import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import {
  lazy1261dae0bgscp as lazy,
  lazy2hsh8ze7j6ikd as lazy_0,
} from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  $serializer_getInstance3n2rtjb4no11s as $serializer_getInstance,
  $serializer_getInstance1m1pty9fgkr0g as $serializer_getInstance_0,
  $serializer_getInstancegem3nsjl63vn as $serializer_getInstance_1,
  $serializer_getInstance3qhgvjcaya2da as $serializer_getInstance_2,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd as _MonetaryValue___init__impl__jsc11x,
  $serializer_getInstance3fydoi3p4w54x as $serializer_getInstance_3,
  $serializer_getInstancet3nsskmepj66 as $serializer_getInstance_4,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  $serializer_getInstance1wv5hjws0bfh6 as $serializer_getInstance_5,
  $serializer_getInstance5xj5u9f3kifs as $serializer_getInstance_6,
  $serializer_getInstance24oainjoildlv as $serializer_getInstance_7,
  get_withdrawn1jcms7jq46kqk as get_withdrawn,
  ItemChangeInterface3dt2mjp367emm as ItemChangeInterface,
  ChangeRequestItem25pmay5za3qvv as ChangeRequestItem,
  $serializer_getInstancelpjkd3aykg3n as $serializer_getInstance_8,
  DrawTableItemvon7hn1chfhu as DrawTableItem,
  $serializer_getInstancempe4dljrfaa1 as $serializer_getInstance_9,
  $serializer_getInstancephvhog69rda1 as $serializer_getInstance_10,
  Companion_getInstance3c3yiwvq39b64 as Companion_getInstance_0,
  copy$defaultre0p5zwdb0iv as copy$default,
  SpecViewgfdgv6h7w5ti as SpecView,
  ScopeGroupsc04cnao6ys4 as ScopeGroup,
  $serializer_getInstance3ili9vinccewy as $serializer_getInstance_11,
  $serializer_getInstance36u72gmfjreba as $serializer_getInstance_12,
} from './supportModels.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  Multilineo47h3baoeckd as Multiline,
  Denormalizedb7mfi9hagcb1 as Denormalized,
  Index19x9ylte4qic1 as Index,
  References1cc2ge45k8vol as References,
  MultipleReferences1olws9tt2t5e6 as MultipleReferences,
  Unique2l35ftvvs34wx as Unique,
  AdminViewOnly2m1t9bs9xa6rn as AdminViewOnly,
  IndexSet1wbu7in7fosv3 as IndexSet,
  UniqueSet327q26ziuapen as UniqueSet,
  Description2bxny7ww0bbw3 as Description,
  AdminTableColumns2kd3zhffh08h8 as AdminTableColumns,
} from '../../../lightning-server-shared/com/lightningkite/lightningdb/Annotations.mjs';
import {
  Companion_instance1i4n4o7mef2za as Companion_instance_0,
  System_instance3dr57gee6r420 as System_instance,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  FloatSerializer_getInstance2fspe61zbqree as FloatSerializer_getInstance,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  throwArrayMissingFieldExceptionbk1mj238w44a as throwArrayMissingFieldException,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  Companion_getInstance68aky2bnsasg as Companion_getInstance_1,
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance_2,
  Companion_getInstance24kv293bymss5 as Companion_getInstance_3,
  Companion_getInstancex9879gcn3f42 as Companion_getInstance_4,
  PreferredTitle_Contractor_getInstance1vu9hnmofbdy6 as PreferredTitle_Contractor_getInstance,
  ContractorStatus_Registering_getInstance9wzvdghru4x2 as ContractorStatus_Registering_getInstance,
  Companion_getInstance3oueq6ubvzdqu as Companion_getInstance_5,
  IncidentState_Filed_getInstanceg9puzn4wq1pv as IncidentState_Filed_getInstance,
  ChangeType_Modify_getInstance2320ide7eqjcd as ChangeType_Modify_getInstance,
  ChangeType_Remove_getInstance2qh3m0yr0lh4w as ChangeType_Remove_getInstance,
  Companion_getInstance3bhagfzu8ngcb as Companion_getInstance_6,
  ChangeType_New_getInstance3fouji82nef8w as ChangeType_New_getInstance,
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance_7,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  Companion_getInstance3jlmhbtm50921 as Companion_getInstance_8,
  Companion_getInstance3soflne3we53q as Companion_getInstance_9,
  Companion_getInstance8z0585d1ojl8 as Companion_getInstance_10,
} from './enums.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { MonetaryRange1i296pttqy20q as MonetaryRange } from './annotations.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { ReadByDataModel1nk4gz5mxza5s as ReadByDataModel } from './readReceipts.mjs';
import {
  Reorderable3ea4zkahqiq6k as Reorderable,
  compareTobo60qch4pcdz as compareTo,
} from './Reorderable.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  isBlank1dvkhjjvox3p0 as isBlank,
  padStart36w1507hs626a as padStart,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { plus18eogev54fmsa as plus } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l as ServerFile__hashCode_impl_qj0ii5,
  ServerFile__toString_impl_4rulpa1zv5xkbnowbd9 as ServerFile__toString_impl_4rulpa,
} from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  Companion_getInstance240fx64zw6f6d as Companion_getInstance_11,
  ClientConcern_Other_getInstancezoo09lwnn20e as ClientConcern_Other_getInstance,
} from './incidentResponse/IncidentResponseType.mjs';
import {
  $serializer_getInstance11as8uk2vr4gi as $serializer_getInstance_13,
  parseResponsezbt0whvcgfcx as parseResponse,
} from './incidentResponse/serialization.mjs';
import {
  $serializer_getInstance31wv99ymyppht as $serializer_getInstance_14,
  parseResponse1q1zzu6g2wzqi as parseResponse_0,
} from './completionResponse/serialization.mjs';
import { coerceAtLeast3jlgfquiyquc9 as coerceAtLeast } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { Companion_getInstance2n82k3fb4nex0 as Companion_getInstance_12 } from './paymentModels.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationSerializer_getInstanceo50ej00g6vz5 as DurationSerializer_getInstance } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import {
  EmailAddressSerializer_getInstanceu3ltgmcd8ai as EmailAddressSerializer_getInstance,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  PhoneNumberSerializer_getInstance2oi38jtxahgwm as PhoneNumberSerializer_getInstance,
  PhoneNumber2x98iurnwvnj9 as PhoneNumber,
  EmailAddress__toString_impl_artjh32mgb4pan49acs as EmailAddress__toString_impl_artjh3,
  PhoneNumber__toString_impl_7i2x3q276u0h00tg72g as PhoneNumber__toString_impl_7i2x3q,
  EmailAddress__hashCode_impl_wizg9y17d6wnfa2ztdr as EmailAddress__hashCode_impl_wizg9y,
  PhoneNumber__hashCode_impl_t98twl1f2h2fisb0rc2 as PhoneNumber__hashCode_impl_t98twl,
} from '../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { compareTo3ankvs086tmwq as compareTo_0 } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var Visibility_Contractor_instance;
var Visibility_Client_instance;
var Visibility_Both_instance;
var Visibility_entriesInitialized;
function Visibility_initEntries() {
  if (Visibility_entriesInitialized)
    return Unit_instance;
  Visibility_entriesInitialized = true;
  Visibility_Contractor_instance = Visibility().c91('Contractor', 0);
  Visibility_Client_instance = Visibility().c91('Client', 1);
  Visibility_Both_instance = Visibility().c91('Both', 2);
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.e8q_1.f2();
}
function CrowPayLegalDocument$Type$Companion$_anonymous__ut8r8() {
  return createSimpleEnumSerializer('com.crowpay.CrowPayLegalDocument.Type', values());
}
var Type_ClientTermsAndConditions_instance;
var Type_ContractorTermsAndConditions_instance;
var Type_PrivacyPolicy_instance;
var VisibilityClass;
function Visibility() {
  if (VisibilityClass === VOID) {
    class $ extends Enum() {
      static c91(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Visibility');
    VisibilityClass = $;
  }
  return VisibilityClass;
}
function values() {
  return [Type_ClientTermsAndConditions_getInstance(), Type_ContractorTermsAndConditions_getInstance(), Type_PrivacyPolicy_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.e8q_1 = lazy(tmp_0, CrowPayLegalDocument$Type$Companion$_anonymous__ut8r8);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_13() {
  Type_initEntries();
  if (Companion_instance_1 === VOID)
    new (Companion())();
  return Companion_instance_1;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_ClientTermsAndConditions_instance = Type().h91('ClientTermsAndConditions', 0, 'Client Terms And Conditions', Visibility_Client_getInstance());
  Type_ContractorTermsAndConditions_instance = Type().h91('ContractorTermsAndConditions', 1, 'Contractor Terms And Conditions', Visibility_Contractor_getInstance());
  Type_PrivacyPolicy_instance = Type().h91('PrivacyPolicy', 2, 'Privacy Policy');
  Companion_getInstance_13();
}
function Visibility_Contractor_getInstance() {
  Visibility_initEntries();
  return Visibility_Contractor_instance;
}
function Visibility_Client_getInstance() {
  Visibility_initEntries();
  return Visibility_Client_instance;
}
function Visibility_Both_getInstance() {
  Visibility_initEntries();
  return Visibility_Both_instance;
}
var $ENTRIES;
function CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_0() {
  return Companion_getInstance_13().k2a();
}
function CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      static h91(name, ordinal, displayName, visibility) {
        visibility = visibility === VOID ? Visibility_Both_getInstance() : visibility;
        var $this = this.c4(name, ordinal);
        $this.f91_1 = displayName;
        $this.g91_1 = visibility;
        return $this;
      }
      e90() {
        return this.f91_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'Type', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_13});
    TypeClass = $;
  }
  return TypeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.r5u_1 = [tmp_1, tmp_3, lazy(tmp_4, CrowPayLegalDocument$Companion$$childSerializers$_anonymous__f5bx6h_1), null, null];
      }
      k2a() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_2;
function Companion_getInstance_14() {
  if (Companion_instance_2 === VOID)
    new (Companion_0())();
  return Companion_instance_2;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.CrowPayLegalDocument', this, 5);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('type', true);
        tmp0_serialDesc.a1b('establishedAt', true);
        tmp0_serialDesc.a1b('contents', false);
        tmp0_serialDesc.b1b(new (Multiline())());
        tmp0_serialDesc.a1b('version', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.i91_1 = tmp0_serialDesc;
      }
      j91(encoder, value) {
        var tmp0_desc = this.i91_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_14().r5u_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.y5u_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.y5u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.z5u_1.equals(Type_ClientTermsAndConditions_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.z5u_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.a5v_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.a5v_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.b5v_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.c5v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.c5v_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j91(encoder, value instanceof CrowPayLegalDocument() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i91_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_14().r5u_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return CrowPayLegalDocument().k91(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.i91_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_14().r5u_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_15() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Type_ClientTermsAndConditions_getInstance() {
  Type_initEntries();
  return Type_ClientTermsAndConditions_instance;
}
function Type_ContractorTermsAndConditions_getInstance() {
  Type_initEntries();
  return Type_ContractorTermsAndConditions_instance;
}
function Type_PrivacyPolicy_getInstance() {
  Type_initEntries();
  return Type_PrivacyPolicy_instance;
}
var CrowPayLegalDocumentClass;
function CrowPayLegalDocument() {
  if (CrowPayLegalDocumentClass === VOID) {
    class $ {
      constructor(_id, type, establishedAt, contents, version) {
        Companion_getInstance_14();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        type = type === VOID ? Type_ClientTermsAndConditions_getInstance() : type;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        version = version === VOID ? null : version;
        this.y5u_1 = _id;
        this.z5u_1 = type;
        this.a5v_1 = establishedAt;
        this.b5v_1 = contents;
        this.c5v_1 = version;
      }
      f40() {
        return this.y5u_1;
      }
      l91(_id, type, establishedAt, contents, version) {
        return new (CrowPayLegalDocument())(_id, type, establishedAt, contents, version);
      }
      e5v(_id, type, establishedAt, contents, version, $super) {
        _id = _id === VOID ? this.y5u_1 : _id;
        type = type === VOID ? this.z5u_1 : type;
        establishedAt = establishedAt === VOID ? this.a5v_1 : establishedAt;
        contents = contents === VOID ? this.b5v_1 : contents;
        version = version === VOID ? this.c5v_1 : version;
        return $super === VOID ? this.l91(_id, type, establishedAt, contents, version) : $super.l91.call(this, _id, type, establishedAt, contents, version);
      }
      toString() {
        return 'CrowPayLegalDocument(_id=' + this.y5u_1.toString() + ', type=' + toString(this.z5u_1) + ', establishedAt=' + this.a5v_1.toString() + ', contents=' + this.b5v_1 + ', version=' + this.c5v_1 + ')';
      }
      hashCode() {
        var result = this.y5u_1.hashCode();
        result = imul(result, 31) + this.z5u_1.hashCode() | 0;
        result = imul(result, 31) + this.a5v_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.b5v_1) | 0;
        result = imul(result, 31) + (this.c5v_1 == null ? 0 : getStringHashCode(this.c5v_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CrowPayLegalDocument()))
          return false;
        if (!this.y5u_1.equals(other.y5u_1))
          return false;
        if (!this.z5u_1.equals(other.z5u_1))
          return false;
        if (!this.a5v_1.equals(other.a5v_1))
          return false;
        if (!(this.b5v_1 === other.b5v_1))
          return false;
        if (!(this.c5v_1 == other.c5v_1))
          return false;
        return true;
      }
      static k91(seen0, _id, type, establishedAt, contents, version, serializationConstructorMarker) {
        Companion_getInstance_14();
        if (!(8 === (8 & seen0))) {
          throwMissingFieldException(seen0, 8, $serializer_getInstance_15().i91_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.y5u_1 = Companion_getInstance().k2p();
        else
          $this.y5u_1 = _id;
        if (0 === (seen0 & 2))
          $this.z5u_1 = Type_ClientTermsAndConditions_getInstance();
        else
          $this.z5u_1 = type;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.a5v_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.a5v_1 = establishedAt;
        $this.b5v_1 = contents;
        if (0 === (seen0 & 16))
          $this.c5v_1 = null;
        else
          $this.c5v_1 = version;
        return $this;
      }
    }
    initMetadataForClass($, 'CrowPayLegalDocument', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_15});
    CrowPayLegalDocumentClass = $;
  }
  return CrowPayLegalDocumentClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.m91_1 = function_0;
      }
      wi(a, b) {
        return this.m91_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.m91_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_5() {
  return Companion_getInstance_1().k2a();
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_6() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_7() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_8() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_9() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_10() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function LineItem$Companion$$childSerializers$_anonymous__30lg5f_11() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItem$Companion$comparator$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.m6k_1;
  var tmp$ret$1 = b.m6k_1;
  return compareValues(tmp, tmp$ret$1);
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LineItem$Companion$$childSerializers$_anonymous__30lg5f);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LineItem$Companion$$childSerializers$_anonymous__30lg5f_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LineItem$Companion$$childSerializers$_anonymous__30lg5f_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, LineItem$Companion$$childSerializers$_anonymous__30lg5f_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, LineItem$Companion$$childSerializers$_anonymous__30lg5f_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, LineItem$Companion$$childSerializers$_anonymous__30lg5f_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, LineItem$Companion$$childSerializers$_anonymous__30lg5f_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, LineItem$Companion$$childSerializers$_anonymous__30lg5f_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, LineItem$Companion$$childSerializers$_anonymous__30lg5f_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_19 = lazy(tmp_18, LineItem$Companion$$childSerializers$_anonymous__30lg5f_8);
        var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_21 = lazy(tmp_20, LineItem$Companion$$childSerializers$_anonymous__30lg5f_9);
        var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_23 = lazy(tmp_22, LineItem$Companion$$childSerializers$_anonymous__30lg5f_10);
        var tmp_24 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.v6j_1 = [tmp_1, tmp_3, null, tmp_5, tmp_7, null, null, null, null, tmp_9, tmp_11, tmp_13, null, null, null, null, null, tmp_15, null, tmp_17, tmp_19, tmp_21, null, tmp_23, lazy(tmp_24, LineItem$Companion$$childSerializers$_anonymous__30lg5f_11)];
        var tmp_25 = this;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_26 = LineItem$Companion$comparator$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp_26);
        var tmp_27 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = a.j6k_1;
            var tmp$ret$5 = b.j6k_1;
            tmp = compareValues(tmp_0, tmp$ret$5);
          }
          return tmp;
        };
        tmp_25.w6j_1 = new (sam$kotlin_Comparator$0())(tmp_27);
        this.x6j_1 = Regex().qh(' \\(\\d+(?:\\.\\d+)? [a-zA-Z]+(?: [a-zA-Z]+)*\\)$');
      }
      k2a() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_3;
function Companion_getInstance_15() {
  if (Companion_instance_3 === VOID)
    new (Companion_1())();
  return Companion_instance_3;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LineItem', this, 25);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('changeRequest', true);
        tmp0_serialDesc.a1b('scopeView', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.a1b('scopeSet', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('name', true);
        tmp0_serialDesc.a1b('description', true);
        tmp0_serialDesc.a1b('originalPrice', true);
        tmp0_serialDesc.b1b(new (MonetaryRange())(0n, 2147483647n));
        tmp0_serialDesc.a1b('order', true);
        tmp0_serialDesc.a1b('files', true);
        tmp0_serialDesc.a1b('started', true);
        tmp0_serialDesc.a1b('state', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('acceptedPriceChange', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('allowRaiseIssue', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('allowFileDispute', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('allowLockProject', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('issue', true);
        tmp0_serialDesc.a1b('credits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('complete', true);
        tmp0_serialDesc.a1b('ledgerItems', true);
        tmp0_serialDesc.b1b(new (MultipleReferences())(getKClass(ProjectLedgerItem())));
        tmp0_serialDesc.a1b('cancelled', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('contractorDeposits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('lastModifiedBy', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (References())(getKClass(User())));
        this.n91_1 = tmp0_serialDesc;
      }
      o91(encoder, value) {
        var tmp0_desc = this.n91_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_15().v6j_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.e6k_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.e6k_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.f6k_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.g6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_1(), value.g6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.h6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.h6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.i6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.i6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.j6k_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.j6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.k6k_1 === '')) {
          tmp1_output.a15(tmp0_desc, 6, value.k6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.l6k_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance_2(), new (MonetaryValue())(value.l6k_1));
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.m6k_1, 0.5)) {
          tmp1_output.y14(tmp0_desc, 8, value.m6k_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.n6k_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.n6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.o6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.o6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !value.p6k_1.equals(LineItemState_NotStarted_getInstance())) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.p6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.q6k_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 12, $serializer_getInstance_2(), new (MonetaryValue())(value.q6k_1));
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.r6k_1 === false)) {
          tmp1_output.s14(tmp0_desc, 13, value.r6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.s6k_1 === false)) {
          tmp1_output.s14(tmp0_desc, 14, value.s6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.t6k_1 === false)) {
          tmp1_output.s14(tmp0_desc, 15, value.t6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 16) ? true : !(value.u6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 16, $serializer_getInstance_3(), value.u6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !equals(value.v6k_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 17, tmp2_cached[17].f2(), value.v6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 18) ? true : !(value.w6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 18, $serializer_getInstance_4(), value.w6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 19) ? true : !equals(value.x6k_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 19, tmp2_cached[19].f2(), value.x6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 20) ? true : !(value.y6k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 20, tmp2_cached[20].f2(), value.y6k_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 21)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance_0).b1m();
          tmp_0 = !value.z6k_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 21, tmp2_cached[21].f2(), value.z6k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 22) ? true : !(value.a6l_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 22, $serializer_getInstance_2(), new (MonetaryValue())(value.a6l_1));
        }
        if (tmp1_output.h15(tmp0_desc, 23) ? true : !equals(value.b6l_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 23, tmp2_cached[23].f2(), value.b6l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 24) ? true : !(value.c6l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 24, tmp2_cached[24].f2(), value.c6l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o91(encoder, value instanceof LineItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n91_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = 0.0;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = false;
        var tmp18_local14 = false;
        var tmp19_local15 = false;
        var tmp20_local16 = null;
        var tmp21_local17 = null;
        var tmp22_local18 = null;
        var tmp23_local19 = null;
        var tmp24_local20 = null;
        var tmp25_local21 = null;
        var tmp26_local22 = null;
        var tmp27_local23 = null;
        var tmp28_local24 = null;
        var tmp31_input = decoder.l13(tmp0_desc);
        var tmp32_cached = Companion_getInstance_15().v6j_1;
        if (tmp31_input.a14()) {
          tmp4_local0 = tmp31_input.x13(tmp0_desc, 0, tmp32_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp31_input.x13(tmp0_desc, 1, tmp32_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp31_input.z13(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp31_input.z13(tmp0_desc, 3, tmp32_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp31_input.z13(tmp0_desc, 4, tmp32_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp31_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp31_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp11_local7;
          var tmp_1 = tmp31_input.x13(tmp0_desc, 7, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp11_local7 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp31_input.t13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp31_input.x13(tmp0_desc, 9, tmp32_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp31_input.z13(tmp0_desc, 10, tmp32_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp31_input.x13(tmp0_desc, 11, tmp32_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp16_local12;
          var tmp_4 = tmp31_input.x13(tmp0_desc, 12, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp16_local12 = tmp_4 == null ? null : tmp_4.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp31_input.n13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp31_input.n13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp31_input.n13(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp31_input.z13(tmp0_desc, 16, $serializer_getInstance_3(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp31_input.x13(tmp0_desc, 17, tmp32_cached[17].f2(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp31_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp23_local19 = tmp31_input.x13(tmp0_desc, 19, tmp32_cached[19].f2(), tmp23_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          tmp24_local20 = tmp31_input.z13(tmp0_desc, 20, tmp32_cached[20].f2(), tmp24_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          tmp25_local21 = tmp31_input.x13(tmp0_desc, 21, tmp32_cached[21].f2(), tmp25_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp26_local22;
          var tmp_7 = tmp31_input.x13(tmp0_desc, 22, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp26_local22 = tmp_7 == null ? null : tmp_7.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          tmp27_local23 = tmp31_input.x13(tmp0_desc, 23, tmp32_cached[23].f2(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          tmp28_local24 = tmp31_input.z13(tmp0_desc, 24, tmp32_cached[24].f2(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp31_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp31_input.x13(tmp0_desc, 0, tmp32_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp31_input.x13(tmp0_desc, 1, tmp32_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp31_input.z13(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp31_input.z13(tmp0_desc, 3, tmp32_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp31_input.z13(tmp0_desc, 4, tmp32_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp31_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp31_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp11_local7;
                var tmp_10 = tmp31_input.x13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp11_local7 = tmp_10 == null ? null : tmp_10.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp31_input.t13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp31_input.x13(tmp0_desc, 9, tmp32_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp31_input.z13(tmp0_desc, 10, tmp32_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp31_input.x13(tmp0_desc, 11, tmp32_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp16_local12;
                var tmp_13 = tmp31_input.x13(tmp0_desc, 12, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
                tmp16_local12 = tmp_13 == null ? null : tmp_13.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp31_input.n13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp31_input.n13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp31_input.n13(tmp0_desc, 15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp31_input.z13(tmp0_desc, 16, $serializer_getInstance_3(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp31_input.x13(tmp0_desc, 17, tmp32_cached[17].f2(), tmp21_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp31_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp22_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp23_local19 = tmp31_input.x13(tmp0_desc, 19, tmp32_cached[19].f2(), tmp23_local19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              case 20:
                tmp24_local20 = tmp31_input.z13(tmp0_desc, 20, tmp32_cached[20].f2(), tmp24_local20);
                tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
                break;
              case 21:
                tmp25_local21 = tmp31_input.x13(tmp0_desc, 21, tmp32_cached[21].f2(), tmp25_local21);
                tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
                break;
              case 22:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp26_local22;
                var tmp_16 = tmp31_input.x13(tmp0_desc, 22, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
                tmp26_local22 = tmp_16 == null ? null : tmp_16.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
                break;
              case 23:
                tmp27_local23 = tmp31_input.x13(tmp0_desc, 23, tmp32_cached[23].f2(), tmp27_local23);
                tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
                break;
              case 24:
                tmp28_local24 = tmp31_input.z13(tmp0_desc, 24, tmp32_cached[24].f2(), tmp28_local24);
                tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp31_input.m13(tmp0_desc);
        return LineItem().p91(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, null);
      }
      az() {
        return this.n91_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_15().v6j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable($serializer_getInstance_1()), get_nullable(tmp0_cached[3].f2()), get_nullable(tmp0_cached[4].f2()), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_2(), DoubleSerializer_getInstance(), tmp0_cached[9].f2(), get_nullable(tmp0_cached[10].f2()), tmp0_cached[11].f2(), $serializer_getInstance_2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_3()), tmp0_cached[17].f2(), get_nullable($serializer_getInstance_4()), tmp0_cached[19].f2(), get_nullable(tmp0_cached[20].f2()), tmp0_cached[21].f2(), $serializer_getInstance_2(), tmp0_cached[23].f2(), get_nullable(tmp0_cached[24].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_16() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function LineItem$_get_remainingFunds_$ref_m55iyn() {
  return (p0) => new (MonetaryValue())(p0.q91());
}
var LineItemClass;
function LineItem() {
  if (LineItemClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy) {
        Companion_getInstance_15();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        changeRequest = changeRequest === VOID ? null : changeRequest;
        scopeView = scopeView === VOID ? null : scopeView;
        scopeSet = scopeSet === VOID ? null : scopeSet;
        name = name === VOID ? '' : name;
        description = description === VOID ? '' : description;
        originalPrice = originalPrice === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : originalPrice;
        order = order === VOID ? 0.5 : order;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        started = started === VOID ? null : started;
        state = state === VOID ? LineItemState_NotStarted_getInstance() : state;
        acceptedPriceChange = acceptedPriceChange === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : acceptedPriceChange;
        allowRaiseIssue = allowRaiseIssue === VOID ? false : allowRaiseIssue;
        allowFileDispute = allowFileDispute === VOID ? false : allowFileDispute;
        allowLockProject = allowLockProject === VOID ? false : allowLockProject;
        issue = issue === VOID ? null : issue;
        credits = credits === VOID ? emptyList() : credits;
        complete = complete === VOID ? null : complete;
        ledgerItems = ledgerItems === VOID ? emptySet() : ledgerItems;
        cancelled = cancelled === VOID ? null : cancelled;
        var tmp_0;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance_0).b1m();
        } else {
          tmp_0 = created;
        }
        created = tmp_0;
        contractorDeposits = contractorDeposits === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : contractorDeposits;
        readBy = readBy === VOID ? emptySet() : readBy;
        lastModifiedBy = lastModifiedBy === VOID ? null : lastModifiedBy;
        this.e6k_1 = _id;
        this.f6k_1 = project;
        this.g6k_1 = changeRequest;
        this.h6k_1 = scopeView;
        this.i6k_1 = scopeSet;
        this.j6k_1 = name;
        this.k6k_1 = description;
        this.l6k_1 = originalPrice;
        this.m6k_1 = order;
        this.n6k_1 = files;
        this.o6k_1 = started;
        this.p6k_1 = state;
        this.q6k_1 = acceptedPriceChange;
        this.r6k_1 = allowRaiseIssue;
        this.s6k_1 = allowFileDispute;
        this.t6k_1 = allowLockProject;
        this.u6k_1 = issue;
        this.v6k_1 = credits;
        this.w6k_1 = complete;
        this.x6k_1 = ledgerItems;
        this.y6k_1 = cancelled;
        this.z6k_1 = created;
        this.a6l_1 = contractorDeposits;
        this.b6l_1 = readBy;
        this.c6l_1 = lastModifiedBy;
        var tmp_1 = this;
        var tmp_2 = MonetaryValue__plus_impl_c1ylt(this.l6k_1, this.q6k_1);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = this.v6k_1;
        var sum = Companion_instance.r91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_3 = sum;
          var tmp$ret$2 = element.y5q_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$2);
        }
        var tmp$ret$3 = sum;
        tmp_1.d6l_1 = MonetaryValue__minus_impl_jw9qyp(tmp_2, tmp$ret$3);
        var tmp_4 = this;
        tmp_4.e6l_1 = lazy_0(() => new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(this.d6l_1, this.a6l_1)));
      }
      f40() {
        return this.e6k_1;
      }
      i20() {
        return this.j6k_1;
      }
      s91() {
        return this.k6k_1;
      }
      i8v() {
        return this.m6k_1;
      }
      t91() {
        return this.n6k_1;
      }
      u91() {
        return this.v6k_1;
      }
      v91() {
        return this.b6l_1;
      }
      w91() {
        var tmp0 = this.j6k_1;
        // Inline function 'kotlin.text.replace' call
        return Companion_getInstance_15().x6j_1.wh(tmp0, '');
      }
      j8v(order) {
        return this.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, order);
      }
      x91() {
        return this.d6l_1;
      }
      q91() {
        var tmp0 = this.e6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('remainingFunds', 1, tmp, LineItem$_get_remainingFunds_$ref_m55iyn(), null);
        return tmp0.f2().y5r_1;
      }
      y91() {
        return this.w6k_1 == null && this.y6k_1 == null && MonetaryValue__compareTo_impl_w7ul1r(this.q91(), Companion_instance.m62(0)) > 0;
      }
      z91(other) {
        return Companion_getInstance_15().w6j_1.compare(this, other);
      }
      d(other) {
        return this.z91(other instanceof LineItem() ? other : THROW_CCE());
      }
      k8v(other) {
        return this.z91(other instanceof LineItem() ? other : THROW_CCE());
      }
      a92() {
        return !(this.h6k_1 == null);
      }
      b92(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy) {
        return new (LineItem())(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy);
      }
      g6l(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy, $super) {
        _id = _id === VOID ? this.e6k_1 : _id;
        project = project === VOID ? this.f6k_1 : project;
        changeRequest = changeRequest === VOID ? this.g6k_1 : changeRequest;
        scopeView = scopeView === VOID ? this.h6k_1 : scopeView;
        scopeSet = scopeSet === VOID ? this.i6k_1 : scopeSet;
        name = name === VOID ? this.j6k_1 : name;
        description = description === VOID ? this.k6k_1 : description;
        originalPrice = originalPrice === VOID ? this.l6k_1 : originalPrice;
        order = order === VOID ? this.m6k_1 : order;
        files = files === VOID ? this.n6k_1 : files;
        started = started === VOID ? this.o6k_1 : started;
        state = state === VOID ? this.p6k_1 : state;
        acceptedPriceChange = acceptedPriceChange === VOID ? this.q6k_1 : acceptedPriceChange;
        allowRaiseIssue = allowRaiseIssue === VOID ? this.r6k_1 : allowRaiseIssue;
        allowFileDispute = allowFileDispute === VOID ? this.s6k_1 : allowFileDispute;
        allowLockProject = allowLockProject === VOID ? this.t6k_1 : allowLockProject;
        issue = issue === VOID ? this.u6k_1 : issue;
        credits = credits === VOID ? this.v6k_1 : credits;
        complete = complete === VOID ? this.w6k_1 : complete;
        ledgerItems = ledgerItems === VOID ? this.x6k_1 : ledgerItems;
        cancelled = cancelled === VOID ? this.y6k_1 : cancelled;
        created = created === VOID ? this.z6k_1 : created;
        contractorDeposits = contractorDeposits === VOID ? this.a6l_1 : contractorDeposits;
        readBy = readBy === VOID ? this.b6l_1 : readBy;
        lastModifiedBy = lastModifiedBy === VOID ? this.c6l_1 : lastModifiedBy;
        return $super === VOID ? this.b92(_id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy) : $super.b92.call(this, _id, project, changeRequest, scopeView, scopeSet, name, description, new (MonetaryValue())(originalPrice), order, files, started, state, new (MonetaryValue())(acceptedPriceChange), allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, new (MonetaryValue())(contractorDeposits), readBy, lastModifiedBy);
      }
      toString() {
        return 'LineItem(_id=' + this.e6k_1.toString() + ', project=' + this.f6k_1.toString() + ', changeRequest=' + toString_0(this.g6k_1) + ', scopeView=' + toString_0(this.h6k_1) + ', scopeSet=' + toString_0(this.i6k_1) + ', name=' + this.j6k_1 + ', description=' + this.k6k_1 + ', originalPrice=' + MonetaryValue__toString_impl_xslc77(this.l6k_1) + ', order=' + this.m6k_1 + ', files=' + toString(this.n6k_1) + ', started=' + toString_0(this.o6k_1) + ', state=' + this.p6k_1.toString() + ', acceptedPriceChange=' + MonetaryValue__toString_impl_xslc77(this.q6k_1) + ', allowRaiseIssue=' + this.r6k_1 + ', allowFileDispute=' + this.s6k_1 + ', allowLockProject=' + this.t6k_1 + ', issue=' + toString_0(this.u6k_1) + ', credits=' + toString(this.v6k_1) + ', complete=' + toString_0(this.w6k_1) + ', ledgerItems=' + toString(this.x6k_1) + ', cancelled=' + toString_0(this.y6k_1) + ', created=' + this.z6k_1.toString() + ', contractorDeposits=' + MonetaryValue__toString_impl_xslc77(this.a6l_1) + ', readBy=' + toString(this.b6l_1) + ', lastModifiedBy=' + toString_0(this.c6l_1) + ')';
      }
      hashCode() {
        var result = this.e6k_1.hashCode();
        result = imul(result, 31) + this.f6k_1.hashCode() | 0;
        result = imul(result, 31) + (this.g6k_1 == null ? 0 : this.g6k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.h6k_1 == null ? 0 : this.h6k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.i6k_1 == null ? 0 : this.i6k_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.j6k_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k6k_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.l6k_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.m6k_1) | 0;
        result = imul(result, 31) + hashCode(this.n6k_1) | 0;
        result = imul(result, 31) + (this.o6k_1 == null ? 0 : this.o6k_1.hashCode()) | 0;
        result = imul(result, 31) + this.p6k_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.q6k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.r6k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.s6k_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t6k_1) | 0;
        result = imul(result, 31) + (this.u6k_1 == null ? 0 : this.u6k_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.v6k_1) | 0;
        result = imul(result, 31) + (this.w6k_1 == null ? 0 : this.w6k_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.x6k_1) | 0;
        result = imul(result, 31) + (this.y6k_1 == null ? 0 : this.y6k_1.hashCode()) | 0;
        result = imul(result, 31) + this.z6k_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.a6l_1) | 0;
        result = imul(result, 31) + hashCode(this.b6l_1) | 0;
        result = imul(result, 31) + (this.c6l_1 == null ? 0 : this.c6l_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItem()))
          return false;
        if (!this.e6k_1.equals(other.e6k_1))
          return false;
        if (!this.f6k_1.equals(other.f6k_1))
          return false;
        if (!equals(this.g6k_1, other.g6k_1))
          return false;
        if (!equals(this.h6k_1, other.h6k_1))
          return false;
        if (!equals(this.i6k_1, other.i6k_1))
          return false;
        if (!(this.j6k_1 === other.j6k_1))
          return false;
        if (!(this.k6k_1 === other.k6k_1))
          return false;
        if (!(this.l6k_1 === other.l6k_1))
          return false;
        if (!equals(this.m6k_1, other.m6k_1))
          return false;
        if (!equals(this.n6k_1, other.n6k_1))
          return false;
        if (!equals(this.o6k_1, other.o6k_1))
          return false;
        if (!this.p6k_1.equals(other.p6k_1))
          return false;
        if (!(this.q6k_1 === other.q6k_1))
          return false;
        if (!(this.r6k_1 === other.r6k_1))
          return false;
        if (!(this.s6k_1 === other.s6k_1))
          return false;
        if (!(this.t6k_1 === other.t6k_1))
          return false;
        if (!equals(this.u6k_1, other.u6k_1))
          return false;
        if (!equals(this.v6k_1, other.v6k_1))
          return false;
        if (!equals(this.w6k_1, other.w6k_1))
          return false;
        if (!equals(this.x6k_1, other.x6k_1))
          return false;
        if (!equals(this.y6k_1, other.y6k_1))
          return false;
        if (!this.z6k_1.equals(other.z6k_1))
          return false;
        if (!(this.a6l_1 === other.a6l_1))
          return false;
        if (!equals(this.b6l_1, other.b6l_1))
          return false;
        if (!equals(this.c6l_1, other.c6l_1))
          return false;
        return true;
      }
      static p91(seen0, _id, project, changeRequest, scopeView, scopeSet, name, description, originalPrice, order, files, started, state, acceptedPriceChange, allowRaiseIssue, allowFileDispute, allowLockProject, issue, credits, complete, ledgerItems, cancelled, created, contractorDeposits, readBy, lastModifiedBy, serializationConstructorMarker) {
        Companion_getInstance_15();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_16().n91_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.e6k_1 = Companion_getInstance().k2p();
        else
          $this.e6k_1 = _id;
        $this.f6k_1 = project;
        if (0 === (seen0 & 4))
          $this.g6k_1 = null;
        else
          $this.g6k_1 = changeRequest;
        if (0 === (seen0 & 8))
          $this.h6k_1 = null;
        else
          $this.h6k_1 = scopeView;
        if (0 === (seen0 & 16))
          $this.i6k_1 = null;
        else
          $this.i6k_1 = scopeSet;
        if (0 === (seen0 & 32))
          $this.j6k_1 = '';
        else
          $this.j6k_1 = name;
        if (0 === (seen0 & 64))
          $this.k6k_1 = '';
        else
          $this.k6k_1 = description;
        if (0 === (seen0 & 128))
          $this.l6k_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.l6k_1 = originalPrice;
        if (0 === (seen0 & 256))
          $this.m6k_1 = 0.5;
        else
          $this.m6k_1 = order;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.n6k_1 = emptyList();
        } else
          $this.n6k_1 = files;
        if (0 === (seen0 & 1024))
          $this.o6k_1 = null;
        else
          $this.o6k_1 = started;
        if (0 === (seen0 & 2048))
          $this.p6k_1 = LineItemState_NotStarted_getInstance();
        else
          $this.p6k_1 = state;
        if (0 === (seen0 & 4096))
          $this.q6k_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.q6k_1 = acceptedPriceChange;
        if (0 === (seen0 & 8192))
          $this.r6k_1 = false;
        else
          $this.r6k_1 = allowRaiseIssue;
        if (0 === (seen0 & 16384))
          $this.s6k_1 = false;
        else
          $this.s6k_1 = allowFileDispute;
        if (0 === (seen0 & 32768))
          $this.t6k_1 = false;
        else
          $this.t6k_1 = allowLockProject;
        if (0 === (seen0 & 65536))
          $this.u6k_1 = null;
        else
          $this.u6k_1 = issue;
        if (0 === (seen0 & 131072))
          $this.v6k_1 = emptyList();
        else
          $this.v6k_1 = credits;
        if (0 === (seen0 & 262144))
          $this.w6k_1 = null;
        else
          $this.w6k_1 = complete;
        if (0 === (seen0 & 524288))
          $this.x6k_1 = emptySet();
        else
          $this.x6k_1 = ledgerItems;
        if (0 === (seen0 & 1048576))
          $this.y6k_1 = null;
        else
          $this.y6k_1 = cancelled;
        if (0 === (seen0 & 2097152)) {
          var tmp_0 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_0.z6k_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.z6k_1 = created;
        if (0 === (seen0 & 4194304))
          $this.a6l_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.a6l_1 = contractorDeposits;
        if (0 === (seen0 & 8388608))
          $this.b6l_1 = emptySet();
        else
          $this.b6l_1 = readBy;
        if (0 === (seen0 & 16777216))
          $this.c6l_1 = null;
        else
          $this.c6l_1 = lastModifiedBy;
        var tmp_1 = $this;
        var tmp_2 = MonetaryValue__plus_impl_c1ylt($this.l6k_1, $this.q6k_1);
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = $this.v6k_1;
        var sum = Companion_instance.r91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_3 = sum;
          var tmp$ret$2 = element.y5q_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_3, tmp$ret$2);
        }
        var tmp$ret$3 = sum;
        tmp_1.d6l_1 = MonetaryValue__minus_impl_jw9qyp(tmp_2, tmp$ret$3);
        var tmp_4 = $this;
        tmp_4.e6l_1 = lazy_0(() => new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp($this.d6l_1, $this.a6l_1)));
        return $this;
      }
    }
    initMetadataForClass($, 'LineItem', VOID, VOID, [HasId(), LineItemInterface(), ReadByDataModel(), Reorderable()], VOID, VOID, {0: $serializer_getInstance_16});
    LineItemClass = $;
  }
  return LineItemClass;
}
function ApprovedState$Companion$$childSerializers$_anonymous__9fp9dc() {
  return Companion_getInstance_2().k2a();
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s56_1 = [lazy(tmp_0, ApprovedState$Companion$$childSerializers$_anonymous__9fp9dc), null];
      }
      k2a() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_4;
function Companion_getInstance_16() {
  if (Companion_instance_4 === VOID)
    new (Companion_2())();
  return Companion_instance_4;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ApprovedState', this, 2);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('approved', true);
        this.c92_1 = tmp0_serialDesc;
      }
      d92(encoder, value) {
        var tmp0_desc = this.c92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_16().s56_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.z56_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.a57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 1, value.a57_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d92(encoder, value instanceof ApprovedState() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_16().s56_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ApprovedState().e92(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.c92_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_16().s56_1[0].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_17() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var ApprovedStateClass;
function ApprovedState() {
  if (ApprovedStateClass === VOID) {
    class $ {
      constructor(_id, approved) {
        Companion_getInstance_16();
        approved = approved === VOID ? false : approved;
        this.z56_1 = _id;
        this.a57_1 = approved;
      }
      f40() {
        return this.z56_1;
      }
      f92(_id, approved) {
        return new (ApprovedState())(_id, approved);
      }
      c57(_id, approved, $super) {
        _id = _id === VOID ? this.z56_1 : _id;
        approved = approved === VOID ? this.a57_1 : approved;
        return $super === VOID ? this.f92(_id, approved) : $super.f92.call(this, _id, approved);
      }
      toString() {
        return 'ApprovedState(_id=' + this.z56_1.toString() + ', approved=' + this.a57_1 + ')';
      }
      hashCode() {
        var result = this.z56_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.a57_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ApprovedState()))
          return false;
        if (!this.z56_1.equals(other.z56_1))
          return false;
        if (!(this.a57_1 === other.a57_1))
          return false;
        return true;
      }
      static e92(seen0, _id, approved, serializationConstructorMarker) {
        Companion_getInstance_16();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_17().c92_1);
        }
        var $this = createThis(this);
        $this.z56_1 = _id;
        if (0 === (seen0 & 2))
          $this.a57_1 = false;
        else
          $this.a57_1 = approved;
        return $this;
      }
    }
    initMetadataForClass($, 'ApprovedState', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_17});
    ApprovedStateClass = $;
  }
  return ApprovedStateClass;
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_2() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h57_1 = [tmp_1, tmp_3, null, null, null, tmp_5, null, null, null, null, null, null, tmp_7, lazy(tmp_8, ChangeRequest$Companion$$childSerializers$_anonymous__56ms2z_3)];
      }
      k2a() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_5;
function Companion_getInstance_17() {
  if (Companion_instance_5 === VOID)
    new (Companion_3())();
  return Companion_instance_5;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ChangeRequest', this, 14);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('title', true);
        tmp0_serialDesc.a1b('description', false);
        tmp0_serialDesc.a1b('projectDescription', true);
        tmp0_serialDesc.a1b('published', true);
        tmp0_serialDesc.a1b('cardinalChange', true);
        tmp0_serialDesc.a1b('linkItems', true);
        tmp0_serialDesc.a1b('scopeSet', true);
        tmp0_serialDesc.a1b('fullyLinked', true);
        tmp0_serialDesc.a1b('pending', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('number', false);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('readBy', true);
        this.g92_1 = tmp0_serialDesc;
      }
      h92(encoder, value) {
        var tmp0_desc = this.g92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_17().h57_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.o57_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.o57_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.p57_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.q57_1 === '')) {
          tmp1_output.a15(tmp0_desc, 2, value.q57_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.r57_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.s57_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.s57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.t57_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, tmp2_cached[5].f2(), value.t57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.u57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 6, value.u57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.v57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.v57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.w57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 8, value.w57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.x57_1 === false)) {
          tmp1_output.s14(tmp0_desc, 9, value.x57_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.y57_1 === 0)) {
          tmp1_output.v14(tmp0_desc, 10, value.y57_1);
        }
        tmp1_output.a15(tmp0_desc, 11, value.z57_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 12)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.a58_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 12, tmp2_cached[12].f2(), value.a58_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !equals(value.b58_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 13, tmp2_cached[13].f2(), value.b58_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h92(encoder, value instanceof ChangeRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = false;
        var tmp12_local8 = false;
        var tmp13_local9 = false;
        var tmp14_local10 = 0;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_input = decoder.l13(tmp0_desc);
        var tmp19_cached = Companion_getInstance_17().h57_1;
        if (tmp18_input.a14()) {
          tmp4_local0 = tmp18_input.x13(tmp0_desc, 0, tmp19_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp18_input.x13(tmp0_desc, 1, tmp19_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp18_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp18_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp18_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp18_input.z13(tmp0_desc, 5, tmp19_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp18_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp18_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp18_input.n13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp18_input.n13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp18_input.q13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp18_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp18_input.x13(tmp0_desc, 12, tmp19_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp18_input.x13(tmp0_desc, 13, tmp19_cached[13].f2(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp18_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp18_input.x13(tmp0_desc, 0, tmp19_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp18_input.x13(tmp0_desc, 1, tmp19_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp18_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp18_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp18_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp18_input.z13(tmp0_desc, 5, tmp19_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp18_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp18_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp18_input.n13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp18_input.n13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp18_input.q13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp18_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp18_input.x13(tmp0_desc, 12, tmp19_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp18_input.x13(tmp0_desc, 13, tmp19_cached[13].f2(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp18_input.m13(tmp0_desc);
        return ChangeRequest().i92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
      }
      az() {
        return this.g92_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_17().h57_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[5].f2()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[12].f2(), tmp0_cached[13].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_18() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var ChangeRequestClass;
function ChangeRequest() {
  if (ChangeRequestClass === VOID) {
    class $ {
      constructor(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy) {
        Companion_getInstance_17();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        title = title === VOID ? '' : title;
        projectDescription = projectDescription === VOID ? null : projectDescription;
        published = published === VOID ? null : published;
        cardinalChange = cardinalChange === VOID ? false : cardinalChange;
        linkItems = linkItems === VOID ? false : linkItems;
        scopeSet = scopeSet === VOID ? false : scopeSet;
        fullyLinked = fullyLinked === VOID ? false : fullyLinked;
        pending = pending === VOID ? 0 : pending;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.o57_1 = _id;
        this.p57_1 = project;
        this.q57_1 = title;
        this.r57_1 = description;
        this.s57_1 = projectDescription;
        this.t57_1 = published;
        this.u57_1 = cardinalChange;
        this.v57_1 = linkItems;
        this.w57_1 = scopeSet;
        this.x57_1 = fullyLinked;
        this.y57_1 = pending;
        this.z57_1 = number;
        this.a58_1 = created;
        this.b58_1 = readBy;
      }
      f40() {
        return this.o57_1;
      }
      v91() {
        return this.b58_1;
      }
      j92(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy) {
        return new (ChangeRequest())(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy);
      }
      d58(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy, $super) {
        _id = _id === VOID ? this.o57_1 : _id;
        project = project === VOID ? this.p57_1 : project;
        title = title === VOID ? this.q57_1 : title;
        description = description === VOID ? this.r57_1 : description;
        projectDescription = projectDescription === VOID ? this.s57_1 : projectDescription;
        published = published === VOID ? this.t57_1 : published;
        cardinalChange = cardinalChange === VOID ? this.u57_1 : cardinalChange;
        linkItems = linkItems === VOID ? this.v57_1 : linkItems;
        scopeSet = scopeSet === VOID ? this.w57_1 : scopeSet;
        fullyLinked = fullyLinked === VOID ? this.x57_1 : fullyLinked;
        pending = pending === VOID ? this.y57_1 : pending;
        number = number === VOID ? this.z57_1 : number;
        created = created === VOID ? this.a58_1 : created;
        readBy = readBy === VOID ? this.b58_1 : readBy;
        return $super === VOID ? this.j92(_id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy) : $super.j92.call(this, _id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy);
      }
      toString() {
        return 'ChangeRequest(_id=' + this.o57_1.toString() + ', project=' + this.p57_1.toString() + ', title=' + this.q57_1 + ', description=' + this.r57_1 + ', projectDescription=' + this.s57_1 + ', published=' + toString_0(this.t57_1) + ', cardinalChange=' + this.u57_1 + ', linkItems=' + this.v57_1 + ', scopeSet=' + this.w57_1 + ', fullyLinked=' + this.x57_1 + ', pending=' + this.y57_1 + ', number=' + this.z57_1 + ', created=' + this.a58_1.toString() + ', readBy=' + toString(this.b58_1) + ')';
      }
      hashCode() {
        var result = this.o57_1.hashCode();
        result = imul(result, 31) + this.p57_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.q57_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r57_1) | 0;
        result = imul(result, 31) + (this.s57_1 == null ? 0 : getStringHashCode(this.s57_1)) | 0;
        result = imul(result, 31) + (this.t57_1 == null ? 0 : this.t57_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.u57_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.v57_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w57_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.x57_1) | 0;
        result = imul(result, 31) + this.y57_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.z57_1) | 0;
        result = imul(result, 31) + this.a58_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.b58_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequest()))
          return false;
        if (!this.o57_1.equals(other.o57_1))
          return false;
        if (!this.p57_1.equals(other.p57_1))
          return false;
        if (!(this.q57_1 === other.q57_1))
          return false;
        if (!(this.r57_1 === other.r57_1))
          return false;
        if (!(this.s57_1 == other.s57_1))
          return false;
        if (!equals(this.t57_1, other.t57_1))
          return false;
        if (!(this.u57_1 === other.u57_1))
          return false;
        if (!(this.v57_1 === other.v57_1))
          return false;
        if (!(this.w57_1 === other.w57_1))
          return false;
        if (!(this.x57_1 === other.x57_1))
          return false;
        if (!(this.y57_1 === other.y57_1))
          return false;
        if (!(this.z57_1 === other.z57_1))
          return false;
        if (!this.a58_1.equals(other.a58_1))
          return false;
        if (!equals(this.b58_1, other.b58_1))
          return false;
        return true;
      }
      static i92(seen0, _id, project, title, description, projectDescription, published, cardinalChange, linkItems, scopeSet, fullyLinked, pending, number, created, readBy, serializationConstructorMarker) {
        Companion_getInstance_17();
        if (!(2058 === (2058 & seen0))) {
          throwMissingFieldException(seen0, 2058, $serializer_getInstance_18().g92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.o57_1 = Companion_getInstance().k2p();
        else
          $this.o57_1 = _id;
        $this.p57_1 = project;
        if (0 === (seen0 & 4))
          $this.q57_1 = '';
        else
          $this.q57_1 = title;
        $this.r57_1 = description;
        if (0 === (seen0 & 16))
          $this.s57_1 = null;
        else
          $this.s57_1 = projectDescription;
        if (0 === (seen0 & 32))
          $this.t57_1 = null;
        else
          $this.t57_1 = published;
        if (0 === (seen0 & 64))
          $this.u57_1 = false;
        else
          $this.u57_1 = cardinalChange;
        if (0 === (seen0 & 128))
          $this.v57_1 = false;
        else
          $this.v57_1 = linkItems;
        if (0 === (seen0 & 256))
          $this.w57_1 = false;
        else
          $this.w57_1 = scopeSet;
        if (0 === (seen0 & 512))
          $this.x57_1 = false;
        else
          $this.x57_1 = fullyLinked;
        if (0 === (seen0 & 1024))
          $this.y57_1 = 0;
        else
          $this.y57_1 = pending;
        $this.z57_1 = number;
        if (0 === (seen0 & 4096)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.a58_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.a58_1 = created;
        if (0 === (seen0 & 8192))
          $this.b58_1 = emptySet();
        else
          $this.b58_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeRequest', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_18});
    ChangeRequestClass = $;
  }
  return ChangeRequestClass;
}
function Client$Companion$$childSerializers$_anonymous__j6t4kf() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Client$Companion$$childSerializers$_anonymous__j6t4kf_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Client$Companion$$childSerializers$_anonymous__j6t4kf);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u5b_1 = [tmp_1, lazy(tmp_2, Client$Companion$$childSerializers$_anonymous__j6t4kf_0), null, null, null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_6;
function Companion_getInstance_18() {
  if (Companion_instance_6 === VOID)
    new (Companion_4())();
  return Companion_instance_6;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Client', this, 8);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('contractor', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('userFirstName', true);
        tmp0_serialDesc.a1b('userLastName', true);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.a1b('phoneNumber', false);
        tmp0_serialDesc.a1b('address', false);
        this.k92_1 = tmp0_serialDesc;
      }
      l92(encoder, value) {
        var tmp0_desc = this.k92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_18().u5b_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.b5c_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.b5c_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.c5c_1);
        tmp1_output.a15(tmp0_desc, 2, value.d5c_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.e5c_1 === substringBefore(value.d5c_1, _Char___init__impl__6a9atx(32)))) {
          tmp1_output.a15(tmp0_desc, 3, value.e5c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.f5c_1 === substringAfter(value.d5c_1, _Char___init__impl__6a9atx(32)))) {
          tmp1_output.a15(tmp0_desc, 4, value.f5c_1);
        }
        tmp1_output.a15(tmp0_desc, 5, value.g5c_1);
        tmp1_output.a15(tmp0_desc, 6, value.h5c_1);
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance_5(), value.i5c_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l92(encoder, value instanceof Client() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_18().u5b_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, $serializer_getInstance_5(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, $serializer_getInstance_5(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return Client().m92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.k92_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_18().u5b_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_19() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var ClientClass;
function Client() {
  if (ClientClass === VOID) {
    class $ {
      constructor(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address) {
        Companion_getInstance_18();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        userFirstName = userFirstName === VOID ? substringBefore(name, _Char___init__impl__6a9atx(32)) : userFirstName;
        userLastName = userLastName === VOID ? substringAfter(name, _Char___init__impl__6a9atx(32)) : userLastName;
        this.b5c_1 = _id;
        this.c5c_1 = contractor;
        this.d5c_1 = name;
        this.e5c_1 = userFirstName;
        this.f5c_1 = userLastName;
        this.g5c_1 = email;
        this.h5c_1 = phoneNumber;
        this.i5c_1 = address;
      }
      f40() {
        return this.b5c_1;
      }
      i20() {
        return this.d5c_1;
      }
      n92() {
        return this.g5c_1;
      }
      o92() {
        return this.h5c_1;
      }
      p92() {
        return this.e5c_1 + ' ' + this.f5c_1;
      }
      q92() {
        return null;
      }
      r92(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address) {
        return new (Client())(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address);
      }
      k5c(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address, $super) {
        _id = _id === VOID ? this.b5c_1 : _id;
        contractor = contractor === VOID ? this.c5c_1 : contractor;
        name = name === VOID ? this.d5c_1 : name;
        userFirstName = userFirstName === VOID ? this.e5c_1 : userFirstName;
        userLastName = userLastName === VOID ? this.f5c_1 : userLastName;
        email = email === VOID ? this.g5c_1 : email;
        phoneNumber = phoneNumber === VOID ? this.h5c_1 : phoneNumber;
        address = address === VOID ? this.i5c_1 : address;
        return $super === VOID ? this.r92(_id, contractor, name, userFirstName, userLastName, email, phoneNumber, address) : $super.r92.call(this, _id, contractor, name, userFirstName, userLastName, email, phoneNumber, address);
      }
      toString() {
        return 'Client(_id=' + this.b5c_1.toString() + ', contractor=' + this.c5c_1.toString() + ', name=' + this.d5c_1 + ', userFirstName=' + this.e5c_1 + ', userLastName=' + this.f5c_1 + ', email=' + this.g5c_1 + ', phoneNumber=' + this.h5c_1 + ', address=' + this.i5c_1.toString() + ')';
      }
      hashCode() {
        var result = this.b5c_1.hashCode();
        result = imul(result, 31) + this.c5c_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g5c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h5c_1) | 0;
        result = imul(result, 31) + this.i5c_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Client()))
          return false;
        if (!this.b5c_1.equals(other.b5c_1))
          return false;
        if (!this.c5c_1.equals(other.c5c_1))
          return false;
        if (!(this.d5c_1 === other.d5c_1))
          return false;
        if (!(this.e5c_1 === other.e5c_1))
          return false;
        if (!(this.f5c_1 === other.f5c_1))
          return false;
        if (!(this.g5c_1 === other.g5c_1))
          return false;
        if (!(this.h5c_1 === other.h5c_1))
          return false;
        if (!this.i5c_1.equals(other.i5c_1))
          return false;
        return true;
      }
      static m92(seen0, _id, contractor, name, userFirstName, userLastName, email, phoneNumber, address, serializationConstructorMarker) {
        Companion_getInstance_18();
        if (!(230 === (230 & seen0))) {
          throwMissingFieldException(seen0, 230, $serializer_getInstance_19().k92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.b5c_1 = Companion_getInstance().k2p();
        else
          $this.b5c_1 = _id;
        $this.c5c_1 = contractor;
        $this.d5c_1 = name;
        if (0 === (seen0 & 8))
          $this.e5c_1 = substringBefore($this.d5c_1, _Char___init__impl__6a9atx(32));
        else
          $this.e5c_1 = userFirstName;
        if (0 === (seen0 & 16))
          $this.f5c_1 = substringAfter($this.d5c_1, _Char___init__impl__6a9atx(32));
        else
          $this.f5c_1 = userLastName;
        $this.g5c_1 = email;
        $this.h5c_1 = phoneNumber;
        $this.i5c_1 = address;
        return $this;
      }
    }
    initMetadataForClass($, 'Client', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_19});
    ClientClass = $;
  }
  return ClientClass;
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i5d_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, null, null, tmp_11, lazy(tmp_12, CompletionMessageComment$Companion$$childSerializers$_anonymous__hd2l06_5)];
      }
      k2a() {
        return $serializer_getInstance_20();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_7;
function Companion_getInstance_19() {
  if (Companion_instance_7 === VOID)
    new (Companion_5())();
  return Companion_instance_7;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.CompletionMessageComment', this, 10);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('completionMessage', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItemCompletionMessage())));
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lineItem', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('sender', false);
        tmp0_serialDesc.a1b('senderName', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('clientMessage', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('created', true);
        this.s92_1 = tmp0_serialDesc;
      }
      t92(encoder, value) {
        var tmp0_desc = this.s92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_19().i5d_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.n5d_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.n5d_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.o5d_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.p5d_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.q5d_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.r5d_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.s5d_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.s5d_1);
        }
        tmp1_output.s14(tmp0_desc, 6, value.t5d_1);
        tmp1_output.a15(tmp0_desc, 7, value.u5d_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.v5d_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.v5d_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.w5d_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.w5d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t92(encoder, value instanceof CompletionMessageComment() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_19().i5d_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return CompletionMessageComment().u92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.s92_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_19().i5d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), tmp0_cached[4].f2(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[8].f2(), tmp0_cached[9].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_20() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CompletionMessageCommentClass;
function CompletionMessageComment() {
  if (CompletionMessageCommentClass === VOID) {
    class $ {
      constructor(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created) {
        Companion_getInstance_19();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        senderName = senderName === VOID ? '' : senderName;
        readBy = readBy === VOID ? emptySet() : readBy;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.n5d_1 = _id;
        this.o5d_1 = completionMessage;
        this.p5d_1 = project;
        this.q5d_1 = lineItem;
        this.r5d_1 = sender;
        this.s5d_1 = senderName;
        this.t5d_1 = clientMessage;
        this.u5d_1 = message;
        this.v5d_1 = readBy;
        this.w5d_1 = created;
      }
      f40() {
        return this.n5d_1;
      }
      v91() {
        return this.v5d_1;
      }
      v92() {
        return plus(this.v5d_1, this.r5d_1);
      }
      w92(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created) {
        return new (CompletionMessageComment())(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created);
      }
      y5d(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created, $super) {
        _id = _id === VOID ? this.n5d_1 : _id;
        completionMessage = completionMessage === VOID ? this.o5d_1 : completionMessage;
        project = project === VOID ? this.p5d_1 : project;
        lineItem = lineItem === VOID ? this.q5d_1 : lineItem;
        sender = sender === VOID ? this.r5d_1 : sender;
        senderName = senderName === VOID ? this.s5d_1 : senderName;
        clientMessage = clientMessage === VOID ? this.t5d_1 : clientMessage;
        message = message === VOID ? this.u5d_1 : message;
        readBy = readBy === VOID ? this.v5d_1 : readBy;
        created = created === VOID ? this.w5d_1 : created;
        return $super === VOID ? this.w92(_id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created) : $super.w92.call(this, _id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created);
      }
      toString() {
        return 'CompletionMessageComment(_id=' + this.n5d_1.toString() + ', completionMessage=' + this.o5d_1.toString() + ', project=' + this.p5d_1.toString() + ', lineItem=' + this.q5d_1.toString() + ', sender=' + this.r5d_1.toString() + ', senderName=' + this.s5d_1 + ', clientMessage=' + this.t5d_1 + ', message=' + this.u5d_1 + ', readBy=' + toString(this.v5d_1) + ', created=' + this.w5d_1.toString() + ')';
      }
      hashCode() {
        var result = this.n5d_1.hashCode();
        result = imul(result, 31) + this.o5d_1.hashCode() | 0;
        result = imul(result, 31) + this.p5d_1.hashCode() | 0;
        result = imul(result, 31) + this.q5d_1.hashCode() | 0;
        result = imul(result, 31) + this.r5d_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.s5d_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t5d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u5d_1) | 0;
        result = imul(result, 31) + hashCode(this.v5d_1) | 0;
        result = imul(result, 31) + this.w5d_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompletionMessageComment()))
          return false;
        if (!this.n5d_1.equals(other.n5d_1))
          return false;
        if (!this.o5d_1.equals(other.o5d_1))
          return false;
        if (!this.p5d_1.equals(other.p5d_1))
          return false;
        if (!this.q5d_1.equals(other.q5d_1))
          return false;
        if (!this.r5d_1.equals(other.r5d_1))
          return false;
        if (!(this.s5d_1 === other.s5d_1))
          return false;
        if (!(this.t5d_1 === other.t5d_1))
          return false;
        if (!(this.u5d_1 === other.u5d_1))
          return false;
        if (!equals(this.v5d_1, other.v5d_1))
          return false;
        if (!this.w5d_1.equals(other.w5d_1))
          return false;
        return true;
      }
      static u92(seen0, _id, completionMessage, project, lineItem, sender, senderName, clientMessage, message, readBy, created, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(222 === (222 & seen0))) {
          throwMissingFieldException(seen0, 222, $serializer_getInstance_20().s92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.n5d_1 = Companion_getInstance().k2p();
        else
          $this.n5d_1 = _id;
        $this.o5d_1 = completionMessage;
        $this.p5d_1 = project;
        $this.q5d_1 = lineItem;
        $this.r5d_1 = sender;
        if (0 === (seen0 & 32))
          $this.s5d_1 = '';
        else
          $this.s5d_1 = senderName;
        $this.t5d_1 = clientMessage;
        $this.u5d_1 = message;
        if (0 === (seen0 & 256))
          $this.v5d_1 = emptySet();
        else
          $this.v5d_1 = readBy;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.w5d_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.w5d_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'CompletionMessageComment', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_20});
    CompletionMessageCommentClass = $;
  }
  return CompletionMessageCommentClass;
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_0() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_1() {
  return Companion_getInstance_3().k2a();
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_2() {
  return new (LinkedHashSetSerializer())(Companion_getInstance_2().k2a());
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_3() {
  return new (ArrayListSerializer())($serializer_getInstance_59());
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_4() {
  return Companion_getInstance_4().k2a();
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Contractor$Companion$$childSerializers$_anonymous__2zvvwr_6() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Contractor$Companion$$childSerializers$_anonymous__2zvvwr);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o5i_1 = [tmp_1, null, null, null, null, null, null, tmp_3, tmp_5, null, null, null, null, null, null, null, tmp_7, null, null, null, null, null, null, tmp_9, tmp_11, null, tmp_13, lazy(tmp_14, Contractor$Companion$$childSerializers$_anonymous__2zvvwr_6)];
      }
      k2a() {
        return $serializer_getInstance_21();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_8;
function Companion_getInstance_20() {
  if (Companion_instance_8 === VOID)
    new (Companion_6())();
  return Companion_instance_8;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Contractor', this, 28);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('shortId', true);
        tmp0_serialDesc.b1b(new (Unique())());
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('legalName', false);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.a1b('phoneNumber', false);
        tmp0_serialDesc.a1b('address', false);
        tmp0_serialDesc.a1b('image', true);
        tmp0_serialDesc.a1b('preferredTitle', true);
        tmp0_serialDesc.a1b('trade', true);
        tmp0_serialDesc.a1b('entityType', true);
        tmp0_serialDesc.a1b('contactFirstName', false);
        tmp0_serialDesc.a1b('contactLastName', false);
        tmp0_serialDesc.a1b('contactEmail', false);
        tmp0_serialDesc.a1b('contactPhoneNumber', false);
        tmp0_serialDesc.a1b('contactAddress', false);
        tmp0_serialDesc.a1b('operationStates', true);
        tmp0_serialDesc.a1b('annualRevenue', true);
        tmp0_serialDesc.a1b('averageJobSize', true);
        tmp0_serialDesc.a1b('employeeCount', true);
        tmp0_serialDesc.a1b('otherBusinessData', true);
        tmp0_serialDesc.a1b('stateEntityNumber', false);
        tmp0_serialDesc.a1b('ein', false);
        tmp0_serialDesc.a1b('owners', true);
        tmp0_serialDesc.a1b('status', true);
        tmp0_serialDesc.a1b('paymentId', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('readBy', true);
        this.x92_1 = tmp0_serialDesc;
      }
      y92(encoder, value) {
        var tmp0_desc = this.x92_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_20().o5i_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.t5i_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t5i_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.u5i_1 === Companion_instance_47.i5n())) {
          tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_58(), new (ShortId())(value.u5i_1));
        }
        tmp1_output.a15(tmp0_desc, 2, value.v5i_1);
        tmp1_output.a15(tmp0_desc, 3, value.w5i_1);
        tmp1_output.a15(tmp0_desc, 4, value.x5i_1);
        tmp1_output.a15(tmp0_desc, 5, value.y5i_1);
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_5(), value.z5i_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp = true;
        } else {
          var tmp_0 = value.a5j_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[7].f2();
          var tmp_2 = value.a5j_1;
          tmp1_output.d15(tmp0_desc, 7, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !value.b5j_1.equals(PreferredTitle_Contractor_getInstance())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.b5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.c5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.c5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.d5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, StringSerializer_getInstance(), value.d5j_1);
        }
        tmp1_output.a15(tmp0_desc, 11, value.e5j_1);
        tmp1_output.a15(tmp0_desc, 12, value.f5j_1);
        tmp1_output.a15(tmp0_desc, 13, value.g5j_1);
        tmp1_output.a15(tmp0_desc, 14, value.h5j_1);
        tmp1_output.c15(tmp0_desc, 15, $serializer_getInstance_5(), value.i5j_1);
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 16)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp_3 = !equals(value.j5j_1, tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 16, tmp2_cached[16].f2(), value.j5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !(value.k5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 17, IntSerializer_getInstance(), value.k5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 18) ? true : !(value.l5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 18, IntSerializer_getInstance(), value.l5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 19) ? true : !(value.m5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 19, IntSerializer_getInstance(), value.m5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 20) ? true : !(value.n5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 20, StringSerializer_getInstance(), value.n5j_1);
        }
        tmp1_output.a15(tmp0_desc, 21, value.o5j_1);
        tmp1_output.a15(tmp0_desc, 22, value.p5j_1);
        var tmp_4;
        if (tmp1_output.h15(tmp0_desc, 23)) {
          tmp_4 = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$1 = emptyList();
          tmp_4 = !equals(value.q5j_1, tmp$ret$1);
        }
        if (tmp_4) {
          tmp1_output.c15(tmp0_desc, 23, tmp2_cached[23].f2(), value.q5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 24) ? true : !value.r5j_1.equals(ContractorStatus_Registering_getInstance())) {
          tmp1_output.c15(tmp0_desc, 24, tmp2_cached[24].f2(), value.r5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 25) ? true : !(value.s5j_1 == null)) {
          tmp1_output.d15(tmp0_desc, 25, StringSerializer_getInstance(), value.s5j_1);
        }
        var tmp_5;
        if (tmp1_output.h15(tmp0_desc, 26)) {
          tmp_5 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$2 = get_default(Companion_instance_0).b1m();
          tmp_5 = !value.t5j_1.equals(tmp$ret$2);
        }
        if (tmp_5) {
          tmp1_output.c15(tmp0_desc, 26, tmp2_cached[26].f2(), value.t5j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 27) ? true : !equals(value.u5j_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 27, tmp2_cached[27].f2(), value.u5j_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y92(encoder, value instanceof Contractor() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x92_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_local16 = null;
        var tmp21_local17 = null;
        var tmp22_local18 = null;
        var tmp23_local19 = null;
        var tmp24_local20 = null;
        var tmp25_local21 = null;
        var tmp26_local22 = null;
        var tmp27_local23 = null;
        var tmp28_local24 = null;
        var tmp29_local25 = null;
        var tmp30_local26 = null;
        var tmp31_local27 = null;
        var tmp32_input = decoder.l13(tmp0_desc);
        var tmp33_cached = Companion_getInstance_20().o5i_1;
        if (tmp32_input.a14()) {
          tmp4_local0 = tmp32_input.x13(tmp0_desc, 0, tmp33_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance_58();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp32_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (ShortId())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.l5n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp32_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp32_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp32_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp32_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp32_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_2 = tmp33_cached[7].f2();
          var tmp_3 = tmp11_local7;
          var tmp_4 = tmp32_input.z13(tmp0_desc, 7, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp11_local7 = tmp_4 == null ? null : tmp_4.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp32_input.x13(tmp0_desc, 8, tmp33_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp32_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp32_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp32_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp32_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp32_input.v13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp32_input.v13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp32_input.x13(tmp0_desc, 15, $serializer_getInstance_5(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp32_input.x13(tmp0_desc, 16, tmp33_cached[16].f2(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp32_input.z13(tmp0_desc, 17, IntSerializer_getInstance(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp32_input.z13(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp23_local19 = tmp32_input.z13(tmp0_desc, 19, IntSerializer_getInstance(), tmp23_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          tmp24_local20 = tmp32_input.z13(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          tmp25_local21 = tmp32_input.v13(tmp0_desc, 21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          tmp26_local22 = tmp32_input.v13(tmp0_desc, 22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          tmp27_local23 = tmp32_input.x13(tmp0_desc, 23, tmp33_cached[23].f2(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          tmp28_local24 = tmp32_input.x13(tmp0_desc, 24, tmp33_cached[24].f2(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          tmp29_local25 = tmp32_input.z13(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          tmp30_local26 = tmp32_input.x13(tmp0_desc, 26, tmp33_cached[26].f2(), tmp30_local26);
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          tmp31_local27 = tmp32_input.x13(tmp0_desc, 27, tmp33_cached[27].f2(), tmp31_local27);
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp32_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp32_input.x13(tmp0_desc, 0, tmp33_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = $serializer_getInstance_58();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp32_input.x13(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (ShortId())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.l5n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp32_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp32_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp32_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp32_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp32_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_8 = tmp33_cached[7].f2();
                var tmp_9 = tmp11_local7;
                var tmp_10 = tmp32_input.z13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp11_local7 = tmp_10 == null ? null : tmp_10.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp32_input.x13(tmp0_desc, 8, tmp33_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp32_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp32_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp32_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp32_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp32_input.v13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp32_input.v13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp32_input.x13(tmp0_desc, 15, $serializer_getInstance_5(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp32_input.x13(tmp0_desc, 16, tmp33_cached[16].f2(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp32_input.z13(tmp0_desc, 17, IntSerializer_getInstance(), tmp21_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp32_input.z13(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp23_local19 = tmp32_input.z13(tmp0_desc, 19, IntSerializer_getInstance(), tmp23_local19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              case 20:
                tmp24_local20 = tmp32_input.z13(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
                tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
                break;
              case 21:
                tmp25_local21 = tmp32_input.v13(tmp0_desc, 21);
                tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
                break;
              case 22:
                tmp26_local22 = tmp32_input.v13(tmp0_desc, 22);
                tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
                break;
              case 23:
                tmp27_local23 = tmp32_input.x13(tmp0_desc, 23, tmp33_cached[23].f2(), tmp27_local23);
                tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
                break;
              case 24:
                tmp28_local24 = tmp32_input.x13(tmp0_desc, 24, tmp33_cached[24].f2(), tmp28_local24);
                tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
                break;
              case 25:
                tmp29_local25 = tmp32_input.z13(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
                tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
                break;
              case 26:
                tmp30_local26 = tmp32_input.x13(tmp0_desc, 26, tmp33_cached[26].f2(), tmp30_local26);
                tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
                break;
              case 27:
                tmp31_local27 = tmp32_input.x13(tmp0_desc, 27, tmp33_cached[27].f2(), tmp31_local27);
                tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp32_input.m13(tmp0_desc);
        return Contractor().z92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, null);
      }
      az() {
        return this.x92_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_20().o5i_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), $serializer_getInstance_58(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), get_nullable(tmp0_cached[7].f2()), tmp0_cached[8].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), tmp0_cached[16].f2(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[23].f2(), tmp0_cached[24].f2(), get_nullable(StringSerializer_getInstance()), tmp0_cached[26].f2(), tmp0_cached[27].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_21() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var ContractorClass;
function Contractor() {
  if (ContractorClass === VOID) {
    class $ {
      constructor(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy) {
        Companion_getInstance_20();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        shortId = shortId === VOID ? Companion_instance_47.i5n() : shortId;
        image = image === VOID ? null : image;
        preferredTitle = preferredTitle === VOID ? PreferredTitle_Contractor_getInstance() : preferredTitle;
        trade = trade === VOID ? null : trade;
        entityType = entityType === VOID ? null : entityType;
        var tmp;
        if (operationStates === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = operationStates;
        }
        operationStates = tmp;
        annualRevenue = annualRevenue === VOID ? null : annualRevenue;
        averageJobSize = averageJobSize === VOID ? null : averageJobSize;
        employeeCount = employeeCount === VOID ? null : employeeCount;
        otherBusinessData = otherBusinessData === VOID ? null : otherBusinessData;
        var tmp_0;
        if (owners === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_0 = emptyList();
        } else {
          tmp_0 = owners;
        }
        owners = tmp_0;
        status = status === VOID ? ContractorStatus_Registering_getInstance() : status;
        paymentId = paymentId === VOID ? null : paymentId;
        var tmp_1;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_1 = get_default(Companion_instance_0).b1m();
        } else {
          tmp_1 = created;
        }
        created = tmp_1;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.t5i_1 = _id;
        this.u5i_1 = shortId;
        this.v5i_1 = name;
        this.w5i_1 = legalName;
        this.x5i_1 = email;
        this.y5i_1 = phoneNumber;
        this.z5i_1 = address;
        this.a5j_1 = image;
        this.b5j_1 = preferredTitle;
        this.c5j_1 = trade;
        this.d5j_1 = entityType;
        this.e5j_1 = contactFirstName;
        this.f5j_1 = contactLastName;
        this.g5j_1 = contactEmail;
        this.h5j_1 = contactPhoneNumber;
        this.i5j_1 = contactAddress;
        this.j5j_1 = operationStates;
        this.k5j_1 = annualRevenue;
        this.l5j_1 = averageJobSize;
        this.m5j_1 = employeeCount;
        this.n5j_1 = otherBusinessData;
        this.o5j_1 = stateEntityNumber;
        this.p5j_1 = ein;
        this.q5j_1 = owners;
        this.r5j_1 = status;
        this.s5j_1 = paymentId;
        this.t5j_1 = created;
        this.u5j_1 = readBy;
      }
      f40() {
        return this.t5i_1;
      }
      i20() {
        return this.v5i_1;
      }
      n92() {
        return this.x5i_1;
      }
      o92() {
        return this.y5i_1;
      }
      q92() {
        return this.a5j_1;
      }
      v91() {
        return this.u5j_1;
      }
      a93(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy) {
        return new (Contractor())(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy);
      }
      w5j(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy, $super) {
        _id = _id === VOID ? this.t5i_1 : _id;
        shortId = shortId === VOID ? this.u5i_1 : shortId;
        name = name === VOID ? this.v5i_1 : name;
        legalName = legalName === VOID ? this.w5i_1 : legalName;
        email = email === VOID ? this.x5i_1 : email;
        phoneNumber = phoneNumber === VOID ? this.y5i_1 : phoneNumber;
        address = address === VOID ? this.z5i_1 : address;
        image = image === VOID ? this.a5j_1 : image;
        preferredTitle = preferredTitle === VOID ? this.b5j_1 : preferredTitle;
        trade = trade === VOID ? this.c5j_1 : trade;
        entityType = entityType === VOID ? this.d5j_1 : entityType;
        contactFirstName = contactFirstName === VOID ? this.e5j_1 : contactFirstName;
        contactLastName = contactLastName === VOID ? this.f5j_1 : contactLastName;
        contactEmail = contactEmail === VOID ? this.g5j_1 : contactEmail;
        contactPhoneNumber = contactPhoneNumber === VOID ? this.h5j_1 : contactPhoneNumber;
        contactAddress = contactAddress === VOID ? this.i5j_1 : contactAddress;
        operationStates = operationStates === VOID ? this.j5j_1 : operationStates;
        annualRevenue = annualRevenue === VOID ? this.k5j_1 : annualRevenue;
        averageJobSize = averageJobSize === VOID ? this.l5j_1 : averageJobSize;
        employeeCount = employeeCount === VOID ? this.m5j_1 : employeeCount;
        otherBusinessData = otherBusinessData === VOID ? this.n5j_1 : otherBusinessData;
        stateEntityNumber = stateEntityNumber === VOID ? this.o5j_1 : stateEntityNumber;
        ein = ein === VOID ? this.p5j_1 : ein;
        owners = owners === VOID ? this.q5j_1 : owners;
        status = status === VOID ? this.r5j_1 : status;
        paymentId = paymentId === VOID ? this.s5j_1 : paymentId;
        created = created === VOID ? this.t5j_1 : created;
        readBy = readBy === VOID ? this.u5j_1 : readBy;
        var tmp;
        if ($super === VOID) {
          tmp = this.a93(_id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy);
        } else {
          var tmp_0 = $super.a93;
          var tmp_1 = image;
          tmp = tmp_0.call(this, _id, new (ShortId())(shortId), name, legalName, email, phoneNumber, address, tmp_1 == null ? null : new (ServerFile())(tmp_1), preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy);
        }
        return tmp;
      }
      toString() {
        var tmp = this.t5i_1.toString();
        var tmp_0 = ShortId__toString_impl_wslzee(this.u5i_1);
        var tmp_1 = this.z5i_1.toString();
        var tmp_2 = this.a5j_1;
        return 'Contractor(_id=' + tmp + ', shortId=' + tmp_0 + ', name=' + this.v5i_1 + ', legalName=' + this.w5i_1 + ', email=' + this.x5i_1 + ', phoneNumber=' + this.y5i_1 + ', address=' + tmp_1 + ', image=' + toString_0(tmp_2 == null ? null : new (ServerFile())(tmp_2)) + ', preferredTitle=' + this.b5j_1.toString() + ', trade=' + this.c5j_1 + ', entityType=' + this.d5j_1 + ', contactFirstName=' + this.e5j_1 + ', contactLastName=' + this.f5j_1 + ', contactEmail=' + this.g5j_1 + ', contactPhoneNumber=' + this.h5j_1 + ', contactAddress=' + this.i5j_1.toString() + ', operationStates=' + toString(this.j5j_1) + ', annualRevenue=' + this.k5j_1 + ', averageJobSize=' + this.l5j_1 + ', employeeCount=' + this.m5j_1 + ', otherBusinessData=' + this.n5j_1 + ', stateEntityNumber=' + this.o5j_1 + ', ein=' + this.p5j_1 + ', owners=' + toString(this.q5j_1) + ', status=' + toString(this.r5j_1) + ', paymentId=' + this.s5j_1 + ', created=' + this.t5j_1.toString() + ', readBy=' + toString(this.u5j_1) + ')';
      }
      hashCode() {
        var result = this.t5i_1.hashCode();
        result = imul(result, 31) + ShortId__hashCode_impl_ghc5rv(this.u5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x5i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y5i_1) | 0;
        result = imul(result, 31) + this.z5i_1.hashCode() | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.a5j_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.a5j_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + this.b5j_1.hashCode() | 0;
        result = imul(result, 31) + (this.c5j_1 == null ? 0 : getStringHashCode(this.c5j_1)) | 0;
        result = imul(result, 31) + (this.d5j_1 == null ? 0 : getStringHashCode(this.d5j_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.e5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h5j_1) | 0;
        result = imul(result, 31) + this.i5j_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.j5j_1) | 0;
        result = imul(result, 31) + (this.k5j_1 == null ? 0 : this.k5j_1) | 0;
        result = imul(result, 31) + (this.l5j_1 == null ? 0 : this.l5j_1) | 0;
        result = imul(result, 31) + (this.m5j_1 == null ? 0 : this.m5j_1) | 0;
        result = imul(result, 31) + (this.n5j_1 == null ? 0 : getStringHashCode(this.n5j_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.o5j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p5j_1) | 0;
        result = imul(result, 31) + hashCode(this.q5j_1) | 0;
        result = imul(result, 31) + this.r5j_1.hashCode() | 0;
        result = imul(result, 31) + (this.s5j_1 == null ? 0 : getStringHashCode(this.s5j_1)) | 0;
        result = imul(result, 31) + this.t5j_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.u5j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Contractor()))
          return false;
        if (!this.t5i_1.equals(other.t5i_1))
          return false;
        if (!(this.u5i_1 === other.u5i_1))
          return false;
        if (!(this.v5i_1 === other.v5i_1))
          return false;
        if (!(this.w5i_1 === other.w5i_1))
          return false;
        if (!(this.x5i_1 === other.x5i_1))
          return false;
        if (!(this.y5i_1 === other.y5i_1))
          return false;
        if (!this.z5i_1.equals(other.z5i_1))
          return false;
        var tmp = this.a5j_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.a5j_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!this.b5j_1.equals(other.b5j_1))
          return false;
        if (!(this.c5j_1 == other.c5j_1))
          return false;
        if (!(this.d5j_1 == other.d5j_1))
          return false;
        if (!(this.e5j_1 === other.e5j_1))
          return false;
        if (!(this.f5j_1 === other.f5j_1))
          return false;
        if (!(this.g5j_1 === other.g5j_1))
          return false;
        if (!(this.h5j_1 === other.h5j_1))
          return false;
        if (!this.i5j_1.equals(other.i5j_1))
          return false;
        if (!equals(this.j5j_1, other.j5j_1))
          return false;
        if (!(this.k5j_1 == other.k5j_1))
          return false;
        if (!(this.l5j_1 == other.l5j_1))
          return false;
        if (!(this.m5j_1 == other.m5j_1))
          return false;
        if (!(this.n5j_1 == other.n5j_1))
          return false;
        if (!(this.o5j_1 === other.o5j_1))
          return false;
        if (!(this.p5j_1 === other.p5j_1))
          return false;
        if (!equals(this.q5j_1, other.q5j_1))
          return false;
        if (!this.r5j_1.equals(other.r5j_1))
          return false;
        if (!(this.s5j_1 == other.s5j_1))
          return false;
        if (!this.t5j_1.equals(other.t5j_1))
          return false;
        if (!equals(this.u5j_1, other.u5j_1))
          return false;
        return true;
      }
      static z92(seen0, _id, shortId, name, legalName, email, phoneNumber, address, image, preferredTitle, trade, entityType, contactFirstName, contactLastName, contactEmail, contactPhoneNumber, contactAddress, operationStates, annualRevenue, averageJobSize, employeeCount, otherBusinessData, stateEntityNumber, ein, owners, status, paymentId, created, readBy, serializationConstructorMarker) {
        Companion_getInstance_20();
        if (!(6355068 === (6355068 & seen0))) {
          throwMissingFieldException(seen0, 6355068, $serializer_getInstance_21().x92_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.t5i_1 = Companion_getInstance().k2p();
        else
          $this.t5i_1 = _id;
        if (0 === (seen0 & 2))
          $this.u5i_1 = Companion_instance_47.i5n();
        else
          $this.u5i_1 = shortId;
        $this.v5i_1 = name;
        $this.w5i_1 = legalName;
        $this.x5i_1 = email;
        $this.y5i_1 = phoneNumber;
        $this.z5i_1 = address;
        if (0 === (seen0 & 128))
          $this.a5j_1 = null;
        else
          $this.a5j_1 = image;
        if (0 === (seen0 & 256))
          $this.b5j_1 = PreferredTitle_Contractor_getInstance();
        else
          $this.b5j_1 = preferredTitle;
        if (0 === (seen0 & 512))
          $this.c5j_1 = null;
        else
          $this.c5j_1 = trade;
        if (0 === (seen0 & 1024))
          $this.d5j_1 = null;
        else
          $this.d5j_1 = entityType;
        $this.e5j_1 = contactFirstName;
        $this.f5j_1 = contactLastName;
        $this.g5j_1 = contactEmail;
        $this.h5j_1 = contactPhoneNumber;
        $this.i5j_1 = contactAddress;
        if (0 === (seen0 & 65536)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.j5j_1 = emptySet();
        } else
          $this.j5j_1 = operationStates;
        if (0 === (seen0 & 131072))
          $this.k5j_1 = null;
        else
          $this.k5j_1 = annualRevenue;
        if (0 === (seen0 & 262144))
          $this.l5j_1 = null;
        else
          $this.l5j_1 = averageJobSize;
        if (0 === (seen0 & 524288))
          $this.m5j_1 = null;
        else
          $this.m5j_1 = employeeCount;
        if (0 === (seen0 & 1048576))
          $this.n5j_1 = null;
        else
          $this.n5j_1 = otherBusinessData;
        $this.o5j_1 = stateEntityNumber;
        $this.p5j_1 = ein;
        if (0 === (seen0 & 8388608)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp_0.q5j_1 = emptyList();
        } else
          $this.q5j_1 = owners;
        if (0 === (seen0 & 16777216))
          $this.r5j_1 = ContractorStatus_Registering_getInstance();
        else
          $this.r5j_1 = status;
        if (0 === (seen0 & 33554432))
          $this.s5j_1 = null;
        else
          $this.s5j_1 = paymentId;
        if (0 === (seen0 & 67108864)) {
          var tmp_1 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_1.t5j_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.t5j_1 = created;
        if (0 === (seen0 & 134217728))
          $this.u5j_1 = emptySet();
        else
          $this.u5j_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Contractor', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_21});
    ContractorClass = $;
  }
  return ContractorClass;
}
var Purpose_ArticleOfIncorporation_instance;
var Purpose_ProofOfEin_instance;
var Purpose_Other_instance;
function values_0() {
  return [Purpose_ArticleOfIncorporation_getInstance(), Purpose_ProofOfEin_getInstance(), Purpose_Other_getInstance()];
}
var Purpose_entriesInitialized;
function Purpose_initEntries() {
  if (Purpose_entriesInitialized)
    return Unit_instance;
  Purpose_entriesInitialized = true;
  Purpose_ArticleOfIncorporation_instance = Purpose().d93('ArticleOfIncorporation', 0);
  Purpose_ProofOfEin_instance = Purpose().d93('ProofOfEin', 1);
  Purpose_Other_instance = Purpose().d93('Other', 2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_1() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_2() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_3() {
  return createSimpleEnumSerializer('com.crowpay.ContractorDocument.Purpose', values_0());
}
var PurposeClass;
function Purpose() {
  if (PurposeClass === VOID) {
    class $ extends Enum() {
      static d93(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Purpose');
    PurposeClass = $;
  }
  return PurposeClass;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_9 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w5g_1 = [tmp_1, tmp_3, null, null, tmp_5, tmp_7, lazy(tmp_8, ContractorDocument$Companion$$childSerializers$_anonymous__bbujye_3)];
      }
      k2a() {
        return $serializer_getInstance_22();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_9;
function Companion_getInstance_21() {
  if (Companion_instance_9 === VOID)
    new (Companion_7())();
  return Companion_instance_9;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ContractorDocument', this, 7);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('contractor', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('fileType', false);
        tmp0_serialDesc.a1b('file', false);
        tmp0_serialDesc.a1b('preview', true);
        tmp0_serialDesc.a1b('purpose', true);
        this.e93_1 = tmp0_serialDesc;
      }
      f93(encoder, value) {
        var tmp0_desc = this.e93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_21().w5g_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.b5h_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.b5h_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.c5h_1);
        tmp1_output.a15(tmp0_desc, 2, value.d5h_1);
        tmp1_output.a15(tmp0_desc, 3, value.e5h_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), new (ServerFile())(value.f5h_1));
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.g5h_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[5].f2();
          var tmp_2 = value.g5h_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !value.h5h_1.equals(Purpose_Other_getInstance())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.h5h_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f93(encoder, value instanceof ContractorDocument() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_21().w5g_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp = tmp12_cached[4].f2();
          var tmp_0 = tmp8_local4;
          var tmp_1 = tmp11_input.x13(tmp0_desc, 4, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp8_local4 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_2 = tmp12_cached[5].f2();
          var tmp_3 = tmp9_local5;
          var tmp_4 = tmp11_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp9_local5 = tmp_4 == null ? null : tmp_4.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_5 = tmp12_cached[4].f2();
                var tmp_6 = tmp8_local4;
                var tmp_7 = tmp11_input.x13(tmp0_desc, 4, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
                tmp8_local4 = tmp_7 == null ? null : tmp_7.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_8 = tmp12_cached[5].f2();
                var tmp_9 = tmp9_local5;
                var tmp_10 = tmp11_input.z13(tmp0_desc, 5, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp9_local5 = tmp_10 == null ? null : tmp_10.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return ContractorDocument().g93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.e93_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_21().w5g_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4].f2(), get_nullable(tmp0_cached[5].f2()), tmp0_cached[6].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_22() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function Purpose_ArticleOfIncorporation_getInstance() {
  Purpose_initEntries();
  return Purpose_ArticleOfIncorporation_instance;
}
function Purpose_ProofOfEin_getInstance() {
  Purpose_initEntries();
  return Purpose_ProofOfEin_instance;
}
function Purpose_Other_getInstance() {
  Purpose_initEntries();
  return Purpose_Other_instance;
}
var ContractorDocumentClass;
function ContractorDocument() {
  if (ContractorDocumentClass === VOID) {
    class $ {
      constructor(_id, contractor, name, fileType, file, preview, purpose) {
        Companion_getInstance_21();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        preview = preview === VOID ? null : preview;
        purpose = purpose === VOID ? Purpose_Other_getInstance() : purpose;
        this.b5h_1 = _id;
        this.c5h_1 = contractor;
        this.d5h_1 = name;
        this.e5h_1 = fileType;
        this.f5h_1 = file;
        this.g5h_1 = preview;
        this.h5h_1 = purpose;
      }
      f40() {
        return this.b5h_1;
      }
      i20() {
        return this.d5h_1;
      }
      h93() {
        return this.e5h_1;
      }
      i93() {
        return this.f5h_1;
      }
      j93() {
        return this.g5h_1;
      }
      k93(_id, contractor, name, fileType, file, preview, purpose) {
        return new (ContractorDocument())(_id, contractor, name, fileType, file, preview, purpose);
      }
      j5h(_id, contractor, name, fileType, file, preview, purpose, $super) {
        _id = _id === VOID ? this.b5h_1 : _id;
        contractor = contractor === VOID ? this.c5h_1 : contractor;
        name = name === VOID ? this.d5h_1 : name;
        fileType = fileType === VOID ? this.e5h_1 : fileType;
        file = file === VOID ? this.f5h_1 : file;
        preview = preview === VOID ? this.g5h_1 : preview;
        purpose = purpose === VOID ? this.h5h_1 : purpose;
        var tmp;
        if ($super === VOID) {
          tmp = this.k93(_id, contractor, name, fileType, file, preview, purpose);
        } else {
          var tmp_0 = $super.k93;
          var tmp_1 = preview;
          tmp = tmp_0.call(this, _id, contractor, name, fileType, new (ServerFile())(file), tmp_1 == null ? null : new (ServerFile())(tmp_1), purpose);
        }
        return tmp;
      }
      toString() {
        var tmp = this.b5h_1.toString();
        var tmp_0 = this.c5h_1.toString();
        var tmp_1 = ServerFile__toString_impl_4rulpa(this.f5h_1);
        var tmp_2 = this.g5h_1;
        return 'ContractorDocument(_id=' + tmp + ', contractor=' + tmp_0 + ', name=' + this.d5h_1 + ', fileType=' + this.e5h_1 + ', file=' + tmp_1 + ', preview=' + toString_0(tmp_2 == null ? null : new (ServerFile())(tmp_2)) + ', purpose=' + this.h5h_1.toString() + ')';
      }
      hashCode() {
        var result = this.b5h_1.hashCode();
        result = imul(result, 31) + this.c5h_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d5h_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e5h_1) | 0;
        result = imul(result, 31) + ServerFile__hashCode_impl_qj0ii5(this.f5h_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.g5h_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.g5h_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + this.h5h_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContractorDocument()))
          return false;
        if (!this.b5h_1.equals(other.b5h_1))
          return false;
        if (!this.c5h_1.equals(other.c5h_1))
          return false;
        if (!(this.d5h_1 === other.d5h_1))
          return false;
        if (!(this.e5h_1 === other.e5h_1))
          return false;
        if (!(this.f5h_1 === other.f5h_1))
          return false;
        var tmp = this.g5h_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.g5h_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!this.h5h_1.equals(other.h5h_1))
          return false;
        return true;
      }
      static g93(seen0, _id, contractor, name, fileType, file, preview, purpose, serializationConstructorMarker) {
        Companion_getInstance_21();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_22().e93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.b5h_1 = Companion_getInstance().k2p();
        else
          $this.b5h_1 = _id;
        $this.c5h_1 = contractor;
        $this.d5h_1 = name;
        $this.e5h_1 = fileType;
        $this.f5h_1 = file;
        if (0 === (seen0 & 32))
          $this.g5h_1 = null;
        else
          $this.g5h_1 = preview;
        if (0 === (seen0 & 64))
          $this.h5h_1 = Purpose_Other_getInstance();
        else
          $this.h5h_1 = purpose;
        return $this;
      }
    }
    initMetadataForClass($, 'ContractorDocument', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_22});
    ContractorDocumentClass = $;
  }
  return ContractorDocumentClass;
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_2() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_10 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w5o_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, tmp_9, lazy(tmp_10, ContractorNote$Companion$$childSerializers$_anonymous__32pyqr_4)];
      }
      k2a() {
        return $serializer_getInstance_23();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_10;
function Companion_getInstance_22() {
  if (Companion_instance_10 === VOID)
    new (Companion_8())();
  return Companion_instance_10;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ContractorNote', this, 7);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lineItem', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('files', true);
        tmp0_serialDesc.a1b('at', true);
        tmp0_serialDesc.a1b('readBy', true);
        this.l93_1 = tmp0_serialDesc;
      }
      m93(encoder, value) {
        var tmp0_desc = this.l93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_22().w5o_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.b5p_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.b5p_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.c5p_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.d5p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.d5p_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.e5p_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.f5p_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.f5p_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.g5p_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.g5p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !equals(value.h5p_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.h5p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m93(encoder, value instanceof ContractorNote() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_22().w5o_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, tmp12_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, tmp12_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return ContractorNote().n93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.l93_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_22().w5o_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), StringSerializer_getInstance(), tmp0_cached[4].f2(), tmp0_cached[5].f2(), tmp0_cached[6].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_23() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var ContractorNoteClass;
function ContractorNote() {
  if (ContractorNoteClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, message, files, at, readBy) {
        Companion_getInstance_22();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        files = files === VOID ? emptyList() : files;
        var tmp;
        if (at === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = at;
        }
        at = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.b5p_1 = _id;
        this.c5p_1 = project;
        this.d5p_1 = lineItem;
        this.e5p_1 = message;
        this.f5p_1 = files;
        this.g5p_1 = at;
        this.h5p_1 = readBy;
      }
      f40() {
        return this.b5p_1;
      }
      v91() {
        return this.h5p_1;
      }
      o93(_id, project, lineItem, message, files, at, readBy) {
        return new (ContractorNote())(_id, project, lineItem, message, files, at, readBy);
      }
      j5p(_id, project, lineItem, message, files, at, readBy, $super) {
        _id = _id === VOID ? this.b5p_1 : _id;
        project = project === VOID ? this.c5p_1 : project;
        lineItem = lineItem === VOID ? this.d5p_1 : lineItem;
        message = message === VOID ? this.e5p_1 : message;
        files = files === VOID ? this.f5p_1 : files;
        at = at === VOID ? this.g5p_1 : at;
        readBy = readBy === VOID ? this.h5p_1 : readBy;
        return $super === VOID ? this.o93(_id, project, lineItem, message, files, at, readBy) : $super.o93.call(this, _id, project, lineItem, message, files, at, readBy);
      }
      toString() {
        return 'ContractorNote(_id=' + this.b5p_1.toString() + ', project=' + this.c5p_1.toString() + ', lineItem=' + toString_0(this.d5p_1) + ', message=' + this.e5p_1 + ', files=' + toString(this.f5p_1) + ', at=' + this.g5p_1.toString() + ', readBy=' + toString(this.h5p_1) + ')';
      }
      hashCode() {
        var result = this.b5p_1.hashCode();
        result = imul(result, 31) + this.c5p_1.hashCode() | 0;
        result = imul(result, 31) + (this.d5p_1 == null ? 0 : this.d5p_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.e5p_1) | 0;
        result = imul(result, 31) + hashCode(this.f5p_1) | 0;
        result = imul(result, 31) + this.g5p_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.h5p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContractorNote()))
          return false;
        if (!this.b5p_1.equals(other.b5p_1))
          return false;
        if (!this.c5p_1.equals(other.c5p_1))
          return false;
        if (!equals(this.d5p_1, other.d5p_1))
          return false;
        if (!(this.e5p_1 === other.e5p_1))
          return false;
        if (!equals(this.f5p_1, other.f5p_1))
          return false;
        if (!this.g5p_1.equals(other.g5p_1))
          return false;
        if (!equals(this.h5p_1, other.h5p_1))
          return false;
        return true;
      }
      static n93(seen0, _id, project, lineItem, message, files, at, readBy, serializationConstructorMarker) {
        Companion_getInstance_22();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_23().l93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.b5p_1 = Companion_getInstance().k2p();
        else
          $this.b5p_1 = _id;
        $this.c5p_1 = project;
        if (0 === (seen0 & 4))
          $this.d5p_1 = null;
        else
          $this.d5p_1 = lineItem;
        $this.e5p_1 = message;
        if (0 === (seen0 & 16))
          $this.f5p_1 = emptyList();
        else
          $this.f5p_1 = files;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.g5p_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.g5p_1 = at;
        if (0 === (seen0 & 64))
          $this.h5p_1 = emptySet();
        else
          $this.h5p_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'ContractorNote', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_23});
    ContractorNoteClass = $;
  }
  return ContractorNoteClass;
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function Dispute$Companion$$childSerializers$_anonymous__k8vm1m_3() {
  return Companion_getInstance_55().k2a();
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      constructor() {
        Companion_instance_11 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Dispute$Companion$$childSerializers$_anonymous__k8vm1m);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b5w_1 = [tmp_1, tmp_3, null, tmp_5, null, null, null, null, tmp_7, lazy(tmp_8, Dispute$Companion$$childSerializers$_anonymous__k8vm1m_3)];
      }
      k2a() {
        return $serializer_getInstance_24();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_11;
function Companion_getInstance_23() {
  if (Companion_instance_11 === VOID)
    new (Companion_9())();
  return Companion_instance_11;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Dispute', this, 10);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lineItem', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('incident', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.a1b('filed', false);
        tmp0_serialDesc.a1b('lockProject', true);
        tmp0_serialDesc.a1b('filedForArbitration', true);
        tmp0_serialDesc.a1b('resolved', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('state', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.p93_1 = tmp0_serialDesc;
      }
      q93(encoder, value) {
        var tmp0_desc = this.p93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_23().b5w_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.i5w_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.i5w_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j5w_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.k5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_6(), value.k5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.l5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.l5w_1);
        }
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance_4(), value.m5w_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.n5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, $serializer_getInstance_4(), value.n5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.o5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_7(), value.o5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.p5w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.p5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.q5w_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.q5w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !value.r5w_1.equals(DisputeState_Ongoing_getInstance())) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.r5w_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q93(encoder, value instanceof Dispute() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_23().b5w_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.z13(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.z13(tmp0_desc, 6, $serializer_getInstance_7(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.z13(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.z13(tmp0_desc, 6, $serializer_getInstance_7(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return Dispute().r93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.p93_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_23().b5w_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable($serializer_getInstance_6()), get_nullable(tmp0_cached[3].f2()), $serializer_getInstance_4(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_7()), get_nullable($serializer_getInstance_4()), tmp0_cached[8].f2(), tmp0_cached[9].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_24() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var DisputeClass;
function Dispute() {
  if (DisputeClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state) {
        Companion_getInstance_23();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        incident = incident === VOID ? null : incident;
        lockProject = lockProject === VOID ? null : lockProject;
        filedForArbitration = filedForArbitration === VOID ? null : filedForArbitration;
        resolved = resolved === VOID ? null : resolved;
        readBy = readBy === VOID ? emptySet() : readBy;
        state = state === VOID ? DisputeState_Ongoing_getInstance() : state;
        this.i5w_1 = _id;
        this.j5w_1 = project;
        this.k5w_1 = lineItem;
        this.l5w_1 = incident;
        this.m5w_1 = filed;
        this.n5w_1 = lockProject;
        this.o5w_1 = filedForArbitration;
        this.p5w_1 = resolved;
        this.q5w_1 = readBy;
        this.r5w_1 = state;
      }
      f40() {
        return this.i5w_1;
      }
      v91() {
        return this.q5w_1;
      }
      s93(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state) {
        return new (Dispute())(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state);
      }
      t5w(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state, $super) {
        _id = _id === VOID ? this.i5w_1 : _id;
        project = project === VOID ? this.j5w_1 : project;
        lineItem = lineItem === VOID ? this.k5w_1 : lineItem;
        incident = incident === VOID ? this.l5w_1 : incident;
        filed = filed === VOID ? this.m5w_1 : filed;
        lockProject = lockProject === VOID ? this.n5w_1 : lockProject;
        filedForArbitration = filedForArbitration === VOID ? this.o5w_1 : filedForArbitration;
        resolved = resolved === VOID ? this.p5w_1 : resolved;
        readBy = readBy === VOID ? this.q5w_1 : readBy;
        state = state === VOID ? this.r5w_1 : state;
        return $super === VOID ? this.s93(_id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state) : $super.s93.call(this, _id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state);
      }
      toString() {
        return 'Dispute(_id=' + this.i5w_1.toString() + ', project=' + this.j5w_1.toString() + ', lineItem=' + toString_0(this.k5w_1) + ', incident=' + toString_0(this.l5w_1) + ', filed=' + this.m5w_1.toString() + ', lockProject=' + toString_0(this.n5w_1) + ', filedForArbitration=' + toString_0(this.o5w_1) + ', resolved=' + toString_0(this.p5w_1) + ', readBy=' + toString(this.q5w_1) + ', state=' + this.r5w_1.toString() + ')';
      }
      hashCode() {
        var result = this.i5w_1.hashCode();
        result = imul(result, 31) + this.j5w_1.hashCode() | 0;
        result = imul(result, 31) + (this.k5w_1 == null ? 0 : this.k5w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.l5w_1 == null ? 0 : this.l5w_1.hashCode()) | 0;
        result = imul(result, 31) + this.m5w_1.hashCode() | 0;
        result = imul(result, 31) + (this.n5w_1 == null ? 0 : this.n5w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.o5w_1 == null ? 0 : this.o5w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.p5w_1 == null ? 0 : this.p5w_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.q5w_1) | 0;
        result = imul(result, 31) + this.r5w_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Dispute()))
          return false;
        if (!this.i5w_1.equals(other.i5w_1))
          return false;
        if (!this.j5w_1.equals(other.j5w_1))
          return false;
        if (!equals(this.k5w_1, other.k5w_1))
          return false;
        if (!equals(this.l5w_1, other.l5w_1))
          return false;
        if (!this.m5w_1.equals(other.m5w_1))
          return false;
        if (!equals(this.n5w_1, other.n5w_1))
          return false;
        if (!equals(this.o5w_1, other.o5w_1))
          return false;
        if (!equals(this.p5w_1, other.p5w_1))
          return false;
        if (!equals(this.q5w_1, other.q5w_1))
          return false;
        if (!this.r5w_1.equals(other.r5w_1))
          return false;
        return true;
      }
      static r93(seen0, _id, project, lineItem, incident, filed, lockProject, filedForArbitration, resolved, readBy, state, serializationConstructorMarker) {
        Companion_getInstance_23();
        if (!(18 === (18 & seen0))) {
          throwMissingFieldException(seen0, 18, $serializer_getInstance_24().p93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i5w_1 = Companion_getInstance().k2p();
        else
          $this.i5w_1 = _id;
        $this.j5w_1 = project;
        if (0 === (seen0 & 4))
          $this.k5w_1 = null;
        else
          $this.k5w_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.l5w_1 = null;
        else
          $this.l5w_1 = incident;
        $this.m5w_1 = filed;
        if (0 === (seen0 & 32))
          $this.n5w_1 = null;
        else
          $this.n5w_1 = lockProject;
        if (0 === (seen0 & 64))
          $this.o5w_1 = null;
        else
          $this.o5w_1 = filedForArbitration;
        if (0 === (seen0 & 128))
          $this.p5w_1 = null;
        else
          $this.p5w_1 = resolved;
        if (0 === (seen0 & 256))
          $this.q5w_1 = emptySet();
        else
          $this.q5w_1 = readBy;
        if (0 === (seen0 & 512))
          $this.r5w_1 = DisputeState_Ongoing_getInstance();
        else
          $this.r5w_1 = state;
        return $this;
      }
    }
    initMetadataForClass($, 'Dispute', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_24});
    DisputeClass = $;
  }
  return DisputeClass;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_25();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_12;
function Companion_getInstance_24() {
  return Companion_instance_12;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.EntityType', this, 1);
        tmp0_serialDesc.a1b('_id', false);
        this.t93_1 = tmp0_serialDesc;
      }
      u93(encoder, value) {
        var tmp0_desc = this.t93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.l5z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u93(encoder, value instanceof EntityType() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return EntityType().v93(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.t93_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_25() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var EntityTypeClass;
function EntityType() {
  if (EntityTypeClass === VOID) {
    class $ {
      constructor(_id) {
        this.l5z_1 = _id;
      }
      f40() {
        return this.l5z_1;
      }
      n5z(_id) {
        return new (EntityType())(_id);
      }
      toString() {
        return 'EntityType(_id=' + this.l5z_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.l5z_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EntityType()))
          return false;
        if (!(this.l5z_1 === other.l5z_1))
          return false;
        return true;
      }
      static v93(seen0, _id, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_25().t93_1);
        }
        var $this = createThis(this);
        $this.l5z_1 = _id;
        return $this;
      }
    }
    initMetadataForClass($, 'EntityType', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_25});
    EntityTypeClass = $;
  }
  return EntityTypeClass;
}
function FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      constructor() {
        Companion_instance_13 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y60_1 = [tmp_1, tmp_3, null, null, null, null, null, lazy(tmp_4, FundsRequest$Companion$$childSerializers$_anonymous__mmbn7b_1)];
      }
      k2a() {
        return $serializer_getInstance_26();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_13;
function Companion_getInstance_25() {
  if (Companion_instance_13 === VOID)
    new (Companion_11())();
  return Companion_instance_13;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.FundsRequest', this, 8);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('access', false);
        tmp0_serialDesc.a1b('amount', false);
        tmp0_serialDesc.a1b('summary', true);
        tmp0_serialDesc.a1b('pendingDeposits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('deposits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('funded', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.w93_1 = tmp0_serialDesc;
      }
      x93(encoder, value) {
        var tmp0_desc = this.w93_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_25().y60_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d61_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d61_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.e61_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.f61_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_2(), new (MonetaryValue())(value.g61_1));
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.h61_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.h61_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.i61_1 === Companion_instance.m62(0))) {
          tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.i61_1));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.j61_1 === Companion_instance.m62(0))) {
          tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_2(), new (MonetaryValue())(value.j61_1));
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp = true;
        } else {
          var tmp_0;
          if (MonetaryValue__compareTo_impl_w7ul1r(value.j61_1, value.g61_1) >= 0) {
            // Inline function 'com.lightningkite.now' call
            tmp_0 = get_default(Companion_instance_0).b1m();
          } else {
            tmp_0 = null;
          }
          tmp = !equals(value.k61_1, tmp_0);
        }
        if (tmp) {
          tmp1_output.d15(tmp0_desc, 7, tmp2_cached[7].f2(), value.k61_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x93(encoder, value instanceof FundsRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w93_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_25().y60_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp12_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp9_local5;
          var tmp_4 = tmp12_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp9_local5 = tmp_4 == null ? null : tmp_4.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp10_local6;
          var tmp_7 = tmp12_input.x13(tmp0_desc, 6, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp10_local6 = tmp_7 == null ? null : tmp_7.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp7_local3;
                var tmp_10 = tmp12_input.x13(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp7_local3 = tmp_10 == null ? null : tmp_10.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp9_local5;
                var tmp_13 = tmp12_input.x13(tmp0_desc, 5, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
                tmp9_local5 = tmp_13 == null ? null : tmp_13.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp10_local6;
                var tmp_16 = tmp12_input.x13(tmp0_desc, 6, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
                tmp10_local6 = tmp_16 == null ? null : tmp_16.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return FundsRequest().y93(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.w93_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_25().y60_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_4(), $serializer_getInstance_2(), StringSerializer_getInstance(), $serializer_getInstance_2(), $serializer_getInstance_2(), get_nullable(tmp0_cached[7].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_26() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var FundsRequestClass;
function FundsRequest() {
  if (FundsRequestClass === VOID) {
    class $ {
      constructor(_id, project, access, amount, summary, pendingDeposits, deposits, funded) {
        Companion_getInstance_25();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        summary = summary === VOID ? '' : summary;
        pendingDeposits = pendingDeposits === VOID ? Companion_instance.m62(0) : pendingDeposits;
        deposits = deposits === VOID ? Companion_instance.m62(0) : deposits;
        var tmp;
        if (funded === VOID) {
          var tmp_0;
          if (MonetaryValue__compareTo_impl_w7ul1r(deposits, amount) >= 0) {
            // Inline function 'com.lightningkite.now' call
            tmp_0 = get_default(Companion_instance_0).b1m();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = funded;
        }
        funded = tmp;
        this.d61_1 = _id;
        this.e61_1 = project;
        this.f61_1 = access;
        this.g61_1 = amount;
        this.h61_1 = summary;
        this.i61_1 = pendingDeposits;
        this.j61_1 = deposits;
        this.k61_1 = funded;
      }
      f40() {
        return this.d61_1;
      }
      z93(_id, project, access, amount, summary, pendingDeposits, deposits, funded) {
        return new (FundsRequest())(_id, project, access, amount, summary, pendingDeposits, deposits, funded);
      }
      m61(_id, project, access, amount, summary, pendingDeposits, deposits, funded, $super) {
        _id = _id === VOID ? this.d61_1 : _id;
        project = project === VOID ? this.e61_1 : project;
        access = access === VOID ? this.f61_1 : access;
        amount = amount === VOID ? this.g61_1 : amount;
        summary = summary === VOID ? this.h61_1 : summary;
        pendingDeposits = pendingDeposits === VOID ? this.i61_1 : pendingDeposits;
        deposits = deposits === VOID ? this.j61_1 : deposits;
        funded = funded === VOID ? this.k61_1 : funded;
        return $super === VOID ? this.z93(_id, project, access, amount, summary, pendingDeposits, deposits, funded) : $super.z93.call(this, _id, project, access, new (MonetaryValue())(amount), summary, new (MonetaryValue())(pendingDeposits), new (MonetaryValue())(deposits), funded);
      }
      toString() {
        return 'FundsRequest(_id=' + this.d61_1.toString() + ', project=' + this.e61_1.toString() + ', access=' + this.f61_1.toString() + ', amount=' + MonetaryValue__toString_impl_xslc77(this.g61_1) + ', summary=' + this.h61_1 + ', pendingDeposits=' + MonetaryValue__toString_impl_xslc77(this.i61_1) + ', deposits=' + MonetaryValue__toString_impl_xslc77(this.j61_1) + ', funded=' + toString_0(this.k61_1) + ')';
      }
      hashCode() {
        var result = this.d61_1.hashCode();
        result = imul(result, 31) + this.e61_1.hashCode() | 0;
        result = imul(result, 31) + this.f61_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.g61_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h61_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.i61_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.j61_1) | 0;
        result = imul(result, 31) + (this.k61_1 == null ? 0 : this.k61_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FundsRequest()))
          return false;
        if (!this.d61_1.equals(other.d61_1))
          return false;
        if (!this.e61_1.equals(other.e61_1))
          return false;
        if (!this.f61_1.equals(other.f61_1))
          return false;
        if (!(this.g61_1 === other.g61_1))
          return false;
        if (!(this.h61_1 === other.h61_1))
          return false;
        if (!(this.i61_1 === other.i61_1))
          return false;
        if (!(this.j61_1 === other.j61_1))
          return false;
        if (!equals(this.k61_1, other.k61_1))
          return false;
        return true;
      }
      static y93(seen0, _id, project, access, amount, summary, pendingDeposits, deposits, funded, serializationConstructorMarker) {
        Companion_getInstance_25();
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_26().w93_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d61_1 = Companion_getInstance().k2p();
        else
          $this.d61_1 = _id;
        $this.e61_1 = project;
        $this.f61_1 = access;
        $this.g61_1 = amount;
        if (0 === (seen0 & 16))
          $this.h61_1 = '';
        else
          $this.h61_1 = summary;
        if (0 === (seen0 & 32))
          $this.i61_1 = Companion_instance.m62(0);
        else
          $this.i61_1 = pendingDeposits;
        if (0 === (seen0 & 64))
          $this.j61_1 = Companion_instance.m62(0);
        else
          $this.j61_1 = deposits;
        if (0 === (seen0 & 128)) {
          var tmp = $this;
          var tmp_0;
          if (MonetaryValue__compareTo_impl_w7ul1r($this.j61_1, $this.g61_1) >= 0) {
            // Inline function 'com.lightningkite.now' call
            tmp_0 = get_default(Companion_instance_0).b1m();
          } else {
            tmp_0 = null;
          }
          tmp.k61_1 = tmp_0;
        } else
          $this.k61_1 = funded;
        return $this;
      }
    }
    initMetadataForClass($, 'FundsRequest', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_26});
    FundsRequestClass = $;
  }
  return FundsRequestClass;
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_2() {
  return Companion_getInstance_11().k2a();
}
function Incident$Companion$$childSerializers$_anonymous__hwsgq0_3() {
  return Companion_getInstance_5().k2a();
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      constructor() {
        Companion_instance_14 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Incident$Companion$$childSerializers$_anonymous__hwsgq0);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Incident$Companion$$childSerializers$_anonymous__hwsgq0_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Incident$Companion$$childSerializers$_anonymous__hwsgq0_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Incident$Companion$$childSerializers$_anonymous__hwsgq0_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w62_1 = [tmp_1, tmp_3, null, null, null, tmp_5, tmp_7, lazy(tmp_8, Incident$Companion$$childSerializers$_anonymous__hwsgq0_3), null, null];
      }
      k2a() {
        return $serializer_getInstance_27();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_14;
function Companion_getInstance_26() {
  if (Companion_instance_14 === VOID)
    new (Companion_12())();
  return Companion_instance_14;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Incident', this, 10);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('filed', false);
        tmp0_serialDesc.a1b('issue', true);
        tmp0_serialDesc.a1b('resolved', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('concern', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('state', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('canFileDispute', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('canLockProject', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.a94_1 = tmp0_serialDesc;
      }
      b94(encoder, value) {
        var tmp0_desc = this.a94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_26().w62_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.b63_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.b63_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.c63_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.d63_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.e63_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, $serializer_getInstance_3(), value.e63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.f63_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, $serializer_getInstance_4(), value.f63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !equals(value.g63_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.g63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !value.h63_1.equals(ClientConcern_Other_getInstance())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.h63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !value.i63_1.equals(IncidentState_Filed_getInstance())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.i63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.j63_1 === false)) {
          tmp1_output.s14(tmp0_desc, 8, value.j63_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.k63_1 === false)) {
          tmp1_output.s14(tmp0_desc, 9, value.k63_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b94(encoder, value instanceof Incident() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = false;
        var tmp13_local9 = false;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_26().w62_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.x13(tmp0_desc, 5, tmp15_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.x13(tmp0_desc, 6, tmp15_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.x13(tmp0_desc, 7, tmp15_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.n13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.n13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, $serializer_getInstance_3(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.x13(tmp0_desc, 5, tmp15_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.x13(tmp0_desc, 6, tmp15_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.x13(tmp0_desc, 7, tmp15_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.n13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.n13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return Incident().c94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.a94_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_26().w62_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_4(), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_4()), tmp0_cached[5].f2(), tmp0_cached[6].f2(), tmp0_cached[7].f2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_27() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
var IncidentClass;
function Incident() {
  if (IncidentClass === VOID) {
    class $ {
      constructor(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject) {
        Companion_getInstance_26();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        issue = issue === VOID ? null : issue;
        resolved = resolved === VOID ? null : resolved;
        readBy = readBy === VOID ? emptySet() : readBy;
        concern = concern === VOID ? ClientConcern_Other_getInstance() : concern;
        state = state === VOID ? IncidentState_Filed_getInstance() : state;
        canFileDispute = canFileDispute === VOID ? false : canFileDispute;
        canLockProject = canLockProject === VOID ? false : canLockProject;
        this.b63_1 = _id;
        this.c63_1 = project;
        this.d63_1 = filed;
        this.e63_1 = issue;
        this.f63_1 = resolved;
        this.g63_1 = readBy;
        this.h63_1 = concern;
        this.i63_1 = state;
        this.j63_1 = canFileDispute;
        this.k63_1 = canLockProject;
      }
      f40() {
        return this.b63_1;
      }
      v91() {
        return this.g63_1;
      }
      d94(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject) {
        return new (Incident())(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject);
      }
      m63(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject, $super) {
        _id = _id === VOID ? this.b63_1 : _id;
        project = project === VOID ? this.c63_1 : project;
        filed = filed === VOID ? this.d63_1 : filed;
        issue = issue === VOID ? this.e63_1 : issue;
        resolved = resolved === VOID ? this.f63_1 : resolved;
        readBy = readBy === VOID ? this.g63_1 : readBy;
        concern = concern === VOID ? this.h63_1 : concern;
        state = state === VOID ? this.i63_1 : state;
        canFileDispute = canFileDispute === VOID ? this.j63_1 : canFileDispute;
        canLockProject = canLockProject === VOID ? this.k63_1 : canLockProject;
        return $super === VOID ? this.d94(_id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject) : $super.d94.call(this, _id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject);
      }
      toString() {
        return 'Incident(_id=' + this.b63_1.toString() + ', project=' + this.c63_1.toString() + ', filed=' + this.d63_1.toString() + ', issue=' + toString_0(this.e63_1) + ', resolved=' + toString_0(this.f63_1) + ', readBy=' + toString(this.g63_1) + ', concern=' + this.h63_1.toString() + ', state=' + toString(this.i63_1) + ', canFileDispute=' + this.j63_1 + ', canLockProject=' + this.k63_1 + ')';
      }
      hashCode() {
        var result = this.b63_1.hashCode();
        result = imul(result, 31) + this.c63_1.hashCode() | 0;
        result = imul(result, 31) + this.d63_1.hashCode() | 0;
        result = imul(result, 31) + (this.e63_1 == null ? 0 : this.e63_1.hashCode()) | 0;
        result = imul(result, 31) + (this.f63_1 == null ? 0 : this.f63_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.g63_1) | 0;
        result = imul(result, 31) + this.h63_1.hashCode() | 0;
        result = imul(result, 31) + this.i63_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.j63_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.k63_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Incident()))
          return false;
        if (!this.b63_1.equals(other.b63_1))
          return false;
        if (!this.c63_1.equals(other.c63_1))
          return false;
        if (!this.d63_1.equals(other.d63_1))
          return false;
        if (!equals(this.e63_1, other.e63_1))
          return false;
        if (!equals(this.f63_1, other.f63_1))
          return false;
        if (!equals(this.g63_1, other.g63_1))
          return false;
        if (!this.h63_1.equals(other.h63_1))
          return false;
        if (!this.i63_1.equals(other.i63_1))
          return false;
        if (!(this.j63_1 === other.j63_1))
          return false;
        if (!(this.k63_1 === other.k63_1))
          return false;
        return true;
      }
      static c94(seen0, _id, project, filed, issue, resolved, readBy, concern, state, canFileDispute, canLockProject, serializationConstructorMarker) {
        Companion_getInstance_26();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_27().a94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.b63_1 = Companion_getInstance().k2p();
        else
          $this.b63_1 = _id;
        $this.c63_1 = project;
        $this.d63_1 = filed;
        if (0 === (seen0 & 8))
          $this.e63_1 = null;
        else
          $this.e63_1 = issue;
        if (0 === (seen0 & 16))
          $this.f63_1 = null;
        else
          $this.f63_1 = resolved;
        if (0 === (seen0 & 32))
          $this.g63_1 = emptySet();
        else
          $this.g63_1 = readBy;
        if (0 === (seen0 & 64))
          $this.h63_1 = ClientConcern_Other_getInstance();
        else
          $this.h63_1 = concern;
        if (0 === (seen0 & 128))
          $this.i63_1 = IncidentState_Filed_getInstance();
        else
          $this.i63_1 = state;
        if (0 === (seen0 & 256))
          $this.j63_1 = false;
        else
          $this.j63_1 = canFileDispute;
        if (0 === (seen0 & 512))
          $this.k63_1 = false;
        else
          $this.k63_1 = canLockProject;
        return $this;
      }
    }
    initMetadataForClass($, 'Incident', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_27});
    IncidentClass = $;
  }
  return IncidentClass;
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_15 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p67_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, null, null, tmp_9, tmp_11, lazy(tmp_12, IncidentMessage$Companion$$childSerializers$_anonymous__ojnt05_5), null];
      }
      k2a() {
        return $serializer_getInstance_28();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_15;
function Companion_getInstance_27() {
  if (Companion_instance_15 === VOID)
    new (Companion_13())();
  return Companion_instance_15;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.IncidentMessage', this, 11);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('incident', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('clientMessage', false);
        tmp0_serialDesc.a1b('sender', false);
        tmp0_serialDesc.a1b('typeSerializable', false);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('attachments', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('needsResponse', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.e94_1 = tmp0_serialDesc;
      }
      f94(encoder, value) {
        var tmp0_desc = this.e94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_27().p67_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.u67_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.u67_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.v67_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.w67_1);
        tmp1_output.s14(tmp0_desc, 3, value.x67_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.y67_1);
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_13(), value.z67_1);
        tmp1_output.a15(tmp0_desc, 6, value.a68_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.b68_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.b68_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.c68_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.c68_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !equals(value.d68_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.d68_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.e68_1 === true)) {
          tmp1_output.s14(tmp0_desc, 10, value.e68_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f94(encoder, value instanceof IncidentMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_27().p67_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.x13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_13(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.x13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_13(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return IncidentMessage().g94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.e94_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_27().p67_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), BooleanSerializer_getInstance(), tmp0_cached[4].f2(), $serializer_getInstance_13(), StringSerializer_getInstance(), tmp0_cached[7].f2(), tmp0_cached[8].f2(), tmp0_cached[9].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_28() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
function IncidentMessage$_get_type_$ref_ia9x1r() {
  return (p0) => p0.h94();
}
var IncidentMessageClass;
function IncidentMessage() {
  if (IncidentMessageClass === VOID) {
    class $ {
      constructor(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse) {
        Companion_getInstance_27();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        attachments = attachments === VOID ? emptyList() : attachments;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        needsResponse = needsResponse === VOID ? true : needsResponse;
        this.u67_1 = _id;
        this.v67_1 = incident;
        this.w67_1 = project;
        this.x67_1 = clientMessage;
        this.y67_1 = sender;
        this.z67_1 = typeSerializable;
        this.a68_1 = message;
        this.b68_1 = attachments;
        this.c68_1 = created;
        this.d68_1 = readBy;
        this.e68_1 = needsResponse;
        var tmp_0 = this;
        tmp_0.f68_1 = lazy_0(() => parseResponse(this.z67_1));
      }
      f40() {
        return this.u67_1;
      }
      i94() {
        return this.x67_1;
      }
      j94() {
        return this.y67_1;
      }
      j() {
        return this.a68_1;
      }
      k94() {
        return this.c68_1;
      }
      v91() {
        return this.d68_1;
      }
      h94() {
        var tmp0 = this.f68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('type', 1, tmp, IncidentMessage$_get_type_$ref_ia9x1r(), null);
        return tmp0.f2();
      }
      l94(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse) {
        return new (IncidentMessage())(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse);
      }
      h68(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse, $super) {
        _id = _id === VOID ? this.u67_1 : _id;
        incident = incident === VOID ? this.v67_1 : incident;
        project = project === VOID ? this.w67_1 : project;
        clientMessage = clientMessage === VOID ? this.x67_1 : clientMessage;
        sender = sender === VOID ? this.y67_1 : sender;
        typeSerializable = typeSerializable === VOID ? this.z67_1 : typeSerializable;
        message = message === VOID ? this.a68_1 : message;
        attachments = attachments === VOID ? this.b68_1 : attachments;
        created = created === VOID ? this.c68_1 : created;
        readBy = readBy === VOID ? this.d68_1 : readBy;
        needsResponse = needsResponse === VOID ? this.e68_1 : needsResponse;
        return $super === VOID ? this.l94(_id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse) : $super.l94.call(this, _id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse);
      }
      toString() {
        return 'IncidentMessage(_id=' + this.u67_1.toString() + ', incident=' + this.v67_1.toString() + ', project=' + this.w67_1.toString() + ', clientMessage=' + this.x67_1 + ', sender=' + this.y67_1.toString() + ', typeSerializable=' + this.z67_1.toString() + ', message=' + this.a68_1 + ', attachments=' + toString(this.b68_1) + ', created=' + this.c68_1.toString() + ', readBy=' + toString(this.d68_1) + ', needsResponse=' + this.e68_1 + ')';
      }
      hashCode() {
        var result = this.u67_1.hashCode();
        result = imul(result, 31) + this.v67_1.hashCode() | 0;
        result = imul(result, 31) + this.w67_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.x67_1) | 0;
        result = imul(result, 31) + this.y67_1.hashCode() | 0;
        result = imul(result, 31) + this.z67_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.a68_1) | 0;
        result = imul(result, 31) + hashCode(this.b68_1) | 0;
        result = imul(result, 31) + this.c68_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.d68_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.e68_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncidentMessage()))
          return false;
        if (!this.u67_1.equals(other.u67_1))
          return false;
        if (!this.v67_1.equals(other.v67_1))
          return false;
        if (!this.w67_1.equals(other.w67_1))
          return false;
        if (!(this.x67_1 === other.x67_1))
          return false;
        if (!this.y67_1.equals(other.y67_1))
          return false;
        if (!this.z67_1.equals(other.z67_1))
          return false;
        if (!(this.a68_1 === other.a68_1))
          return false;
        if (!equals(this.b68_1, other.b68_1))
          return false;
        if (!this.c68_1.equals(other.c68_1))
          return false;
        if (!equals(this.d68_1, other.d68_1))
          return false;
        if (!(this.e68_1 === other.e68_1))
          return false;
        return true;
      }
      static g94(seen0, _id, incident, project, clientMessage, sender, typeSerializable, message, attachments, created, readBy, needsResponse, serializationConstructorMarker) {
        Companion_getInstance_27();
        if (!(126 === (126 & seen0))) {
          throwMissingFieldException(seen0, 126, $serializer_getInstance_28().e94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.u67_1 = Companion_getInstance().k2p();
        else
          $this.u67_1 = _id;
        $this.v67_1 = incident;
        $this.w67_1 = project;
        $this.x67_1 = clientMessage;
        $this.y67_1 = sender;
        $this.z67_1 = typeSerializable;
        $this.a68_1 = message;
        if (0 === (seen0 & 128))
          $this.b68_1 = emptyList();
        else
          $this.b68_1 = attachments;
        if (0 === (seen0 & 256)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.c68_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.c68_1 = created;
        if (0 === (seen0 & 512))
          $this.d68_1 = emptySet();
        else
          $this.d68_1 = readBy;
        if (0 === (seen0 & 1024))
          $this.e68_1 = true;
        else
          $this.e68_1 = needsResponse;
        var tmp_0 = $this;
        tmp_0.f68_1 = lazy_0(() => parseResponse($this.z67_1));
        return $this;
      }
    }
    initMetadataForClass($, 'IncidentMessage', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_28});
    IncidentMessageClass = $;
  }
  return IncidentMessageClass;
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_5() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      constructor() {
        Companion_instance_16 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l65_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, null, null, tmp_11, lazy(tmp_12, IncidentMessageComment$Companion$$childSerializers$_anonymous__rlbtsw_5)];
      }
      k2a() {
        return $serializer_getInstance_29();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_16;
function Companion_getInstance_28() {
  if (Companion_instance_16 === VOID)
    new (Companion_14())();
  return Companion_instance_16;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.IncidentMessageComment', this, 10);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('incidentMessage', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(IncidentMessage())));
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('incident', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.a1b('sender', false);
        tmp0_serialDesc.a1b('senderName', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('clientMessage', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('created', true);
        this.m94_1 = tmp0_serialDesc;
      }
      n94(encoder, value) {
        var tmp0_desc = this.m94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_28().l65_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.q65_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.q65_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.r65_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.s65_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.t65_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.u65_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.v65_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.v65_1);
        }
        tmp1_output.s14(tmp0_desc, 6, value.w65_1);
        tmp1_output.a15(tmp0_desc, 7, value.x65_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.y65_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.y65_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.z65_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.z65_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n94(encoder, value instanceof IncidentMessageComment() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_28().l65_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.x13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.x13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.x13(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.x13(tmp0_desc, 9, tmp15_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return IncidentMessageComment().o94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.m94_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_28().l65_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), tmp0_cached[4].f2(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[8].f2(), tmp0_cached[9].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_29() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var IncidentMessageCommentClass;
function IncidentMessageComment() {
  if (IncidentMessageCommentClass === VOID) {
    class $ {
      constructor(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created) {
        Companion_getInstance_28();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        senderName = senderName === VOID ? '' : senderName;
        readBy = readBy === VOID ? emptySet() : readBy;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.q65_1 = _id;
        this.r65_1 = incidentMessage;
        this.s65_1 = project;
        this.t65_1 = incident;
        this.u65_1 = sender;
        this.v65_1 = senderName;
        this.w65_1 = clientMessage;
        this.x65_1 = message;
        this.y65_1 = readBy;
        this.z65_1 = created;
      }
      f40() {
        return this.q65_1;
      }
      v91() {
        return this.y65_1;
      }
      v92() {
        return plus(this.y65_1, this.u65_1);
      }
      w92(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created) {
        return new (IncidentMessageComment())(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created);
      }
      b66(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created, $super) {
        _id = _id === VOID ? this.q65_1 : _id;
        incidentMessage = incidentMessage === VOID ? this.r65_1 : incidentMessage;
        project = project === VOID ? this.s65_1 : project;
        incident = incident === VOID ? this.t65_1 : incident;
        sender = sender === VOID ? this.u65_1 : sender;
        senderName = senderName === VOID ? this.v65_1 : senderName;
        clientMessage = clientMessage === VOID ? this.w65_1 : clientMessage;
        message = message === VOID ? this.x65_1 : message;
        readBy = readBy === VOID ? this.y65_1 : readBy;
        created = created === VOID ? this.z65_1 : created;
        return $super === VOID ? this.w92(_id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created) : $super.w92.call(this, _id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created);
      }
      toString() {
        return 'IncidentMessageComment(_id=' + this.q65_1.toString() + ', incidentMessage=' + this.r65_1.toString() + ', project=' + this.s65_1.toString() + ', incident=' + this.t65_1.toString() + ', sender=' + this.u65_1.toString() + ', senderName=' + this.v65_1 + ', clientMessage=' + this.w65_1 + ', message=' + this.x65_1 + ', readBy=' + toString(this.y65_1) + ', created=' + this.z65_1.toString() + ')';
      }
      hashCode() {
        var result = this.q65_1.hashCode();
        result = imul(result, 31) + this.r65_1.hashCode() | 0;
        result = imul(result, 31) + this.s65_1.hashCode() | 0;
        result = imul(result, 31) + this.t65_1.hashCode() | 0;
        result = imul(result, 31) + this.u65_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.v65_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w65_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x65_1) | 0;
        result = imul(result, 31) + hashCode(this.y65_1) | 0;
        result = imul(result, 31) + this.z65_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IncidentMessageComment()))
          return false;
        if (!this.q65_1.equals(other.q65_1))
          return false;
        if (!this.r65_1.equals(other.r65_1))
          return false;
        if (!this.s65_1.equals(other.s65_1))
          return false;
        if (!this.t65_1.equals(other.t65_1))
          return false;
        if (!this.u65_1.equals(other.u65_1))
          return false;
        if (!(this.v65_1 === other.v65_1))
          return false;
        if (!(this.w65_1 === other.w65_1))
          return false;
        if (!(this.x65_1 === other.x65_1))
          return false;
        if (!equals(this.y65_1, other.y65_1))
          return false;
        if (!this.z65_1.equals(other.z65_1))
          return false;
        return true;
      }
      static o94(seen0, _id, incidentMessage, project, incident, sender, senderName, clientMessage, message, readBy, created, serializationConstructorMarker) {
        Companion_getInstance_28();
        if (!(222 === (222 & seen0))) {
          throwMissingFieldException(seen0, 222, $serializer_getInstance_29().m94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.q65_1 = Companion_getInstance().k2p();
        else
          $this.q65_1 = _id;
        $this.r65_1 = incidentMessage;
        $this.s65_1 = project;
        $this.t65_1 = incident;
        $this.u65_1 = sender;
        if (0 === (seen0 & 32))
          $this.v65_1 = '';
        else
          $this.v65_1 = senderName;
        $this.w65_1 = clientMessage;
        $this.x65_1 = message;
        if (0 === (seen0 & 256))
          $this.y65_1 = emptySet();
        else
          $this.y65_1 = readBy;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.z65_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.z65_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'IncidentMessageComment', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_29});
    IncidentMessageCommentClass = $;
  }
  return IncidentMessageCommentClass;
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      constructor() {
        Companion_instance_17 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q6a_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, null, tmp_9, null, lazy(tmp_10, ItemChange$Companion$$childSerializers$_anonymous__pqnnuh_4)];
      }
      k2a() {
        return $serializer_getInstance_30();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_17;
function Companion_getInstance_29() {
  if (Companion_instance_17 === VOID)
    new (Companion_15())();
  return Companion_instance_17;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ItemChange', this, 11);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('changeRequest', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.a1b('itemId', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('linked', true);
        tmp0_serialDesc.a1b('updatedDescription', true);
        tmp0_serialDesc.a1b('priceChange', true);
        tmp0_serialDesc.a1b('cancelled', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('itemNumber', true);
        tmp0_serialDesc.a1b('readBy', true);
        this.p94_1 = tmp0_serialDesc;
      }
      q94(encoder, value) {
        var tmp0_desc = this.p94_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_29().q6a_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.v6a_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.v6a_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.w6a_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.x6a_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.y6a_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.z6a_1 === false)) {
          tmp1_output.s14(tmp0_desc, 4, value.z6a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.a6b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.a6b_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          var tmp_0 = value.b6b_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.b6b_1;
          tmp1_output.d15(tmp0_desc, 6, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.c6b_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.c6b_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp_3 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp_3 = !value.d6b_1.equals(tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.d6b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.e6b_1 === '1')) {
          tmp1_output.a15(tmp0_desc, 9, value.e6b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !equals(value.f6b_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 10, tmp2_cached[10].f2(), value.f6b_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q94(encoder, value instanceof ItemChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p94_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.l13(tmp0_desc);
        var tmp16_cached = Companion_getInstance_29().q6a_1;
        if (tmp15_input.a14()) {
          tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.x13(tmp0_desc, 1, tmp16_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.x13(tmp0_desc, 2, tmp16_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.x13(tmp0_desc, 3, tmp16_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp10_local6;
          var tmp_1 = tmp15_input.z13(tmp0_desc, 6, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp10_local6 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.x13(tmp0_desc, 8, tmp16_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.v13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.x13(tmp0_desc, 10, tmp16_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.x13(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.x13(tmp0_desc, 1, tmp16_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.x13(tmp0_desc, 2, tmp16_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.x13(tmp0_desc, 3, tmp16_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp10_local6;
                var tmp_4 = tmp15_input.z13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp10_local6 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.x13(tmp0_desc, 8, tmp16_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.v13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.x13(tmp0_desc, 10, tmp16_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp15_input.m13(tmp0_desc);
        return ItemChange().r94(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.p94_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_29().q6a_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), BooleanSerializer_getInstance(), tmp0_cached[8].f2(), StringSerializer_getInstance(), tmp0_cached[10].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_30() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var ItemChangeClass;
function ItemChange() {
  if (ItemChangeClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy) {
        Companion_getInstance_29();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        linked = linked === VOID ? false : linked;
        updatedDescription = updatedDescription === VOID ? null : updatedDescription;
        priceChange = priceChange === VOID ? null : priceChange;
        cancelled = cancelled === VOID ? false : cancelled;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        itemNumber = itemNumber === VOID ? '1' : itemNumber;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.v6a_1 = _id;
        this.w6a_1 = project;
        this.x6a_1 = changeRequest;
        this.y6a_1 = itemId;
        this.z6a_1 = linked;
        this.a6b_1 = updatedDescription;
        this.b6b_1 = priceChange;
        this.c6b_1 = cancelled;
        this.d6b_1 = created;
        this.e6b_1 = itemNumber;
        this.f6b_1 = readBy;
      }
      f40() {
        return this.v6a_1;
      }
      s94() {
        return this.x6a_1;
      }
      t94() {
        return this.y6a_1;
      }
      u94() {
        return this.z6a_1;
      }
      v94() {
        return this.a6b_1;
      }
      w94() {
        return this.b6b_1;
      }
      x94() {
        return this.c6b_1;
      }
      y94() {
        return this.e6b_1;
      }
      v91() {
        return this.f6b_1;
      }
      z94() {
        return this.d6b_1;
      }
      a95() {
        return null;
      }
      b95() {
        return this.c6b_1 ? ChangeType_Remove_getInstance() : ChangeType_Modify_getInstance();
      }
      c95() {
        var tmp0_elvis_lhs = this.b6b_1;
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = _MonetaryValue___init__impl__jsc11x(0n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      e26() {
        return this.e6b_1;
      }
      d95() {
        return this.d6b_1;
      }
      h94() {
        return this.b95().h95_1;
      }
      i95(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy) {
        return new (ItemChange())(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy);
      }
      h6b(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy, $super) {
        _id = _id === VOID ? this.v6a_1 : _id;
        project = project === VOID ? this.w6a_1 : project;
        changeRequest = changeRequest === VOID ? this.x6a_1 : changeRequest;
        itemId = itemId === VOID ? this.y6a_1 : itemId;
        linked = linked === VOID ? this.z6a_1 : linked;
        updatedDescription = updatedDescription === VOID ? this.a6b_1 : updatedDescription;
        priceChange = priceChange === VOID ? this.b6b_1 : priceChange;
        cancelled = cancelled === VOID ? this.c6b_1 : cancelled;
        created = created === VOID ? this.d6b_1 : created;
        itemNumber = itemNumber === VOID ? this.e6b_1 : itemNumber;
        readBy = readBy === VOID ? this.f6b_1 : readBy;
        var tmp;
        if ($super === VOID) {
          tmp = this.i95(_id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy);
        } else {
          var tmp_0 = $super.i95;
          var tmp_1 = priceChange;
          tmp = tmp_0.call(this, _id, project, changeRequest, itemId, linked, updatedDescription, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), cancelled, created, itemNumber, readBy);
        }
        return tmp;
      }
      toString() {
        var tmp = this.v6a_1.toString();
        var tmp_0 = this.w6a_1.toString();
        var tmp_1 = this.x6a_1.toString();
        var tmp_2 = this.y6a_1.toString();
        var tmp_3 = this.b6b_1;
        return 'ItemChange(_id=' + tmp + ', project=' + tmp_0 + ', changeRequest=' + tmp_1 + ', itemId=' + tmp_2 + ', linked=' + this.z6a_1 + ', updatedDescription=' + this.a6b_1 + ', priceChange=' + toString_0(tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) + ', cancelled=' + this.c6b_1 + ', created=' + this.d6b_1.toString() + ', itemNumber=' + this.e6b_1 + ', readBy=' + toString(this.f6b_1) + ')';
      }
      hashCode() {
        var result = this.v6a_1.hashCode();
        result = imul(result, 31) + this.w6a_1.hashCode() | 0;
        result = imul(result, 31) + this.x6a_1.hashCode() | 0;
        result = imul(result, 31) + this.y6a_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.z6a_1) | 0;
        result = imul(result, 31) + (this.a6b_1 == null ? 0 : getStringHashCode(this.a6b_1)) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.b6b_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.b6b_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c6b_1) | 0;
        result = imul(result, 31) + this.d6b_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.e6b_1) | 0;
        result = imul(result, 31) + hashCode(this.f6b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ItemChange()))
          return false;
        if (!this.v6a_1.equals(other.v6a_1))
          return false;
        if (!this.w6a_1.equals(other.w6a_1))
          return false;
        if (!this.x6a_1.equals(other.x6a_1))
          return false;
        if (!this.y6a_1.equals(other.y6a_1))
          return false;
        if (!(this.z6a_1 === other.z6a_1))
          return false;
        if (!(this.a6b_1 == other.a6b_1))
          return false;
        var tmp = this.b6b_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.b6b_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!(this.c6b_1 === other.c6b_1))
          return false;
        if (!this.d6b_1.equals(other.d6b_1))
          return false;
        if (!(this.e6b_1 === other.e6b_1))
          return false;
        if (!equals(this.f6b_1, other.f6b_1))
          return false;
        return true;
      }
      static r94(seen0, _id, project, changeRequest, itemId, linked, updatedDescription, priceChange, cancelled, created, itemNumber, readBy, serializationConstructorMarker) {
        Companion_getInstance_29();
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_30().p94_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.v6a_1 = Companion_getInstance().k2p();
        else
          $this.v6a_1 = _id;
        $this.w6a_1 = project;
        $this.x6a_1 = changeRequest;
        $this.y6a_1 = itemId;
        if (0 === (seen0 & 16))
          $this.z6a_1 = false;
        else
          $this.z6a_1 = linked;
        if (0 === (seen0 & 32))
          $this.a6b_1 = null;
        else
          $this.a6b_1 = updatedDescription;
        if (0 === (seen0 & 64))
          $this.b6b_1 = null;
        else
          $this.b6b_1 = priceChange;
        if (0 === (seen0 & 128))
          $this.c6b_1 = false;
        else
          $this.c6b_1 = cancelled;
        if (0 === (seen0 & 256)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.d6b_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.d6b_1 = created;
        if (0 === (seen0 & 512))
          $this.e6b_1 = '1';
        else
          $this.e6b_1 = itemNumber;
        if (0 === (seen0 & 1024))
          $this.f6b_1 = emptySet();
        else
          $this.f6b_1 = readBy;
        return $this;
      }
    }
    protoOf($).j95 = get_withdrawn;
    initMetadataForClass($, 'ItemChange', VOID, VOID, [HasId(), ItemChangeInterface(), ChangeRequestItem(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_30});
    ItemChangeClass = $;
  }
  return ItemChangeClass;
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      constructor() {
        Companion_instance_18 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j6d_1 = [tmp_1, null, tmp_3, tmp_5, lazy(tmp_6, LegalDocumentAgreement$Companion$$childSerializers$_anonymous__u4pl84_2)];
      }
      k2a() {
        return $serializer_getInstance_31();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_18;
function Companion_getInstance_30() {
  if (Companion_instance_18 === VOID)
    new (Companion_16())();
  return Companion_instance_18;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LegalDocumentAgreement', this, 5);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('accessInfo', false);
        tmp0_serialDesc.a1b('contractor', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.a1b('document', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(CrowPayLegalDocument())));
        tmp0_serialDesc.a1b('user', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (References())(getKClass(User())));
        this.k95_1 = tmp0_serialDesc;
      }
      l95(encoder, value) {
        var tmp0_desc = this.k95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_30().j6d_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.q6d_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.q6d_1);
        }
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_4(), value.r6d_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.s6d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.s6d_1);
        }
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.t6d_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.u6d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.u6d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l95(encoder, value instanceof LegalDocumentAgreement() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_30().j6d_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return LegalDocumentAgreement().m95(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.k95_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_30().j6d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), $serializer_getInstance_4(), get_nullable(tmp0_cached[2].f2()), tmp0_cached[3].f2(), get_nullable(tmp0_cached[4].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_31() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var LegalDocumentAgreementClass;
function LegalDocumentAgreement() {
  if (LegalDocumentAgreementClass === VOID) {
    class $ {
      constructor(_id, accessInfo, contractor, document, user) {
        Companion_getInstance_30();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        contractor = contractor === VOID ? null : contractor;
        user = user === VOID ? null : user;
        this.q6d_1 = _id;
        this.r6d_1 = accessInfo;
        this.s6d_1 = contractor;
        this.t6d_1 = document;
        this.u6d_1 = user;
      }
      f40() {
        return this.q6d_1;
      }
      n95(_id, accessInfo, contractor, document, user) {
        return new (LegalDocumentAgreement())(_id, accessInfo, contractor, document, user);
      }
      w6d(_id, accessInfo, contractor, document, user, $super) {
        _id = _id === VOID ? this.q6d_1 : _id;
        accessInfo = accessInfo === VOID ? this.r6d_1 : accessInfo;
        contractor = contractor === VOID ? this.s6d_1 : contractor;
        document = document === VOID ? this.t6d_1 : document;
        user = user === VOID ? this.u6d_1 : user;
        return $super === VOID ? this.n95(_id, accessInfo, contractor, document, user) : $super.n95.call(this, _id, accessInfo, contractor, document, user);
      }
      toString() {
        return 'LegalDocumentAgreement(_id=' + this.q6d_1.toString() + ', accessInfo=' + this.r6d_1.toString() + ', contractor=' + toString_0(this.s6d_1) + ', document=' + this.t6d_1.toString() + ', user=' + toString_0(this.u6d_1) + ')';
      }
      hashCode() {
        var result = this.q6d_1.hashCode();
        result = imul(result, 31) + this.r6d_1.hashCode() | 0;
        result = imul(result, 31) + (this.s6d_1 == null ? 0 : this.s6d_1.hashCode()) | 0;
        result = imul(result, 31) + this.t6d_1.hashCode() | 0;
        result = imul(result, 31) + (this.u6d_1 == null ? 0 : this.u6d_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LegalDocumentAgreement()))
          return false;
        if (!this.q6d_1.equals(other.q6d_1))
          return false;
        if (!this.r6d_1.equals(other.r6d_1))
          return false;
        if (!equals(this.s6d_1, other.s6d_1))
          return false;
        if (!this.t6d_1.equals(other.t6d_1))
          return false;
        if (!equals(this.u6d_1, other.u6d_1))
          return false;
        return true;
      }
      static m95(seen0, _id, accessInfo, contractor, document, user, serializationConstructorMarker) {
        Companion_getInstance_30();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_31().k95_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.q6d_1 = Companion_getInstance().k2p();
        else
          $this.q6d_1 = _id;
        $this.r6d_1 = accessInfo;
        if (0 === (seen0 & 4))
          $this.s6d_1 = null;
        else
          $this.s6d_1 = contractor;
        $this.t6d_1 = document;
        if (0 === (seen0 & 16))
          $this.u6d_1 = null;
        else
          $this.u6d_1 = user;
        return $this;
      }
    }
    initMetadataForClass($, 'LegalDocumentAgreement', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_31});
    LegalDocumentAgreementClass = $;
  }
  return LegalDocumentAgreementClass;
}
function License$Companion$$childSerializers$_anonymous__r2xgkp() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_1() {
  return Companion_getInstance_2().k2a();
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_2() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_3() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function License$Companion$$childSerializers$_anonymous__r2xgkp_4() {
  return Companion_getInstance_6().k2a();
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, License$Companion$$childSerializers$_anonymous__r2xgkp);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, License$Companion$$childSerializers$_anonymous__r2xgkp_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, License$Companion$$childSerializers$_anonymous__r2xgkp_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, License$Companion$$childSerializers$_anonymous__r2xgkp_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, License$Companion$$childSerializers$_anonymous__r2xgkp_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p6e_1 = [tmp_1, tmp_3, null, null, tmp_5, tmp_7, null, tmp_9, lazy(tmp_10, License$Companion$$childSerializers$_anonymous__r2xgkp_4)];
      }
      k2a() {
        return $serializer_getInstance_32();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_19;
function Companion_getInstance_31() {
  if (Companion_instance_19 === VOID)
    new (Companion_17())();
  return Companion_instance_19;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.License', this, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('contractor', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.a1b('number', false);
        tmp0_serialDesc.a1b('city', true);
        tmp0_serialDesc.a1b('state', false);
        tmp0_serialDesc.a1b('file', false);
        tmp0_serialDesc.a1b('fileType', false);
        tmp0_serialDesc.a1b('preview', true);
        tmp0_serialDesc.a1b('type', false);
        this.o95_1 = tmp0_serialDesc;
      }
      p95(encoder, value) {
        var tmp0_desc = this.o95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_31().p6e_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.u6e_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.u6e_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.v6e_1);
        tmp1_output.a15(tmp0_desc, 2, value.w6e_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.x6e_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.x6e_1);
        }
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.y6e_1);
        tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), new (ServerFile())(value.z6e_1));
        tmp1_output.a15(tmp0_desc, 6, value.a6f_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp = true;
        } else {
          var tmp_0 = value.b6f_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[7].f2();
          var tmp_2 = value.b6f_1;
          tmp1_output.d15(tmp0_desc, 7, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.c6f_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.p95(encoder, value instanceof License() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.o95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_31().p6e_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.x13(tmp0_desc, 4, tmp14_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = tmp14_cached[5].f2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp13_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_2 = tmp14_cached[7].f2();
          var tmp_3 = tmp11_local7;
          var tmp_4 = tmp13_input.z13(tmp0_desc, 7, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp11_local7 = tmp_4 == null ? null : tmp_4.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.x13(tmp0_desc, 4, tmp14_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_5 = tmp14_cached[5].f2();
                var tmp_6 = tmp9_local5;
                var tmp_7 = tmp13_input.x13(tmp0_desc, 5, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
                tmp9_local5 = tmp_7 == null ? null : tmp_7.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_8 = tmp14_cached[7].f2();
                var tmp_9 = tmp11_local7;
                var tmp_10 = tmp13_input.z13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp11_local7 = tmp_10 == null ? null : tmp_10.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return License().q95(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.o95_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_31().p6e_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[4].f2(), tmp0_cached[5].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[7].f2()), tmp0_cached[8].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_32() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
var LicenseClass;
function License() {
  if (LicenseClass === VOID) {
    class $ {
      constructor(_id, contractor, number, city, state, file, fileType, preview, type) {
        Companion_getInstance_31();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        city = city === VOID ? null : city;
        preview = preview === VOID ? null : preview;
        this.u6e_1 = _id;
        this.v6e_1 = contractor;
        this.w6e_1 = number;
        this.x6e_1 = city;
        this.y6e_1 = state;
        this.z6e_1 = file;
        this.a6f_1 = fileType;
        this.b6f_1 = preview;
        this.c6f_1 = type;
      }
      f40() {
        return this.u6e_1;
      }
      i93() {
        return this.z6e_1;
      }
      h93() {
        return this.a6f_1;
      }
      j93() {
        return this.b6f_1;
      }
      i20() {
        return this.w6e_1;
      }
      r95(_id, contractor, number, city, state, file, fileType, preview, type) {
        return new (License())(_id, contractor, number, city, state, file, fileType, preview, type);
      }
      e6f(_id, contractor, number, city, state, file, fileType, preview, type, $super) {
        _id = _id === VOID ? this.u6e_1 : _id;
        contractor = contractor === VOID ? this.v6e_1 : contractor;
        number = number === VOID ? this.w6e_1 : number;
        city = city === VOID ? this.x6e_1 : city;
        state = state === VOID ? this.y6e_1 : state;
        file = file === VOID ? this.z6e_1 : file;
        fileType = fileType === VOID ? this.a6f_1 : fileType;
        preview = preview === VOID ? this.b6f_1 : preview;
        type = type === VOID ? this.c6f_1 : type;
        var tmp;
        if ($super === VOID) {
          tmp = this.r95(_id, contractor, number, city, state, file, fileType, preview, type);
        } else {
          var tmp_0 = $super.r95;
          var tmp_1 = preview;
          tmp = tmp_0.call(this, _id, contractor, number, city, state, new (ServerFile())(file), fileType, tmp_1 == null ? null : new (ServerFile())(tmp_1), type);
        }
        return tmp;
      }
      toString() {
        var tmp = this.u6e_1.toString();
        var tmp_0 = this.v6e_1.toString();
        var tmp_1 = this.y6e_1.toString();
        var tmp_2 = ServerFile__toString_impl_4rulpa(this.z6e_1);
        var tmp_3 = this.b6f_1;
        return 'License(_id=' + tmp + ', contractor=' + tmp_0 + ', number=' + this.w6e_1 + ', city=' + this.x6e_1 + ', state=' + tmp_1 + ', file=' + tmp_2 + ', fileType=' + this.a6f_1 + ', preview=' + toString_0(tmp_3 == null ? null : new (ServerFile())(tmp_3)) + ', type=' + this.c6f_1.toString() + ')';
      }
      hashCode() {
        var result = this.u6e_1.hashCode();
        result = imul(result, 31) + this.v6e_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.w6e_1) | 0;
        result = imul(result, 31) + (this.x6e_1 == null ? 0 : getStringHashCode(this.x6e_1)) | 0;
        result = imul(result, 31) + this.y6e_1.hashCode() | 0;
        result = imul(result, 31) + ServerFile__hashCode_impl_qj0ii5(this.z6e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6f_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.b6f_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.b6f_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + this.c6f_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof License()))
          return false;
        if (!this.u6e_1.equals(other.u6e_1))
          return false;
        if (!this.v6e_1.equals(other.v6e_1))
          return false;
        if (!(this.w6e_1 === other.w6e_1))
          return false;
        if (!(this.x6e_1 == other.x6e_1))
          return false;
        if (!this.y6e_1.equals(other.y6e_1))
          return false;
        if (!(this.z6e_1 === other.z6e_1))
          return false;
        if (!(this.a6f_1 === other.a6f_1))
          return false;
        var tmp = this.b6f_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.b6f_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!this.c6f_1.equals(other.c6f_1))
          return false;
        return true;
      }
      static q95(seen0, _id, contractor, number, city, state, file, fileType, preview, type, serializationConstructorMarker) {
        Companion_getInstance_31();
        if (!(374 === (374 & seen0))) {
          throwMissingFieldException(seen0, 374, $serializer_getInstance_32().o95_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.u6e_1 = Companion_getInstance().k2p();
        else
          $this.u6e_1 = _id;
        $this.v6e_1 = contractor;
        $this.w6e_1 = number;
        if (0 === (seen0 & 8))
          $this.x6e_1 = null;
        else
          $this.x6e_1 = city;
        $this.y6e_1 = state;
        $this.z6e_1 = file;
        $this.a6f_1 = fileType;
        if (0 === (seen0 & 128))
          $this.b6f_1 = null;
        else
          $this.b6f_1 = preview;
        $this.c6f_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'License', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_32});
    LicenseClass = $;
  }
  return LicenseClass;
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      constructor() {
        Companion_instance_20 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.r6g_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, tmp_9, tmp_11, lazy(tmp_12, LineItemCompletionMessage$Companion$$childSerializers$_anonymous__xgiz7e_5), null];
      }
      k2a() {
        return $serializer_getInstance_33();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_20;
function Companion_getInstance_32() {
  if (Companion_instance_20 === VOID)
    new (Companion_18())();
  return Companion_instance_20;
}
var $serializerClass_17;
function $serializer_17() {
  if ($serializerClass_17 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LineItemCompletionMessage', this, 11);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lineItem', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('sender', false);
        tmp0_serialDesc.a1b('clientMessage', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('responseTypeSerializable', false);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('attachments', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('needsResponse', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.s95_1 = tmp0_serialDesc;
      }
      t95(encoder, value) {
        var tmp0_desc = this.s95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_32().r6g_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.w6g_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.w6g_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.x6g_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.y6g_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.z6g_1);
        tmp1_output.s14(tmp0_desc, 4, value.a6h_1);
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_14(), value.b6h_1);
        tmp1_output.a15(tmp0_desc, 6, value.c6h_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.d6h_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.d6h_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.e6h_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.e6h_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !equals(value.f6h_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.f6h_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.g6h_1 === true)) {
          tmp1_output.s14(tmp0_desc, 10, value.g6h_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t95(encoder, value instanceof LineItemCompletionMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_32().r6g_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.x13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_14(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.x13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_14(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.x13(tmp0_desc, 9, tmp17_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.n13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return LineItemCompletionMessage().u95(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.s95_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_32().r6g_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), BooleanSerializer_getInstance(), $serializer_getInstance_14(), StringSerializer_getInstance(), tmp0_cached[7].f2(), tmp0_cached[8].f2(), tmp0_cached[9].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_17 = $;
  }
  return $serializerClass_17;
}
var $serializer_instance_17;
function $serializer_getInstance_33() {
  if ($serializer_instance_17 === VOID)
    new ($serializer_17())();
  return $serializer_instance_17;
}
function LineItemCompletionMessage$_get_responseType_$ref_csbgtd() {
  return (p0) => p0.d8w();
}
var LineItemCompletionMessageClass;
function LineItemCompletionMessage() {
  if (LineItemCompletionMessageClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse) {
        Companion_getInstance_32();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        attachments = attachments === VOID ? emptyList() : attachments;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        needsResponse = needsResponse === VOID ? true : needsResponse;
        this.w6g_1 = _id;
        this.x6g_1 = project;
        this.y6g_1 = lineItem;
        this.z6g_1 = sender;
        this.a6h_1 = clientMessage;
        this.b6h_1 = responseTypeSerializable;
        this.c6h_1 = message;
        this.d6h_1 = attachments;
        this.e6h_1 = created;
        this.f6h_1 = readBy;
        this.g6h_1 = needsResponse;
        var tmp_0 = this;
        tmp_0.h6h_1 = lazy_0(() => parseResponse_0(this.b6h_1));
      }
      f40() {
        return this.w6g_1;
      }
      j94() {
        return this.z6g_1;
      }
      i94() {
        return this.a6h_1;
      }
      j() {
        return this.c6h_1;
      }
      k94() {
        return this.e6h_1;
      }
      v91() {
        return this.f6h_1;
      }
      d8w() {
        var tmp0 = this.h6h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('responseType', 1, tmp, LineItemCompletionMessage$_get_responseType_$ref_csbgtd(), null);
        return tmp0.f2();
      }
      v95(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse) {
        return new (LineItemCompletionMessage())(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse);
      }
      j6h(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse, $super) {
        _id = _id === VOID ? this.w6g_1 : _id;
        project = project === VOID ? this.x6g_1 : project;
        lineItem = lineItem === VOID ? this.y6g_1 : lineItem;
        sender = sender === VOID ? this.z6g_1 : sender;
        clientMessage = clientMessage === VOID ? this.a6h_1 : clientMessage;
        responseTypeSerializable = responseTypeSerializable === VOID ? this.b6h_1 : responseTypeSerializable;
        message = message === VOID ? this.c6h_1 : message;
        attachments = attachments === VOID ? this.d6h_1 : attachments;
        created = created === VOID ? this.e6h_1 : created;
        readBy = readBy === VOID ? this.f6h_1 : readBy;
        needsResponse = needsResponse === VOID ? this.g6h_1 : needsResponse;
        return $super === VOID ? this.v95(_id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse) : $super.v95.call(this, _id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse);
      }
      toString() {
        return 'LineItemCompletionMessage(_id=' + this.w6g_1.toString() + ', project=' + this.x6g_1.toString() + ', lineItem=' + this.y6g_1.toString() + ', sender=' + this.z6g_1.toString() + ', clientMessage=' + this.a6h_1 + ', responseTypeSerializable=' + this.b6h_1.toString() + ', message=' + this.c6h_1 + ', attachments=' + toString(this.d6h_1) + ', created=' + this.e6h_1.toString() + ', readBy=' + toString(this.f6h_1) + ', needsResponse=' + this.g6h_1 + ')';
      }
      hashCode() {
        var result = this.w6g_1.hashCode();
        result = imul(result, 31) + this.x6g_1.hashCode() | 0;
        result = imul(result, 31) + this.y6g_1.hashCode() | 0;
        result = imul(result, 31) + this.z6g_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.a6h_1) | 0;
        result = imul(result, 31) + this.b6h_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.c6h_1) | 0;
        result = imul(result, 31) + hashCode(this.d6h_1) | 0;
        result = imul(result, 31) + this.e6h_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.f6h_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.g6h_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemCompletionMessage()))
          return false;
        if (!this.w6g_1.equals(other.w6g_1))
          return false;
        if (!this.x6g_1.equals(other.x6g_1))
          return false;
        if (!this.y6g_1.equals(other.y6g_1))
          return false;
        if (!this.z6g_1.equals(other.z6g_1))
          return false;
        if (!(this.a6h_1 === other.a6h_1))
          return false;
        if (!this.b6h_1.equals(other.b6h_1))
          return false;
        if (!(this.c6h_1 === other.c6h_1))
          return false;
        if (!equals(this.d6h_1, other.d6h_1))
          return false;
        if (!this.e6h_1.equals(other.e6h_1))
          return false;
        if (!equals(this.f6h_1, other.f6h_1))
          return false;
        if (!(this.g6h_1 === other.g6h_1))
          return false;
        return true;
      }
      static u95(seen0, _id, project, lineItem, sender, clientMessage, responseTypeSerializable, message, attachments, created, readBy, needsResponse, serializationConstructorMarker) {
        Companion_getInstance_32();
        if (!(126 === (126 & seen0))) {
          throwMissingFieldException(seen0, 126, $serializer_getInstance_33().s95_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.w6g_1 = Companion_getInstance().k2p();
        else
          $this.w6g_1 = _id;
        $this.x6g_1 = project;
        $this.y6g_1 = lineItem;
        $this.z6g_1 = sender;
        $this.a6h_1 = clientMessage;
        $this.b6h_1 = responseTypeSerializable;
        $this.c6h_1 = message;
        if (0 === (seen0 & 128))
          $this.d6h_1 = emptyList();
        else
          $this.d6h_1 = attachments;
        if (0 === (seen0 & 256)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.e6h_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.e6h_1 = created;
        if (0 === (seen0 & 512))
          $this.f6h_1 = emptySet();
        else
          $this.f6h_1 = readBy;
        if (0 === (seen0 & 1024))
          $this.g6h_1 = true;
        else
          $this.g6h_1 = needsResponse;
        var tmp_0 = $this;
        tmp_0.h6h_1 = lazy_0(() => parseResponse_0($this.b6h_1));
        return $this;
      }
    }
    initMetadataForClass($, 'LineItemCompletionMessage', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_33});
    LineItemCompletionMessageClass = $;
  }
  return LineItemCompletionMessageClass;
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_34();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_21;
function Companion_getInstance_33() {
  return Companion_instance_21;
}
var $serializerClass_18;
function $serializer_18() {
  if ($serializerClass_18 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_18 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MailCheckPhysically.Request', this, 2);
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('address', false);
        this.w95_1 = tmp0_serialDesc;
      }
      x95(encoder, value) {
        var tmp0_desc = this.w95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.v7y_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_5(), value.w7y_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x95(encoder, value instanceof Request() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return Request().y95(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.w95_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_5()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_18 = $;
  }
  return $serializerClass_18;
}
var $serializer_instance_18;
function $serializer_getInstance_34() {
  if ($serializer_instance_18 === VOID)
    new ($serializer_18())();
  return $serializer_instance_18;
}
function MailCheckPhysically$ConfirmedShipped$Companion$$childSerializers$_anonymous__o7pdax() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      constructor() {
        Companion_instance_22 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j8q_1 = [null, null, lazy(tmp_0, MailCheckPhysically$ConfirmedShipped$Companion$$childSerializers$_anonymous__o7pdax)];
      }
      k2a() {
        return $serializer_getInstance_35();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_22;
function Companion_getInstance_34() {
  if (Companion_instance_22 === VOID)
    new (Companion_20())();
  return Companion_instance_22;
}
var $serializerClass_19;
function $serializer_19() {
  if ($serializerClass_19 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MailCheckPhysically.ConfirmedShipped', this, 3);
        tmp0_serialDesc.a1b('admin', false);
        tmp0_serialDesc.a1b('ip', false);
        tmp0_serialDesc.a1b('timestamp', false);
        this.z95_1 = tmp0_serialDesc;
      }
      a96(encoder, value) {
        var tmp0_desc = this.z95_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_34().j8q_1;
        tmp1_output.a15(tmp0_desc, 0, value.b96_1);
        tmp1_output.a15(tmp0_desc, 1, value.c96_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.d96_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a96(encoder, value instanceof ConfirmedShipped() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z95_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_34().j8q_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ConfirmedShipped().e96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.z95_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_34().j8q_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_19 = $;
  }
  return $serializerClass_19;
}
var $serializer_instance_19;
function $serializer_getInstance_35() {
  if ($serializer_instance_19 === VOID)
    new ($serializer_19())();
  return $serializer_instance_19;
}
function MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var RequestClass;
function Request() {
  if (RequestClass === VOID) {
    class $ {
      constructor(name, address) {
        this.v7y_1 = name;
        this.w7y_1 = address;
      }
      f96(name, address) {
        return new (Request())(name, address);
      }
      y7y(name, address, $super) {
        name = name === VOID ? this.v7y_1 : name;
        address = address === VOID ? this.w7y_1 : address;
        return $super === VOID ? this.f96(name, address) : $super.f96.call(this, name, address);
      }
      toString() {
        return 'Request(name=' + this.v7y_1 + ', address=' + this.w7y_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.v7y_1);
        result = imul(result, 31) + this.w7y_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Request()))
          return false;
        if (!(this.v7y_1 === other.v7y_1))
          return false;
        if (!this.w7y_1.equals(other.w7y_1))
          return false;
        return true;
      }
      static y95(seen0, name, address, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_34().w95_1);
        }
        var $this = createThis(this);
        $this.v7y_1 = name;
        $this.w7y_1 = address;
        return $this;
      }
    }
    initMetadataForClass($, 'Request', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
    RequestClass = $;
  }
  return RequestClass;
}
var ConfirmedShippedClass;
function ConfirmedShipped() {
  if (ConfirmedShippedClass === VOID) {
    class $ {
      toString() {
        return 'ConfirmedShipped(admin=' + this.b96_1 + ', ip=' + this.c96_1 + ', timestamp=' + this.d96_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.b96_1);
        result = imul(result, 31) + getStringHashCode(this.c96_1) | 0;
        result = imul(result, 31) + this.d96_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ConfirmedShipped()))
          return false;
        if (!(this.b96_1 === other.b96_1))
          return false;
        if (!(this.c96_1 === other.c96_1))
          return false;
        if (!this.d96_1.equals(other.d96_1))
          return false;
        return true;
      }
      static e96(seen0, admin, ip, timestamp, serializationConstructorMarker) {
        Companion_getInstance_34();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_35().z95_1);
        }
        var $this = createThis(this);
        $this.b96_1 = admin;
        $this.c96_1 = ip;
        $this.d96_1 = timestamp;
        return $this;
      }
    }
    initMetadataForClass($, 'ConfirmedShipped', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
    ConfirmedShippedClass = $;
  }
  return ConfirmedShippedClass;
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      constructor() {
        Companion_instance_23 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w6q_1 = [tmp_1, tmp_3, lazy(tmp_4, MailCheckPhysically$Companion$$childSerializers$_anonymous__v5r13p_1), null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_36();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_23;
function Companion_getInstance_35() {
  if (Companion_instance_23 === VOID)
    new (Companion_21())();
  return Companion_instance_23;
}
var $serializerClass_20;
function $serializer_20() {
  if ($serializerClass_20 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_20 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MailCheckPhysically', this, 7);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('user', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(User())));
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('address', false);
        tmp0_serialDesc.a1b('amount', false);
        tmp0_serialDesc.a1b('confirmed', true);
        this.g96_1 = tmp0_serialDesc;
      }
      h96(encoder, value) {
        var tmp0_desc = this.g96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_35().w6q_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d6r_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d6r_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.e6r_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.f6r_1);
        tmp1_output.a15(tmp0_desc, 3, value.g6r_1);
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance_5(), value.h6r_1);
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.i6r_1));
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.j6r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_35(), value.j6r_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h96(encoder, value instanceof MailCheckPhysically() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_35().w6q_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp11_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, $serializer_getInstance_35(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, tmp12_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp11_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, $serializer_getInstance_35(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return MailCheckPhysically().i96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.g96_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_35().w6q_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), $serializer_getInstance_5(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_35())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_20 = $;
  }
  return $serializerClass_20;
}
var $serializer_instance_20;
function $serializer_getInstance_36() {
  if ($serializer_instance_20 === VOID)
    new ($serializer_20())();
  return $serializer_instance_20;
}
var MailCheckPhysicallyClass;
function MailCheckPhysically() {
  if (MailCheckPhysicallyClass === VOID) {
    class $ {
      constructor(_id, user, project, name, address, amount, confirmed) {
        Companion_getInstance_35();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        confirmed = confirmed === VOID ? null : confirmed;
        this.d6r_1 = _id;
        this.e6r_1 = user;
        this.f6r_1 = project;
        this.g6r_1 = name;
        this.h6r_1 = address;
        this.i6r_1 = amount;
        this.j6r_1 = confirmed;
      }
      f40() {
        return this.d6r_1;
      }
      j96(_id, user, project, name, address, amount, confirmed) {
        return new (MailCheckPhysically())(_id, user, project, name, address, amount, confirmed);
      }
      l6r(_id, user, project, name, address, amount, confirmed, $super) {
        _id = _id === VOID ? this.d6r_1 : _id;
        user = user === VOID ? this.e6r_1 : user;
        project = project === VOID ? this.f6r_1 : project;
        name = name === VOID ? this.g6r_1 : name;
        address = address === VOID ? this.h6r_1 : address;
        amount = amount === VOID ? this.i6r_1 : amount;
        confirmed = confirmed === VOID ? this.j6r_1 : confirmed;
        return $super === VOID ? this.j96(_id, user, project, name, address, amount, confirmed) : $super.j96.call(this, _id, user, project, name, address, new (MonetaryValue())(amount), confirmed);
      }
      toString() {
        return 'MailCheckPhysically(_id=' + this.d6r_1.toString() + ', user=' + this.e6r_1.toString() + ', project=' + this.f6r_1.toString() + ', name=' + this.g6r_1 + ', address=' + this.h6r_1.toString() + ', amount=' + MonetaryValue__toString_impl_xslc77(this.i6r_1) + ', confirmed=' + toString_0(this.j6r_1) + ')';
      }
      hashCode() {
        var result = this.d6r_1.hashCode();
        result = imul(result, 31) + this.e6r_1.hashCode() | 0;
        result = imul(result, 31) + this.f6r_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.g6r_1) | 0;
        result = imul(result, 31) + this.h6r_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.i6r_1) | 0;
        result = imul(result, 31) + (this.j6r_1 == null ? 0 : this.j6r_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MailCheckPhysically()))
          return false;
        if (!this.d6r_1.equals(other.d6r_1))
          return false;
        if (!this.e6r_1.equals(other.e6r_1))
          return false;
        if (!this.f6r_1.equals(other.f6r_1))
          return false;
        if (!(this.g6r_1 === other.g6r_1))
          return false;
        if (!this.h6r_1.equals(other.h6r_1))
          return false;
        if (!(this.i6r_1 === other.i6r_1))
          return false;
        if (!equals(this.j6r_1, other.j6r_1))
          return false;
        return true;
      }
      static i96(seen0, _id, user, project, name, address, amount, confirmed, serializationConstructorMarker) {
        Companion_getInstance_35();
        if (!(62 === (62 & seen0))) {
          throwMissingFieldException(seen0, 62, $serializer_getInstance_36().g96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d6r_1 = Companion_getInstance().k2p();
        else
          $this.d6r_1 = _id;
        $this.e6r_1 = user;
        $this.f6r_1 = project;
        $this.g6r_1 = name;
        $this.h6r_1 = address;
        $this.i6r_1 = amount;
        if (0 === (seen0 & 64))
          $this.j6r_1 = null;
        else
          $this.j6r_1 = confirmed;
        return $this;
      }
    }
    initMetadataForClass($, 'MailCheckPhysically', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_36});
    MailCheckPhysicallyClass = $;
  }
  return MailCheckPhysicallyClass;
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      constructor() {
        Companion_instance_24 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j6v_1 = [tmp_1, tmp_3, tmp_5, null, null, null, null, tmp_7, tmp_9, null, lazy(tmp_10, PayAppItem$Companion$$childSerializers$_anonymous__e1zpb6_4)];
      }
      k2a() {
        return $serializer_getInstance_37();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_24;
function Companion_getInstance_36() {
  if (Companion_instance_24 === VOID)
    new (Companion_22())();
  return Companion_instance_24;
}
var $serializerClass_21;
function $serializer_21() {
  if ($serializerClass_21 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_21 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PayAppItem', this, 11);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('payApp', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.a1b('lineItem', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('amount', false);
        tmp0_serialDesc.b1b(new (MonetaryRange())(0n, 2147483647n));
        tmp0_serialDesc.a1b('approved', true);
        tmp0_serialDesc.a1b('denied', true);
        tmp0_serialDesc.a1b('voided', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('submitted', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('accepted', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('readBy', true);
        this.k96_1 = tmp0_serialDesc;
      }
      l96(encoder, value) {
        var tmp0_desc = this.k96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_36().j6v_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.o6v_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.o6v_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.p6v_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.q6v_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_2(), new (MonetaryValue())(value.r6v_1));
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.s6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, $serializer_getInstance_4(), value.s6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.t6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, $serializer_getInstance_8(), value.t6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.u6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_4(), value.u6v_1);
        }
        tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.v6v_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.w6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, tmp2_cached[8].f2(), value.w6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.x6v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, BooleanSerializer_getInstance(), value.x6v_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !equals(value.y6v_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 10, tmp2_cached[10].f2(), value.y6v_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l96(encoder, value instanceof PayAppItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_36().j6v_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp16_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.z13(tmp0_desc, 5, $serializer_getInstance_8(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, $serializer_getInstance_4(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.z13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.x13(tmp0_desc, 10, tmp17_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp7_local3;
                var tmp_4 = tmp16_input.x13(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp7_local3 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, $serializer_getInstance_4(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.z13(tmp0_desc, 5, $serializer_getInstance_8(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, $serializer_getInstance_4(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.x13(tmp0_desc, 7, tmp17_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.z13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.x13(tmp0_desc, 10, tmp17_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return PayAppItem().m96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.k96_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_36().j6v_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_4()), tmp0_cached[7].f2(), get_nullable(tmp0_cached[8].f2()), get_nullable(BooleanSerializer_getInstance()), tmp0_cached[10].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_21 = $;
  }
  return $serializerClass_21;
}
var $serializer_instance_21;
function $serializer_getInstance_37() {
  if ($serializer_instance_21 === VOID)
    new ($serializer_21())();
  return $serializer_instance_21;
}
var PayAppItemClass;
function PayAppItem() {
  if (PayAppItemClass === VOID) {
    class $ {
      constructor(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy) {
        Companion_getInstance_36();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        approved = approved === VOID ? null : approved;
        denied = denied === VOID ? null : denied;
        voided = voided === VOID ? null : voided;
        submitted = submitted === VOID ? null : submitted;
        accepted = accepted === VOID ? null : accepted;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.o6v_1 = _id;
        this.p6v_1 = payApp;
        this.q6v_1 = lineItem;
        this.r6v_1 = amount;
        this.s6v_1 = approved;
        this.t6v_1 = denied;
        this.u6v_1 = voided;
        this.v6v_1 = project;
        this.w6v_1 = submitted;
        this.x6v_1 = accepted;
        this.y6v_1 = readBy;
        this.z6v_1 = !!(!!(!!(!(this.w6v_1 == null) & this.s6v_1 == null) & this.u6v_1 == null) & this.t6v_1 == null);
      }
      f40() {
        return this.o6v_1;
      }
      v91() {
        return this.y6v_1;
      }
      n96() {
        var tmp0_safe_receiver = this.t6v_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d95();
        var tmp;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = this.u6v_1;
          tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.o54_1;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp;
        var tmp_0;
        if (tmp3_elvis_lhs == null) {
          var tmp4_safe_receiver = this.s6v_1;
          tmp_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.o54_1;
        } else {
          tmp_0 = tmp3_elvis_lhs;
        }
        return tmp_0;
      }
      o96() {
        var tmp0_elvis_lhs = this.w6v_1;
        return tmp0_elvis_lhs == null ? this.n96() : tmp0_elvis_lhs;
      }
      p96() {
        var tmp0_elvis_lhs = this.n96();
        return tmp0_elvis_lhs == null ? this.w6v_1 : tmp0_elvis_lhs;
      }
      q96() {
        return this.t6v_1;
      }
      r96(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy) {
        return new (PayAppItem())(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy);
      }
      b6w(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy, $super) {
        _id = _id === VOID ? this.o6v_1 : _id;
        payApp = payApp === VOID ? this.p6v_1 : payApp;
        lineItem = lineItem === VOID ? this.q6v_1 : lineItem;
        amount = amount === VOID ? this.r6v_1 : amount;
        approved = approved === VOID ? this.s6v_1 : approved;
        denied = denied === VOID ? this.t6v_1 : denied;
        voided = voided === VOID ? this.u6v_1 : voided;
        project = project === VOID ? this.v6v_1 : project;
        submitted = submitted === VOID ? this.w6v_1 : submitted;
        accepted = accepted === VOID ? this.x6v_1 : accepted;
        readBy = readBy === VOID ? this.y6v_1 : readBy;
        return $super === VOID ? this.r96(_id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy) : $super.r96.call(this, _id, payApp, lineItem, new (MonetaryValue())(amount), approved, denied, voided, project, submitted, accepted, readBy);
      }
      toString() {
        return 'PayAppItem(_id=' + this.o6v_1.toString() + ', payApp=' + this.p6v_1.toString() + ', lineItem=' + this.q6v_1.toString() + ', amount=' + MonetaryValue__toString_impl_xslc77(this.r6v_1) + ', approved=' + toString_0(this.s6v_1) + ', denied=' + toString_0(this.t6v_1) + ', voided=' + toString_0(this.u6v_1) + ', project=' + this.v6v_1.toString() + ', submitted=' + toString_0(this.w6v_1) + ', accepted=' + this.x6v_1 + ', readBy=' + toString(this.y6v_1) + ')';
      }
      hashCode() {
        var result = this.o6v_1.hashCode();
        result = imul(result, 31) + this.p6v_1.hashCode() | 0;
        result = imul(result, 31) + this.q6v_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.r6v_1) | 0;
        result = imul(result, 31) + (this.s6v_1 == null ? 0 : this.s6v_1.hashCode()) | 0;
        result = imul(result, 31) + (this.t6v_1 == null ? 0 : this.t6v_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u6v_1 == null ? 0 : this.u6v_1.hashCode()) | 0;
        result = imul(result, 31) + this.v6v_1.hashCode() | 0;
        result = imul(result, 31) + (this.w6v_1 == null ? 0 : this.w6v_1.hashCode()) | 0;
        result = imul(result, 31) + (this.x6v_1 == null ? 0 : getBooleanHashCode(this.x6v_1)) | 0;
        result = imul(result, 31) + hashCode(this.y6v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayAppItem()))
          return false;
        if (!this.o6v_1.equals(other.o6v_1))
          return false;
        if (!this.p6v_1.equals(other.p6v_1))
          return false;
        if (!this.q6v_1.equals(other.q6v_1))
          return false;
        if (!(this.r6v_1 === other.r6v_1))
          return false;
        if (!equals(this.s6v_1, other.s6v_1))
          return false;
        if (!equals(this.t6v_1, other.t6v_1))
          return false;
        if (!equals(this.u6v_1, other.u6v_1))
          return false;
        if (!this.v6v_1.equals(other.v6v_1))
          return false;
        if (!equals(this.w6v_1, other.w6v_1))
          return false;
        if (!(this.x6v_1 == other.x6v_1))
          return false;
        if (!equals(this.y6v_1, other.y6v_1))
          return false;
        return true;
      }
      static m96(seen0, _id, payApp, lineItem, amount, approved, denied, voided, project, submitted, accepted, readBy, serializationConstructorMarker) {
        Companion_getInstance_36();
        if (!(142 === (142 & seen0))) {
          throwMissingFieldException(seen0, 142, $serializer_getInstance_37().k96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.o6v_1 = Companion_getInstance().k2p();
        else
          $this.o6v_1 = _id;
        $this.p6v_1 = payApp;
        $this.q6v_1 = lineItem;
        $this.r6v_1 = amount;
        if (0 === (seen0 & 16))
          $this.s6v_1 = null;
        else
          $this.s6v_1 = approved;
        if (0 === (seen0 & 32))
          $this.t6v_1 = null;
        else
          $this.t6v_1 = denied;
        if (0 === (seen0 & 64))
          $this.u6v_1 = null;
        else
          $this.u6v_1 = voided;
        $this.v6v_1 = project;
        if (0 === (seen0 & 256))
          $this.w6v_1 = null;
        else
          $this.w6v_1 = submitted;
        if (0 === (seen0 & 512))
          $this.x6v_1 = null;
        else
          $this.x6v_1 = accepted;
        if (0 === (seen0 & 1024))
          $this.y6v_1 = emptySet();
        else
          $this.y6v_1 = readBy;
        $this.z6v_1 = !!(!!(!!(!($this.w6v_1 == null) & $this.s6v_1 == null) & $this.u6v_1 == null) & $this.t6v_1 == null);
        return $this;
      }
    }
    initMetadataForClass($, 'PayAppItem', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_37});
    PayAppItemClass = $;
  }
  return PayAppItemClass;
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_2() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      constructor() {
        Companion_instance_25 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b6y_1 = [tmp_1, tmp_3, null, tmp_5, tmp_7, null, tmp_9, lazy(tmp_10, PayApplication$Companion$$childSerializers$_anonymous__wo9p5u_4)];
      }
      k2a() {
        return $serializer_getInstance_38();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_25;
function Companion_getInstance_37() {
  if (Companion_instance_25 === VOID)
    new (Companion_23())();
  return Companion_instance_25;
}
var $serializerClass_22;
function $serializer_22() {
  if ($serializerClass_22 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_22 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PayApplication', this, 8);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('number', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('submitted', true);
        tmp0_serialDesc.a1b('description', true);
        tmp0_serialDesc.a1b('attachments', true);
        tmp0_serialDesc.a1b('readBy', true);
        this.s96_1 = tmp0_serialDesc;
      }
      t96(encoder, value) {
        var tmp0_desc = this.s96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_37().b6y_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.g6y_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.g6y_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.h6y_1);
        tmp1_output.v14(tmp0_desc, 2, value.i6y_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 3)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.j6y_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.j6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.k6y_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.k6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.l6y_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.l6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !equals(value.m6y_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.m6y_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !equals(value.n6y_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.n6y_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t96(encoder, value instanceof PayApplication() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_37().b6y_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, tmp13_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.z13(tmp0_desc, 4, tmp13_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, tmp13_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.z13(tmp0_desc, 4, tmp13_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.x13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return PayApplication().u96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.s96_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_37().b6y_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), IntSerializer_getInstance(), tmp0_cached[3].f2(), get_nullable(tmp0_cached[4].f2()), StringSerializer_getInstance(), tmp0_cached[6].f2(), tmp0_cached[7].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_22 = $;
  }
  return $serializerClass_22;
}
var $serializer_instance_22;
function $serializer_getInstance_38() {
  if ($serializer_instance_22 === VOID)
    new ($serializer_22())();
  return $serializer_instance_22;
}
var PayApplicationClass;
function PayApplication() {
  if (PayApplicationClass === VOID) {
    class $ {
      constructor(_id, project, number, created, submitted, description, attachments, readBy) {
        Companion_getInstance_37();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        submitted = submitted === VOID ? null : submitted;
        description = description === VOID ? '' : description;
        attachments = attachments === VOID ? emptyList() : attachments;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.g6y_1 = _id;
        this.h6y_1 = project;
        this.i6y_1 = number;
        this.j6y_1 = created;
        this.k6y_1 = submitted;
        this.l6y_1 = description;
        this.m6y_1 = attachments;
        this.n6y_1 = readBy;
      }
      f40() {
        return this.g6y_1;
      }
      v91() {
        return this.n6y_1;
      }
      d95() {
        var tmp0_elvis_lhs = this.k6y_1;
        return tmp0_elvis_lhs == null ? this.j6y_1 : tmp0_elvis_lhs;
      }
      v96(_id, project, number, created, submitted, description, attachments, readBy) {
        return new (PayApplication())(_id, project, number, created, submitted, description, attachments, readBy);
      }
      p6y(_id, project, number, created, submitted, description, attachments, readBy, $super) {
        _id = _id === VOID ? this.g6y_1 : _id;
        project = project === VOID ? this.h6y_1 : project;
        number = number === VOID ? this.i6y_1 : number;
        created = created === VOID ? this.j6y_1 : created;
        submitted = submitted === VOID ? this.k6y_1 : submitted;
        description = description === VOID ? this.l6y_1 : description;
        attachments = attachments === VOID ? this.m6y_1 : attachments;
        readBy = readBy === VOID ? this.n6y_1 : readBy;
        return $super === VOID ? this.v96(_id, project, number, created, submitted, description, attachments, readBy) : $super.v96.call(this, _id, project, number, created, submitted, description, attachments, readBy);
      }
      toString() {
        return 'PayApplication(_id=' + this.g6y_1.toString() + ', project=' + this.h6y_1.toString() + ', number=' + this.i6y_1 + ', created=' + this.j6y_1.toString() + ', submitted=' + toString_0(this.k6y_1) + ', description=' + this.l6y_1 + ', attachments=' + toString(this.m6y_1) + ', readBy=' + toString(this.n6y_1) + ')';
      }
      hashCode() {
        var result = this.g6y_1.hashCode();
        result = imul(result, 31) + this.h6y_1.hashCode() | 0;
        result = imul(result, 31) + this.i6y_1 | 0;
        result = imul(result, 31) + this.j6y_1.hashCode() | 0;
        result = imul(result, 31) + (this.k6y_1 == null ? 0 : this.k6y_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.l6y_1) | 0;
        result = imul(result, 31) + hashCode(this.m6y_1) | 0;
        result = imul(result, 31) + hashCode(this.n6y_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayApplication()))
          return false;
        if (!this.g6y_1.equals(other.g6y_1))
          return false;
        if (!this.h6y_1.equals(other.h6y_1))
          return false;
        if (!(this.i6y_1 === other.i6y_1))
          return false;
        if (!this.j6y_1.equals(other.j6y_1))
          return false;
        if (!equals(this.k6y_1, other.k6y_1))
          return false;
        if (!(this.l6y_1 === other.l6y_1))
          return false;
        if (!equals(this.m6y_1, other.m6y_1))
          return false;
        if (!equals(this.n6y_1, other.n6y_1))
          return false;
        return true;
      }
      static u96(seen0, _id, project, number, created, submitted, description, attachments, readBy, serializationConstructorMarker) {
        Companion_getInstance_37();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_38().s96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.g6y_1 = Companion_getInstance().k2p();
        else
          $this.g6y_1 = _id;
        $this.h6y_1 = project;
        $this.i6y_1 = number;
        if (0 === (seen0 & 8)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.j6y_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.j6y_1 = created;
        if (0 === (seen0 & 16))
          $this.k6y_1 = null;
        else
          $this.k6y_1 = submitted;
        if (0 === (seen0 & 32))
          $this.l6y_1 = '';
        else
          $this.l6y_1 = description;
        if (0 === (seen0 & 64))
          $this.m6y_1 = emptyList();
        else
          $this.m6y_1 = attachments;
        if (0 === (seen0 & 128))
          $this.n6y_1 = emptySet();
        else
          $this.n6y_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'PayApplication', VOID, VOID, [HasId(), ReadByDataModel(), DrawTableItem()], VOID, VOID, {0: $serializer_getInstance_38});
    PayApplicationClass = $;
  }
  return PayApplicationClass;
}
function Payout$Companion$$childSerializers$_anonymous__b2iidg() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_24;
function Companion_24() {
  if (CompanionClass_24 === VOID) {
    class $ {
      constructor() {
        Companion_instance_26 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.z70_1 = [lazy(tmp_0, Payout$Companion$$childSerializers$_anonymous__b2iidg), null, null];
      }
      k2a() {
        return $serializer_getInstance_39();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_24 = $;
  }
  return CompanionClass_24;
}
var Companion_instance_26;
function Companion_getInstance_38() {
  if (Companion_instance_26 === VOID)
    new (Companion_24())();
  return Companion_instance_26;
}
var $serializerClass_23;
function $serializer_23() {
  if ($serializerClass_23 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_23 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Payout', this, 3);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('totalOut', false);
        tmp0_serialDesc.a1b('onePercent', false);
        this.w96_1 = tmp0_serialDesc;
      }
      x96(encoder, value) {
        var tmp0_desc = this.w96_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_38().z70_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.g71_1.equals(System_instance.b1m())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.g71_1);
        }
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_2(), new (MonetaryValue())(value.h71_1));
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_2(), new (MonetaryValue())(value.i71_1));
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x96(encoder, value instanceof Payout() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w96_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_38().z70_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp7_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp7_input.x13(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = $serializer_getInstance_2();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp7_input.x13(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp7_input.x13(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return Payout().y96(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.w96_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_38().z70_1[0].f2(), $serializer_getInstance_2(), $serializer_getInstance_2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_23 = $;
  }
  return $serializerClass_23;
}
var $serializer_instance_23;
function $serializer_getInstance_39() {
  if ($serializer_instance_23 === VOID)
    new ($serializer_23())();
  return $serializer_instance_23;
}
var PayoutClass;
function Payout() {
  if (PayoutClass === VOID) {
    class $ {
      constructor(_id, totalOut, onePercent) {
        Companion_getInstance_38();
        _id = _id === VOID ? System_instance.b1m() : _id;
        this.g71_1 = _id;
        this.h71_1 = totalOut;
        this.i71_1 = onePercent;
      }
      f40() {
        return this.g71_1;
      }
      z96(_id, totalOut, onePercent) {
        return new (Payout())(_id, totalOut, onePercent);
      }
      k71(_id, totalOut, onePercent, $super) {
        _id = _id === VOID ? this.g71_1 : _id;
        totalOut = totalOut === VOID ? this.h71_1 : totalOut;
        onePercent = onePercent === VOID ? this.i71_1 : onePercent;
        return $super === VOID ? this.z96(_id, totalOut, onePercent) : $super.z96.call(this, _id, new (MonetaryValue())(totalOut), new (MonetaryValue())(onePercent));
      }
      toString() {
        return 'Payout(_id=' + this.g71_1.toString() + ', totalOut=' + MonetaryValue__toString_impl_xslc77(this.h71_1) + ', onePercent=' + MonetaryValue__toString_impl_xslc77(this.i71_1) + ')';
      }
      hashCode() {
        var result = this.g71_1.hashCode();
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.h71_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.i71_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Payout()))
          return false;
        if (!this.g71_1.equals(other.g71_1))
          return false;
        if (!(this.h71_1 === other.h71_1))
          return false;
        if (!(this.i71_1 === other.i71_1))
          return false;
        return true;
      }
      static y96(seen0, _id, totalOut, onePercent, serializationConstructorMarker) {
        Companion_getInstance_38();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_39().w96_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.g71_1 = System_instance.b1m();
        else
          $this.g71_1 = _id;
        $this.h71_1 = totalOut;
        $this.i71_1 = onePercent;
        return $this;
      }
    }
    initMetadataForClass($, 'Payout', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_39});
    PayoutClass = $;
  }
  return PayoutClass;
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_25;
function Companion_25() {
  if (CompanionClass_25 === VOID) {
    class $ {
      constructor() {
        Companion_instance_27 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t71_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, null, null, null, tmp_9, tmp_11, null, tmp_13, lazy(tmp_14, PendingItemChange$Companion$$childSerializers$_anonymous__oalflc_6)];
      }
      k2a() {
        return $serializer_getInstance_40();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_25 = $;
  }
  return CompanionClass_25;
}
var Companion_instance_27;
function Companion_getInstance_39() {
  if (Companion_instance_27 === VOID)
    new (Companion_25())();
  return Companion_instance_27;
}
var $serializerClass_24;
function $serializer_24() {
  if ($serializerClass_24 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_24 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingItemChange', this, 15);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('changeRequest', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.a1b('itemId', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('updatedDescription', true);
        tmp0_serialDesc.a1b('priceChange', true);
        tmp0_serialDesc.a1b('cancelled', true);
        tmp0_serialDesc.a1b('accepted', true);
        tmp0_serialDesc.a1b('approved', true);
        tmp0_serialDesc.a1b('denied', true);
        tmp0_serialDesc.a1b('withdrawn', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('itemNumber', false);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('published', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.a97_1 = tmp0_serialDesc;
      }
      b97(encoder, value) {
        var tmp0_desc = this.a97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_39().t71_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.a72_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.a72_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.b72_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.c72_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.d72_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.e72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.e72_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.f72_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.f72_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.g72_1 === false)) {
          tmp1_output.s14(tmp0_desc, 6, value.g72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.h72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.h72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.i72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, BooleanSerializer_getInstance(), value.i72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.j72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_8(), value.j72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.k72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.k72_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp_3 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp_3 = !value.l72_1.equals(tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.l72_1);
        }
        tmp1_output.a15(tmp0_desc, 12, value.m72_1);
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !equals(value.n72_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 13, tmp2_cached[13].f2(), value.n72_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.o72_1 == null)) {
          tmp1_output.d15(tmp0_desc, 14, tmp2_cached[14].f2(), value.o72_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b97(encoder, value instanceof PendingItemChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_input = decoder.l13(tmp0_desc);
        var tmp20_cached = Companion_getInstance_39().t71_1;
        if (tmp19_input.a14()) {
          tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, tmp20_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp19_input.x13(tmp0_desc, 1, tmp20_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp19_input.x13(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp19_input.x13(tmp0_desc, 3, tmp20_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp19_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp19_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp19_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp19_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp19_input.z13(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp19_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp19_input.z13(tmp0_desc, 10, tmp20_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp19_input.x13(tmp0_desc, 11, tmp20_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp19_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp19_input.x13(tmp0_desc, 13, tmp20_cached[13].f2(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp19_input.z13(tmp0_desc, 14, tmp20_cached[14].f2(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp19_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, tmp20_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp19_input.x13(tmp0_desc, 1, tmp20_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp19_input.x13(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp19_input.x13(tmp0_desc, 3, tmp20_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp19_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp19_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp19_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp19_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp19_input.z13(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp19_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp19_input.z13(tmp0_desc, 10, tmp20_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp19_input.x13(tmp0_desc, 11, tmp20_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp19_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp19_input.x13(tmp0_desc, 13, tmp20_cached[13].f2(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp19_input.z13(tmp0_desc, 14, tmp20_cached[14].f2(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp19_input.m13(tmp0_desc);
        return PendingItemChange().c97(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
      }
      az() {
        return this.a97_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_39().t71_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_8()), get_nullable(tmp0_cached[10].f2()), tmp0_cached[11].f2(), StringSerializer_getInstance(), tmp0_cached[13].f2(), get_nullable(tmp0_cached[14].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_24 = $;
  }
  return $serializerClass_24;
}
var $serializer_instance_24;
function $serializer_getInstance_40() {
  if ($serializer_instance_24 === VOID)
    new ($serializer_24())();
  return $serializer_instance_24;
}
var PendingItemChangeClass;
function PendingItemChange() {
  if (PendingItemChangeClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published) {
        Companion_getInstance_39();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        updatedDescription = updatedDescription === VOID ? null : updatedDescription;
        priceChange = priceChange === VOID ? null : priceChange;
        cancelled = cancelled === VOID ? false : cancelled;
        accepted = accepted === VOID ? null : accepted;
        approved = approved === VOID ? null : approved;
        denied = denied === VOID ? null : denied;
        withdrawn = withdrawn === VOID ? null : withdrawn;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        published = published === VOID ? null : published;
        this.a72_1 = _id;
        this.b72_1 = project;
        this.c72_1 = changeRequest;
        this.d72_1 = itemId;
        this.e72_1 = updatedDescription;
        this.f72_1 = priceChange;
        this.g72_1 = cancelled;
        this.h72_1 = accepted;
        this.i72_1 = approved;
        this.j72_1 = denied;
        this.k72_1 = withdrawn;
        this.l72_1 = created;
        this.m72_1 = itemNumber;
        this.n72_1 = readBy;
        this.o72_1 = published;
      }
      f40() {
        return this.a72_1;
      }
      s94() {
        return this.c72_1;
      }
      t94() {
        return this.d72_1;
      }
      v94() {
        return this.e72_1;
      }
      w94() {
        return this.f72_1;
      }
      x94() {
        return this.g72_1;
      }
      j95() {
        return this.k72_1;
      }
      y94() {
        return this.m72_1;
      }
      v91() {
        return this.n72_1;
      }
      z94() {
        var tmp0_safe_receiver = this.h72_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o54_1;
      }
      a95() {
        var tmp0_safe_receiver = this.j72_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d95();
      }
      u94() {
        return false;
      }
      b95() {
        return this.g72_1 ? ChangeType_Remove_getInstance() : ChangeType_Modify_getInstance();
      }
      q96() {
        return this.j72_1;
      }
      d97(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published) {
        return new (PendingItemChange())(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published);
      }
      q72(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published, $super) {
        _id = _id === VOID ? this.a72_1 : _id;
        project = project === VOID ? this.b72_1 : project;
        changeRequest = changeRequest === VOID ? this.c72_1 : changeRequest;
        itemId = itemId === VOID ? this.d72_1 : itemId;
        updatedDescription = updatedDescription === VOID ? this.e72_1 : updatedDescription;
        priceChange = priceChange === VOID ? this.f72_1 : priceChange;
        cancelled = cancelled === VOID ? this.g72_1 : cancelled;
        accepted = accepted === VOID ? this.h72_1 : accepted;
        approved = approved === VOID ? this.i72_1 : approved;
        denied = denied === VOID ? this.j72_1 : denied;
        withdrawn = withdrawn === VOID ? this.k72_1 : withdrawn;
        created = created === VOID ? this.l72_1 : created;
        itemNumber = itemNumber === VOID ? this.m72_1 : itemNumber;
        readBy = readBy === VOID ? this.n72_1 : readBy;
        published = published === VOID ? this.o72_1 : published;
        var tmp;
        if ($super === VOID) {
          tmp = this.d97(_id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published);
        } else {
          var tmp_0 = $super.d97;
          var tmp_1 = priceChange;
          tmp = tmp_0.call(this, _id, project, changeRequest, itemId, updatedDescription, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published);
        }
        return tmp;
      }
      toString() {
        var tmp = this.a72_1.toString();
        var tmp_0 = this.b72_1.toString();
        var tmp_1 = this.c72_1.toString();
        var tmp_2 = this.d72_1.toString();
        var tmp_3 = this.f72_1;
        return 'PendingItemChange(_id=' + tmp + ', project=' + tmp_0 + ', changeRequest=' + tmp_1 + ', itemId=' + tmp_2 + ', updatedDescription=' + this.e72_1 + ', priceChange=' + toString_0(tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) + ', cancelled=' + this.g72_1 + ', accepted=' + toString_0(this.h72_1) + ', approved=' + this.i72_1 + ', denied=' + toString_0(this.j72_1) + ', withdrawn=' + toString_0(this.k72_1) + ', created=' + this.l72_1.toString() + ', itemNumber=' + this.m72_1 + ', readBy=' + toString(this.n72_1) + ', published=' + toString_0(this.o72_1) + ')';
      }
      hashCode() {
        var result = this.a72_1.hashCode();
        result = imul(result, 31) + this.b72_1.hashCode() | 0;
        result = imul(result, 31) + this.c72_1.hashCode() | 0;
        result = imul(result, 31) + this.d72_1.hashCode() | 0;
        result = imul(result, 31) + (this.e72_1 == null ? 0 : getStringHashCode(this.e72_1)) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.f72_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.f72_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.g72_1) | 0;
        result = imul(result, 31) + (this.h72_1 == null ? 0 : this.h72_1.hashCode()) | 0;
        result = imul(result, 31) + (this.i72_1 == null ? 0 : getBooleanHashCode(this.i72_1)) | 0;
        result = imul(result, 31) + (this.j72_1 == null ? 0 : this.j72_1.hashCode()) | 0;
        result = imul(result, 31) + (this.k72_1 == null ? 0 : this.k72_1.hashCode()) | 0;
        result = imul(result, 31) + this.l72_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.m72_1) | 0;
        result = imul(result, 31) + hashCode(this.n72_1) | 0;
        result = imul(result, 31) + (this.o72_1 == null ? 0 : this.o72_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingItemChange()))
          return false;
        if (!this.a72_1.equals(other.a72_1))
          return false;
        if (!this.b72_1.equals(other.b72_1))
          return false;
        if (!this.c72_1.equals(other.c72_1))
          return false;
        if (!this.d72_1.equals(other.d72_1))
          return false;
        if (!(this.e72_1 == other.e72_1))
          return false;
        var tmp = this.f72_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.f72_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!(this.g72_1 === other.g72_1))
          return false;
        if (!equals(this.h72_1, other.h72_1))
          return false;
        if (!(this.i72_1 == other.i72_1))
          return false;
        if (!equals(this.j72_1, other.j72_1))
          return false;
        if (!equals(this.k72_1, other.k72_1))
          return false;
        if (!this.l72_1.equals(other.l72_1))
          return false;
        if (!(this.m72_1 === other.m72_1))
          return false;
        if (!equals(this.n72_1, other.n72_1))
          return false;
        if (!equals(this.o72_1, other.o72_1))
          return false;
        return true;
      }
      static c97(seen0, _id, project, changeRequest, itemId, updatedDescription, priceChange, cancelled, accepted, approved, denied, withdrawn, created, itemNumber, readBy, published, serializationConstructorMarker) {
        Companion_getInstance_39();
        if (!(4110 === (4110 & seen0))) {
          throwMissingFieldException(seen0, 4110, $serializer_getInstance_40().a97_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.a72_1 = Companion_getInstance().k2p();
        else
          $this.a72_1 = _id;
        $this.b72_1 = project;
        $this.c72_1 = changeRequest;
        $this.d72_1 = itemId;
        if (0 === (seen0 & 16))
          $this.e72_1 = null;
        else
          $this.e72_1 = updatedDescription;
        if (0 === (seen0 & 32))
          $this.f72_1 = null;
        else
          $this.f72_1 = priceChange;
        if (0 === (seen0 & 64))
          $this.g72_1 = false;
        else
          $this.g72_1 = cancelled;
        if (0 === (seen0 & 128))
          $this.h72_1 = null;
        else
          $this.h72_1 = accepted;
        if (0 === (seen0 & 256))
          $this.i72_1 = null;
        else
          $this.i72_1 = approved;
        if (0 === (seen0 & 512))
          $this.j72_1 = null;
        else
          $this.j72_1 = denied;
        if (0 === (seen0 & 1024))
          $this.k72_1 = null;
        else
          $this.k72_1 = withdrawn;
        if (0 === (seen0 & 2048)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.l72_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.l72_1 = created;
        $this.m72_1 = itemNumber;
        if (0 === (seen0 & 8192))
          $this.n72_1 = emptySet();
        else
          $this.n72_1 = readBy;
        if (0 === (seen0 & 16384))
          $this.o72_1 = null;
        else
          $this.o72_1 = published;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingItemChange', VOID, VOID, [HasId(), ItemChangeInterface(), ChangeRequestItem(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_40});
    PendingItemChangeClass = $;
  }
  return PendingItemChangeClass;
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_2() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_26;
function Companion_26() {
  if (CompanionClass_26 === VOID) {
    class $ {
      constructor() {
        Companion_instance_28 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.m75_1 = [tmp_1, tmp_3, tmp_5, null, null, null, tmp_7, null, null, null, tmp_9, null, tmp_11, null, tmp_13, lazy(tmp_14, PendingLineItem$Companion$$childSerializers$_anonymous__8qfipg_6)];
      }
      k2a() {
        return $serializer_getInstance_41();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_26 = $;
  }
  return CompanionClass_26;
}
var Companion_instance_28;
function Companion_getInstance_40() {
  if (Companion_instance_28 === VOID)
    new (Companion_26())();
  return Companion_instance_28;
}
var $serializerClass_25;
function $serializer_25() {
  if ($serializerClass_25 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_25 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingLineItem', this, 16);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('changeRequest', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.a1b('name', true);
        tmp0_serialDesc.a1b('description', true);
        tmp0_serialDesc.a1b('price', true);
        tmp0_serialDesc.b1b(new (MonetaryRange())(0n, 2147483647n));
        tmp0_serialDesc.a1b('files', true);
        tmp0_serialDesc.a1b('linked', true);
        tmp0_serialDesc.a1b('accepted', true);
        tmp0_serialDesc.a1b('denied', true);
        tmp0_serialDesc.a1b('withdrawn', true);
        tmp0_serialDesc.a1b('approved', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.a1b('itemNumber', false);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('published', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        this.e97_1 = tmp0_serialDesc;
      }
      f97(encoder, value) {
        var tmp0_desc = this.e97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_40().m75_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.t75_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t75_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.u75_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.v75_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.w75_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.w75_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.x75_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.x75_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.y75_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.y75_1));
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.z75_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.z75_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.a76_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.a76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.b76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, $serializer_getInstance_4(), value.b76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.c76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_8(), value.c76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.d76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.d76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.e76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, BooleanSerializer_getInstance(), value.e76_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 12)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance_0).b1m();
          tmp_0 = !value.f76_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 12, tmp2_cached[12].f2(), value.f76_1);
        }
        tmp1_output.a15(tmp0_desc, 13, value.g76_1);
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !equals(value.h76_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 14, tmp2_cached[14].f2(), value.h76_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.i76_1 == null)) {
          tmp1_output.d15(tmp0_desc, 15, tmp2_cached[15].f2(), value.i76_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f97(encoder, value instanceof PendingLineItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_input = decoder.l13(tmp0_desc);
        var tmp21_cached = Companion_getInstance_40().m75_1;
        if (tmp20_input.a14()) {
          tmp4_local0 = tmp20_input.x13(tmp0_desc, 0, tmp21_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp20_input.x13(tmp0_desc, 1, tmp21_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp20_input.x13(tmp0_desc, 2, tmp21_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp20_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp20_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp20_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp20_input.x13(tmp0_desc, 6, tmp21_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp20_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp20_input.z13(tmp0_desc, 8, $serializer_getInstance_4(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp20_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp20_input.z13(tmp0_desc, 10, tmp21_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp20_input.z13(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp20_input.x13(tmp0_desc, 12, tmp21_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp20_input.v13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp20_input.x13(tmp0_desc, 14, tmp21_cached[14].f2(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp20_input.z13(tmp0_desc, 15, tmp21_cached[15].f2(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp20_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp20_input.x13(tmp0_desc, 0, tmp21_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp20_input.x13(tmp0_desc, 1, tmp21_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp20_input.x13(tmp0_desc, 2, tmp21_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp20_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp20_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp20_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp20_input.x13(tmp0_desc, 6, tmp21_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp20_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp20_input.z13(tmp0_desc, 8, $serializer_getInstance_4(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp20_input.z13(tmp0_desc, 9, $serializer_getInstance_8(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp20_input.z13(tmp0_desc, 10, tmp21_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp20_input.z13(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp20_input.x13(tmp0_desc, 12, tmp21_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp20_input.v13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp20_input.x13(tmp0_desc, 14, tmp21_cached[14].f2(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp20_input.z13(tmp0_desc, 15, tmp21_cached[15].f2(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp20_input.m13(tmp0_desc);
        return PendingLineItem().g97(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
      }
      az() {
        return this.e97_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_40().m75_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_2(), tmp0_cached[6].f2(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_8()), get_nullable(tmp0_cached[10].f2()), get_nullable(BooleanSerializer_getInstance()), tmp0_cached[12].f2(), StringSerializer_getInstance(), tmp0_cached[14].f2(), get_nullable(tmp0_cached[15].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_25 = $;
  }
  return $serializerClass_25;
}
var $serializer_instance_25;
function $serializer_getInstance_41() {
  if ($serializer_instance_25 === VOID)
    new ($serializer_25())();
  return $serializer_instance_25;
}
var PendingLineItemClass;
function PendingLineItem() {
  if (PendingLineItemClass === VOID) {
    class $ {
      constructor(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published) {
        Companion_getInstance_40();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        name = name === VOID ? '' : name;
        description = description === VOID ? '' : description;
        price = price === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : price;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        linked = linked === VOID ? false : linked;
        accepted = accepted === VOID ? null : accepted;
        denied = denied === VOID ? null : denied;
        withdrawn = withdrawn === VOID ? null : withdrawn;
        approved = approved === VOID ? null : approved;
        var tmp_0;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance_0).b1m();
        } else {
          tmp_0 = created;
        }
        created = tmp_0;
        readBy = readBy === VOID ? emptySet() : readBy;
        published = published === VOID ? null : published;
        this.t75_1 = _id;
        this.u75_1 = project;
        this.v75_1 = changeRequest;
        this.w75_1 = name;
        this.x75_1 = description;
        this.y75_1 = price;
        this.z75_1 = files;
        this.a76_1 = linked;
        this.b76_1 = accepted;
        this.c76_1 = denied;
        this.d76_1 = withdrawn;
        this.e76_1 = approved;
        this.f76_1 = created;
        this.g76_1 = itemNumber;
        this.h76_1 = readBy;
        this.i76_1 = published;
      }
      f40() {
        return this.t75_1;
      }
      s94() {
        return this.v75_1;
      }
      i20() {
        return this.w75_1;
      }
      s91() {
        return this.x75_1;
      }
      x91() {
        return this.y75_1;
      }
      t91() {
        return this.z75_1;
      }
      u94() {
        return this.a76_1;
      }
      j95() {
        return this.d76_1;
      }
      y94() {
        return this.g76_1;
      }
      v91() {
        return this.h76_1;
      }
      t94() {
        return this.t75_1;
      }
      z94() {
        var tmp0_safe_receiver = this.b76_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o54_1;
      }
      a95() {
        var tmp0_safe_receiver = this.c76_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d95();
      }
      h97() {
        return this.y75_1;
      }
      w94() {
        return this.h97();
      }
      b95() {
        return ChangeType_New_getInstance();
      }
      q96() {
        return this.c76_1;
      }
      i97(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published) {
        return new (PendingLineItem())(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published);
      }
      k76(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published, $super) {
        _id = _id === VOID ? this.t75_1 : _id;
        project = project === VOID ? this.u75_1 : project;
        changeRequest = changeRequest === VOID ? this.v75_1 : changeRequest;
        name = name === VOID ? this.w75_1 : name;
        description = description === VOID ? this.x75_1 : description;
        price = price === VOID ? this.y75_1 : price;
        files = files === VOID ? this.z75_1 : files;
        linked = linked === VOID ? this.a76_1 : linked;
        accepted = accepted === VOID ? this.b76_1 : accepted;
        denied = denied === VOID ? this.c76_1 : denied;
        withdrawn = withdrawn === VOID ? this.d76_1 : withdrawn;
        approved = approved === VOID ? this.e76_1 : approved;
        created = created === VOID ? this.f76_1 : created;
        itemNumber = itemNumber === VOID ? this.g76_1 : itemNumber;
        readBy = readBy === VOID ? this.h76_1 : readBy;
        published = published === VOID ? this.i76_1 : published;
        return $super === VOID ? this.i97(_id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published) : $super.i97.call(this, _id, project, changeRequest, name, description, new (MonetaryValue())(price), files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published);
      }
      toString() {
        return 'PendingLineItem(_id=' + this.t75_1.toString() + ', project=' + this.u75_1.toString() + ', changeRequest=' + this.v75_1.toString() + ', name=' + this.w75_1 + ', description=' + this.x75_1 + ', price=' + MonetaryValue__toString_impl_xslc77(this.y75_1) + ', files=' + toString(this.z75_1) + ', linked=' + this.a76_1 + ', accepted=' + toString_0(this.b76_1) + ', denied=' + toString_0(this.c76_1) + ', withdrawn=' + toString_0(this.d76_1) + ', approved=' + this.e76_1 + ', created=' + this.f76_1.toString() + ', itemNumber=' + this.g76_1 + ', readBy=' + toString(this.h76_1) + ', published=' + toString_0(this.i76_1) + ')';
      }
      hashCode() {
        var result = this.t75_1.hashCode();
        result = imul(result, 31) + this.u75_1.hashCode() | 0;
        result = imul(result, 31) + this.v75_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.w75_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x75_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.y75_1) | 0;
        result = imul(result, 31) + hashCode(this.z75_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.a76_1) | 0;
        result = imul(result, 31) + (this.b76_1 == null ? 0 : this.b76_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c76_1 == null ? 0 : this.c76_1.hashCode()) | 0;
        result = imul(result, 31) + (this.d76_1 == null ? 0 : this.d76_1.hashCode()) | 0;
        result = imul(result, 31) + (this.e76_1 == null ? 0 : getBooleanHashCode(this.e76_1)) | 0;
        result = imul(result, 31) + this.f76_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.g76_1) | 0;
        result = imul(result, 31) + hashCode(this.h76_1) | 0;
        result = imul(result, 31) + (this.i76_1 == null ? 0 : this.i76_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingLineItem()))
          return false;
        if (!this.t75_1.equals(other.t75_1))
          return false;
        if (!this.u75_1.equals(other.u75_1))
          return false;
        if (!this.v75_1.equals(other.v75_1))
          return false;
        if (!(this.w75_1 === other.w75_1))
          return false;
        if (!(this.x75_1 === other.x75_1))
          return false;
        if (!(this.y75_1 === other.y75_1))
          return false;
        if (!equals(this.z75_1, other.z75_1))
          return false;
        if (!(this.a76_1 === other.a76_1))
          return false;
        if (!equals(this.b76_1, other.b76_1))
          return false;
        if (!equals(this.c76_1, other.c76_1))
          return false;
        if (!equals(this.d76_1, other.d76_1))
          return false;
        if (!(this.e76_1 == other.e76_1))
          return false;
        if (!this.f76_1.equals(other.f76_1))
          return false;
        if (!(this.g76_1 === other.g76_1))
          return false;
        if (!equals(this.h76_1, other.h76_1))
          return false;
        if (!equals(this.i76_1, other.i76_1))
          return false;
        return true;
      }
      static g97(seen0, _id, project, changeRequest, name, description, price, files, linked, accepted, denied, withdrawn, approved, created, itemNumber, readBy, published, serializationConstructorMarker) {
        Companion_getInstance_40();
        if (!(8198 === (8198 & seen0))) {
          throwMissingFieldException(seen0, 8198, $serializer_getInstance_41().e97_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.t75_1 = Companion_getInstance().k2p();
        else
          $this.t75_1 = _id;
        $this.u75_1 = project;
        $this.v75_1 = changeRequest;
        if (0 === (seen0 & 8))
          $this.w75_1 = '';
        else
          $this.w75_1 = name;
        if (0 === (seen0 & 16))
          $this.x75_1 = '';
        else
          $this.x75_1 = description;
        if (0 === (seen0 & 32))
          $this.y75_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.y75_1 = price;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.z75_1 = emptyList();
        } else
          $this.z75_1 = files;
        if (0 === (seen0 & 128))
          $this.a76_1 = false;
        else
          $this.a76_1 = linked;
        if (0 === (seen0 & 256))
          $this.b76_1 = null;
        else
          $this.b76_1 = accepted;
        if (0 === (seen0 & 512))
          $this.c76_1 = null;
        else
          $this.c76_1 = denied;
        if (0 === (seen0 & 1024))
          $this.d76_1 = null;
        else
          $this.d76_1 = withdrawn;
        if (0 === (seen0 & 2048))
          $this.e76_1 = null;
        else
          $this.e76_1 = approved;
        if (0 === (seen0 & 4096)) {
          var tmp_0 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_0.f76_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.f76_1 = created;
        $this.g76_1 = itemNumber;
        if (0 === (seen0 & 16384))
          $this.h76_1 = emptySet();
        else
          $this.h76_1 = readBy;
        if (0 === (seen0 & 32768))
          $this.i76_1 = null;
        else
          $this.i76_1 = published;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingLineItem', VOID, VOID, [HasId(), LineItemInterface(), ChangeRequestItem(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_41});
    PendingLineItemClass = $;
  }
  return PendingLineItemClass;
}
var CompanionClass_27;
function Companion_27() {
  if (CompanionClass_27 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_42();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_27 = $;
  }
  return CompanionClass_27;
}
var Companion_instance_29;
function Companion_getInstance_41() {
  return Companion_instance_29;
}
var $serializerClass_26;
function $serializer_26() {
  if ($serializerClass_26 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_26 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Project.LockInfo', this, 2);
        tmp0_serialDesc.a1b('access', false);
        tmp0_serialDesc.a1b('clientLocked', false);
        this.j97_1 = tmp0_serialDesc;
      }
      k97(encoder, value) {
        var tmp0_desc = this.j97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_4(), value.o6q_1);
        tmp1_output.s14(tmp0_desc, 1, value.p6q_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k97(encoder, value instanceof LockInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.j97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return LockInfo().l97(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.j97_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_4(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_26 = $;
  }
  return $serializerClass_26;
}
var $serializer_instance_26;
function $serializer_getInstance_42() {
  if ($serializer_instance_26 === VOID)
    new ($serializer_26())();
  return $serializer_instance_26;
}
function Project$Companion$$childSerializers$_anonymous__hx2clt() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_3() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_7() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_8() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_9() {
  return Companion_getInstance_7().k2a();
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_10() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_11() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_12() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_13() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Project$Companion$$childSerializers$_anonymous__hx2clt_14() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var LockInfoClass;
function LockInfo() {
  if (LockInfoClass === VOID) {
    class $ {
      constructor(access, clientLocked) {
        this.o6q_1 = access;
        this.p6q_1 = clientLocked;
      }
      m97(access, clientLocked) {
        return new (LockInfo())(access, clientLocked);
      }
      r6q(access, clientLocked, $super) {
        access = access === VOID ? this.o6q_1 : access;
        clientLocked = clientLocked === VOID ? this.p6q_1 : clientLocked;
        return $super === VOID ? this.m97(access, clientLocked) : $super.m97.call(this, access, clientLocked);
      }
      toString() {
        return 'LockInfo(access=' + this.o6q_1.toString() + ', clientLocked=' + this.p6q_1 + ')';
      }
      hashCode() {
        var result = this.o6q_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.p6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LockInfo()))
          return false;
        if (!this.o6q_1.equals(other.o6q_1))
          return false;
        if (!(this.p6q_1 === other.p6q_1))
          return false;
        return true;
      }
      static l97(seen0, access, clientLocked, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_42().j97_1);
        }
        var $this = createThis(this);
        $this.o6q_1 = access;
        $this.p6q_1 = clientLocked;
        return $this;
      }
    }
    initMetadataForClass($, 'LockInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
    LockInfoClass = $;
  }
  return LockInfoClass;
}
var CompanionClass_28;
function Companion_28() {
  if (CompanionClass_28 === VOID) {
    class $ {
      constructor() {
        Companion_instance_30 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Project$Companion$$childSerializers$_anonymous__hx2clt);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Project$Companion$$childSerializers$_anonymous__hx2clt_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Project$Companion$$childSerializers$_anonymous__hx2clt_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, Project$Companion$$childSerializers$_anonymous__hx2clt_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, Project$Companion$$childSerializers$_anonymous__hx2clt_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, Project$Companion$$childSerializers$_anonymous__hx2clt_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, Project$Companion$$childSerializers$_anonymous__hx2clt_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, Project$Companion$$childSerializers$_anonymous__hx2clt_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, Project$Companion$$childSerializers$_anonymous__hx2clt_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_19 = lazy(tmp_18, Project$Companion$$childSerializers$_anonymous__hx2clt_8);
        var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_21 = lazy(tmp_20, Project$Companion$$childSerializers$_anonymous__hx2clt_9);
        var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_23 = lazy(tmp_22, Project$Companion$$childSerializers$_anonymous__hx2clt_10);
        var tmp_24 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_25 = lazy(tmp_24, Project$Companion$$childSerializers$_anonymous__hx2clt_11);
        var tmp_26 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_27 = lazy(tmp_26, Project$Companion$$childSerializers$_anonymous__hx2clt_12);
        var tmp_28 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_29 = lazy(tmp_28, Project$Companion$$childSerializers$_anonymous__hx2clt_13);
        var tmp_30 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n7a_1 = [tmp_1, null, tmp_3, null, tmp_5, tmp_7, null, null, null, null, null, tmp_9, null, tmp_11, tmp_13, null, tmp_15, null, null, null, tmp_17, null, tmp_19, null, null, tmp_21, null, null, tmp_23, null, null, null, null, null, null, tmp_25, tmp_27, tmp_29, null, lazy(tmp_30, Project$Companion$$childSerializers$_anonymous__hx2clt_14)];
        this.o7a_1 = 0.05;
      }
      k2a() {
        return $serializer_getInstance_43();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_28 = $;
  }
  return CompanionClass_28;
}
var Companion_instance_30;
function Companion_getInstance_42() {
  if (Companion_instance_30 === VOID)
    new (Companion_28())();
  return Companion_instance_30;
}
var $serializerClass_27;
function $serializer_27() {
  if ($serializerClass_27 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_27 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Project', this, 40);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('shortId', true);
        tmp0_serialDesc.a1b('contractor', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.a1b('contractorShortId', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('customer', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(User())));
        tmp0_serialDesc.a1b('client', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(Client())));
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('description', false);
        tmp0_serialDesc.a1b('address', false);
        tmp0_serialDesc.a1b('location', true);
        tmp0_serialDesc.a1b('jobNumber', true);
        tmp0_serialDesc.a1b('files', true);
        tmp0_serialDesc.a1b('retention', true);
        tmp0_serialDesc.a1b('published', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('feedback', true);
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('cancelled', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('abandoned', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('archived', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('viewedByCustomer', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('approved', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('terminated', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('complete', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('isArchived', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('state', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('originalPrice', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('activePrice', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('projectCredits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('acceptedChangeAmount', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('fundingRequested', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('clientDeposits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('pendingClientDeposits', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('contractorPayments', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('clientReturn', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('started', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('preSubstantialCompletion', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('substantialCompletion', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('locked', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('lastModifiedBy', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.b1b(new (References())(getKClass(User())));
        tmp0_serialDesc.c1b(new (IndexSet())(['contractor', 'customer']));
        tmp0_serialDesc.c1b(new (UniqueSet())(['shortId', 'contractorShortId']));
        this.n97_1 = tmp0_serialDesc;
      }
      o97(encoder, value) {
        var tmp0_desc = this.n97_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_42().n7a_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.v7a_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.v7a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.w7a_1 === Companion_instance_47.i5n())) {
          tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_58(), new (ShortId())(value.w7a_1));
        }
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.x7a_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_58(), new (ShortId())(value.y7a_1));
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.z7a_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.z7a_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.a7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, tmp2_cached[5].f2(), value.a7b_1);
        }
        tmp1_output.a15(tmp0_desc, 6, value.b7b_1);
        tmp1_output.a15(tmp0_desc, 7, value.c7b_1);
        tmp1_output.c15(tmp0_desc, 8, $serializer_getInstance_5(), value.d7b_1);
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.e7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.e7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.f7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, StringSerializer_getInstance(), value.f7b_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.g7b_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.g7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.h7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, FloatSerializer_getInstance(), value.h7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.i7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 13, tmp2_cached[13].f2(), value.i7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !equals(value.j7b_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 14, tmp2_cached[14].f2(), value.j7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.k7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 15, $serializer_getInstance_9(), value.k7b_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 16)) {
          tmp_0 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$1 = get_default(Companion_instance_0).b1m();
          tmp_0 = !value.l7b_1.equals(tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 16, tmp2_cached[16].f2(), value.l7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !(value.m7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 17, $serializer_getInstance_4(), value.m7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 18) ? true : !(value.n7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 18, $serializer_getInstance_4(), value.n7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 19) ? true : !(value.o7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 19, $serializer_getInstance_4(), value.o7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 20) ? true : !(value.p7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 20, tmp2_cached[20].f2(), value.p7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 21) ? true : !(value.q7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 21, $serializer_getInstance_4(), value.q7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 22) ? true : !(value.r7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 22, tmp2_cached[22].f2(), value.r7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 23) ? true : !(value.s7b_1 == null)) {
          tmp1_output.d15(tmp0_desc, 23, $serializer_getInstance_10(), value.s7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 24) ? true : !(value.t7b_1 === false)) {
          tmp1_output.s14(tmp0_desc, 24, value.t7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 25) ? true : !value.u7b_1.equals(ProjectState_Creating_getInstance())) {
          tmp1_output.c15(tmp0_desc, 25, tmp2_cached[25].f2(), value.u7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 26) ? true : !(value.v7b_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 26, $serializer_getInstance_2(), new (MonetaryValue())(value.v7b_1));
        }
        if (tmp1_output.h15(tmp0_desc, 27) ? true : !(value.w7b_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 27, $serializer_getInstance_2(), new (MonetaryValue())(value.w7b_1));
        }
        if (tmp1_output.h15(tmp0_desc, 28) ? true : !equals(value.x7b_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 28, tmp2_cached[28].f2(), value.x7b_1);
        }
        if (tmp1_output.h15(tmp0_desc, 29) ? true : !(value.y7b_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 29, $serializer_getInstance_2(), new (MonetaryValue())(value.y7b_1));
        }
        if (tmp1_output.h15(tmp0_desc, 30) ? true : !(value.z7b_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 30, $serializer_getInstance_2(), new (MonetaryValue())(value.z7b_1));
        }
        if (tmp1_output.h15(tmp0_desc, 31) ? true : !(value.a7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 31, $serializer_getInstance_2(), new (MonetaryValue())(value.a7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 32) ? true : !(value.b7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 32, $serializer_getInstance_2(), new (MonetaryValue())(value.b7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 33) ? true : !(value.c7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 33, $serializer_getInstance_2(), new (MonetaryValue())(value.c7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 34) ? true : !(value.d7c_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 34, $serializer_getInstance_2(), new (MonetaryValue())(value.d7c_1));
        }
        if (tmp1_output.h15(tmp0_desc, 35) ? true : !(value.e7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 35, tmp2_cached[35].f2(), value.e7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 36) ? true : !(value.f7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 36, tmp2_cached[36].f2(), value.f7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 37) ? true : !(value.g7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 37, tmp2_cached[37].f2(), value.g7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 38) ? true : !(value.h7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 38, $serializer_getInstance_42(), value.h7c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 39) ? true : !(value.i7c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 39, tmp2_cached[39].f2(), value.i7c_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o97(encoder, value instanceof Project() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n97_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_bitMask1 = 0;
        var tmp5_local0 = null;
        var tmp6_local1 = null;
        var tmp7_local2 = null;
        var tmp8_local3 = null;
        var tmp9_local4 = null;
        var tmp10_local5 = null;
        var tmp11_local6 = null;
        var tmp12_local7 = null;
        var tmp13_local8 = null;
        var tmp14_local9 = null;
        var tmp15_local10 = null;
        var tmp16_local11 = null;
        var tmp17_local12 = null;
        var tmp18_local13 = null;
        var tmp19_local14 = null;
        var tmp20_local15 = null;
        var tmp21_local16 = null;
        var tmp22_local17 = null;
        var tmp23_local18 = null;
        var tmp24_local19 = null;
        var tmp25_local20 = null;
        var tmp26_local21 = null;
        var tmp27_local22 = null;
        var tmp28_local23 = null;
        var tmp29_local24 = false;
        var tmp30_local25 = null;
        var tmp31_local26 = null;
        var tmp32_local27 = null;
        var tmp33_local28 = null;
        var tmp34_local29 = null;
        var tmp35_local30 = null;
        var tmp36_local31 = null;
        var tmp37_local32 = null;
        var tmp38_local33 = null;
        var tmp39_local34 = null;
        var tmp40_local35 = null;
        var tmp41_local36 = null;
        var tmp42_local37 = null;
        var tmp43_local38 = null;
        var tmp44_local39 = null;
        var tmp45_input = decoder.l13(tmp0_desc);
        var tmp46_cached = Companion_getInstance_42().n7a_1;
        if (tmp45_input.a14()) {
          tmp5_local0 = tmp45_input.x13(tmp0_desc, 0, tmp46_cached[0].f2(), tmp5_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = $serializer_getInstance_58();
          var tmp_0 = tmp6_local1;
          var tmp_1 = tmp45_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (ShortId())(tmp_0));
          tmp6_local1 = tmp_1 == null ? null : tmp_1.l5n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp7_local2 = tmp45_input.x13(tmp0_desc, 2, tmp46_cached[2].f2(), tmp7_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_2 = $serializer_getInstance_58();
          var tmp_3 = tmp8_local3;
          var tmp_4 = tmp45_input.x13(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (ShortId())(tmp_3));
          tmp8_local3 = tmp_4 == null ? null : tmp_4.l5n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp9_local4 = tmp45_input.z13(tmp0_desc, 4, tmp46_cached[4].f2(), tmp9_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp10_local5 = tmp45_input.z13(tmp0_desc, 5, tmp46_cached[5].f2(), tmp10_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp11_local6 = tmp45_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp12_local7 = tmp45_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp13_local8 = tmp45_input.x13(tmp0_desc, 8, $serializer_getInstance_5(), tmp13_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp14_local9 = tmp45_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp14_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp15_local10 = tmp45_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp15_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp16_local11 = tmp45_input.x13(tmp0_desc, 11, tmp46_cached[11].f2(), tmp16_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp17_local12 = tmp45_input.z13(tmp0_desc, 12, FloatSerializer_getInstance(), tmp17_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp18_local13 = tmp45_input.z13(tmp0_desc, 13, tmp46_cached[13].f2(), tmp18_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp19_local14 = tmp45_input.x13(tmp0_desc, 14, tmp46_cached[14].f2(), tmp19_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp20_local15 = tmp45_input.z13(tmp0_desc, 15, $serializer_getInstance_9(), tmp20_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp21_local16 = tmp45_input.x13(tmp0_desc, 16, tmp46_cached[16].f2(), tmp21_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp22_local17 = tmp45_input.z13(tmp0_desc, 17, $serializer_getInstance_4(), tmp22_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp23_local18 = tmp45_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp23_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp24_local19 = tmp45_input.z13(tmp0_desc, 19, $serializer_getInstance_4(), tmp24_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          tmp25_local20 = tmp45_input.z13(tmp0_desc, 20, tmp46_cached[20].f2(), tmp25_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          tmp26_local21 = tmp45_input.z13(tmp0_desc, 21, $serializer_getInstance_4(), tmp26_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          tmp27_local22 = tmp45_input.z13(tmp0_desc, 22, tmp46_cached[22].f2(), tmp27_local22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          tmp28_local23 = tmp45_input.z13(tmp0_desc, 23, $serializer_getInstance_10(), tmp28_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          tmp29_local24 = tmp45_input.n13(tmp0_desc, 24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          tmp30_local25 = tmp45_input.x13(tmp0_desc, 25, tmp46_cached[25].f2(), tmp30_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp31_local26;
          var tmp_7 = tmp45_input.x13(tmp0_desc, 26, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp31_local26 = tmp_7 == null ? null : tmp_7.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          var tmp_8 = $serializer_getInstance_2();
          var tmp_9 = tmp32_local27;
          var tmp_10 = tmp45_input.x13(tmp0_desc, 27, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp32_local27 = tmp_10 == null ? null : tmp_10.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
          tmp33_local28 = tmp45_input.x13(tmp0_desc, 28, tmp46_cached[28].f2(), tmp33_local28);
          tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
          var tmp_11 = $serializer_getInstance_2();
          var tmp_12 = tmp34_local29;
          var tmp_13 = tmp45_input.x13(tmp0_desc, 29, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
          tmp34_local29 = tmp_13 == null ? null : tmp_13.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
          var tmp_14 = $serializer_getInstance_2();
          var tmp_15 = tmp35_local30;
          var tmp_16 = tmp45_input.x13(tmp0_desc, 30, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
          tmp35_local30 = tmp_16 == null ? null : tmp_16.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
          var tmp_17 = $serializer_getInstance_2();
          var tmp_18 = tmp36_local31;
          var tmp_19 = tmp45_input.x13(tmp0_desc, 31, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
          tmp36_local31 = tmp_19 == null ? null : tmp_19.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
          var tmp_20 = $serializer_getInstance_2();
          var tmp_21 = tmp37_local32;
          var tmp_22 = tmp45_input.x13(tmp0_desc, 32, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
          tmp37_local32 = tmp_22 == null ? null : tmp_22.y5r_1;
          tmp4_bitMask1 = tmp4_bitMask1 | 1;
          var tmp_23 = $serializer_getInstance_2();
          var tmp_24 = tmp38_local33;
          var tmp_25 = tmp45_input.x13(tmp0_desc, 33, tmp_23, tmp_24 == null ? null : new (MonetaryValue())(tmp_24));
          tmp38_local33 = tmp_25 == null ? null : tmp_25.y5r_1;
          tmp4_bitMask1 = tmp4_bitMask1 | 2;
          var tmp_26 = $serializer_getInstance_2();
          var tmp_27 = tmp39_local34;
          var tmp_28 = tmp45_input.x13(tmp0_desc, 34, tmp_26, tmp_27 == null ? null : new (MonetaryValue())(tmp_27));
          tmp39_local34 = tmp_28 == null ? null : tmp_28.y5r_1;
          tmp4_bitMask1 = tmp4_bitMask1 | 4;
          tmp40_local35 = tmp45_input.z13(tmp0_desc, 35, tmp46_cached[35].f2(), tmp40_local35);
          tmp4_bitMask1 = tmp4_bitMask1 | 8;
          tmp41_local36 = tmp45_input.z13(tmp0_desc, 36, tmp46_cached[36].f2(), tmp41_local36);
          tmp4_bitMask1 = tmp4_bitMask1 | 16;
          tmp42_local37 = tmp45_input.z13(tmp0_desc, 37, tmp46_cached[37].f2(), tmp42_local37);
          tmp4_bitMask1 = tmp4_bitMask1 | 32;
          tmp43_local38 = tmp45_input.z13(tmp0_desc, 38, $serializer_getInstance_42(), tmp43_local38);
          tmp4_bitMask1 = tmp4_bitMask1 | 64;
          tmp44_local39 = tmp45_input.z13(tmp0_desc, 39, tmp46_cached[39].f2(), tmp44_local39);
          tmp4_bitMask1 = tmp4_bitMask1 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp45_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp5_local0 = tmp45_input.x13(tmp0_desc, 0, tmp46_cached[0].f2(), tmp5_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_29 = $serializer_getInstance_58();
                var tmp_30 = tmp6_local1;
                var tmp_31 = tmp45_input.x13(tmp0_desc, 1, tmp_29, tmp_30 == null ? null : new (ShortId())(tmp_30));
                tmp6_local1 = tmp_31 == null ? null : tmp_31.l5n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp7_local2 = tmp45_input.x13(tmp0_desc, 2, tmp46_cached[2].f2(), tmp7_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_32 = $serializer_getInstance_58();
                var tmp_33 = tmp8_local3;
                var tmp_34 = tmp45_input.x13(tmp0_desc, 3, tmp_32, tmp_33 == null ? null : new (ShortId())(tmp_33));
                tmp8_local3 = tmp_34 == null ? null : tmp_34.l5n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp9_local4 = tmp45_input.z13(tmp0_desc, 4, tmp46_cached[4].f2(), tmp9_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp10_local5 = tmp45_input.z13(tmp0_desc, 5, tmp46_cached[5].f2(), tmp10_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp11_local6 = tmp45_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp12_local7 = tmp45_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp13_local8 = tmp45_input.x13(tmp0_desc, 8, $serializer_getInstance_5(), tmp13_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp14_local9 = tmp45_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp14_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp15_local10 = tmp45_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp15_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp16_local11 = tmp45_input.x13(tmp0_desc, 11, tmp46_cached[11].f2(), tmp16_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp17_local12 = tmp45_input.z13(tmp0_desc, 12, FloatSerializer_getInstance(), tmp17_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp18_local13 = tmp45_input.z13(tmp0_desc, 13, tmp46_cached[13].f2(), tmp18_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp19_local14 = tmp45_input.x13(tmp0_desc, 14, tmp46_cached[14].f2(), tmp19_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp20_local15 = tmp45_input.z13(tmp0_desc, 15, $serializer_getInstance_9(), tmp20_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp21_local16 = tmp45_input.x13(tmp0_desc, 16, tmp46_cached[16].f2(), tmp21_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp22_local17 = tmp45_input.z13(tmp0_desc, 17, $serializer_getInstance_4(), tmp22_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp23_local18 = tmp45_input.z13(tmp0_desc, 18, $serializer_getInstance_4(), tmp23_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp24_local19 = tmp45_input.z13(tmp0_desc, 19, $serializer_getInstance_4(), tmp24_local19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              case 20:
                tmp25_local20 = tmp45_input.z13(tmp0_desc, 20, tmp46_cached[20].f2(), tmp25_local20);
                tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
                break;
              case 21:
                tmp26_local21 = tmp45_input.z13(tmp0_desc, 21, $serializer_getInstance_4(), tmp26_local21);
                tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
                break;
              case 22:
                tmp27_local22 = tmp45_input.z13(tmp0_desc, 22, tmp46_cached[22].f2(), tmp27_local22);
                tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
                break;
              case 23:
                tmp28_local23 = tmp45_input.z13(tmp0_desc, 23, $serializer_getInstance_10(), tmp28_local23);
                tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
                break;
              case 24:
                tmp29_local24 = tmp45_input.n13(tmp0_desc, 24);
                tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
                break;
              case 25:
                tmp30_local25 = tmp45_input.x13(tmp0_desc, 25, tmp46_cached[25].f2(), tmp30_local25);
                tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
                break;
              case 26:
                var tmp_35 = $serializer_getInstance_2();
                var tmp_36 = tmp31_local26;
                var tmp_37 = tmp45_input.x13(tmp0_desc, 26, tmp_35, tmp_36 == null ? null : new (MonetaryValue())(tmp_36));
                tmp31_local26 = tmp_37 == null ? null : tmp_37.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
                break;
              case 27:
                var tmp_38 = $serializer_getInstance_2();
                var tmp_39 = tmp32_local27;
                var tmp_40 = tmp45_input.x13(tmp0_desc, 27, tmp_38, tmp_39 == null ? null : new (MonetaryValue())(tmp_39));
                tmp32_local27 = tmp_40 == null ? null : tmp_40.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
                break;
              case 28:
                tmp33_local28 = tmp45_input.x13(tmp0_desc, 28, tmp46_cached[28].f2(), tmp33_local28);
                tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
                break;
              case 29:
                var tmp_41 = $serializer_getInstance_2();
                var tmp_42 = tmp34_local29;
                var tmp_43 = tmp45_input.x13(tmp0_desc, 29, tmp_41, tmp_42 == null ? null : new (MonetaryValue())(tmp_42));
                tmp34_local29 = tmp_43 == null ? null : tmp_43.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
                break;
              case 30:
                var tmp_44 = $serializer_getInstance_2();
                var tmp_45 = tmp35_local30;
                var tmp_46 = tmp45_input.x13(tmp0_desc, 30, tmp_44, tmp_45 == null ? null : new (MonetaryValue())(tmp_45));
                tmp35_local30 = tmp_46 == null ? null : tmp_46.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
                break;
              case 31:
                var tmp_47 = $serializer_getInstance_2();
                var tmp_48 = tmp36_local31;
                var tmp_49 = tmp45_input.x13(tmp0_desc, 31, tmp_47, tmp_48 == null ? null : new (MonetaryValue())(tmp_48));
                tmp36_local31 = tmp_49 == null ? null : tmp_49.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
                break;
              case 32:
                var tmp_50 = $serializer_getInstance_2();
                var tmp_51 = tmp37_local32;
                var tmp_52 = tmp45_input.x13(tmp0_desc, 32, tmp_50, tmp_51 == null ? null : new (MonetaryValue())(tmp_51));
                tmp37_local32 = tmp_52 == null ? null : tmp_52.y5r_1;
                tmp4_bitMask1 = tmp4_bitMask1 | 1;
                break;
              case 33:
                var tmp_53 = $serializer_getInstance_2();
                var tmp_54 = tmp38_local33;
                var tmp_55 = tmp45_input.x13(tmp0_desc, 33, tmp_53, tmp_54 == null ? null : new (MonetaryValue())(tmp_54));
                tmp38_local33 = tmp_55 == null ? null : tmp_55.y5r_1;
                tmp4_bitMask1 = tmp4_bitMask1 | 2;
                break;
              case 34:
                var tmp_56 = $serializer_getInstance_2();
                var tmp_57 = tmp39_local34;
                var tmp_58 = tmp45_input.x13(tmp0_desc, 34, tmp_56, tmp_57 == null ? null : new (MonetaryValue())(tmp_57));
                tmp39_local34 = tmp_58 == null ? null : tmp_58.y5r_1;
                tmp4_bitMask1 = tmp4_bitMask1 | 4;
                break;
              case 35:
                tmp40_local35 = tmp45_input.z13(tmp0_desc, 35, tmp46_cached[35].f2(), tmp40_local35);
                tmp4_bitMask1 = tmp4_bitMask1 | 8;
                break;
              case 36:
                tmp41_local36 = tmp45_input.z13(tmp0_desc, 36, tmp46_cached[36].f2(), tmp41_local36);
                tmp4_bitMask1 = tmp4_bitMask1 | 16;
                break;
              case 37:
                tmp42_local37 = tmp45_input.z13(tmp0_desc, 37, tmp46_cached[37].f2(), tmp42_local37);
                tmp4_bitMask1 = tmp4_bitMask1 | 32;
                break;
              case 38:
                tmp43_local38 = tmp45_input.z13(tmp0_desc, 38, $serializer_getInstance_42(), tmp43_local38);
                tmp4_bitMask1 = tmp4_bitMask1 | 64;
                break;
              case 39:
                tmp44_local39 = tmp45_input.z13(tmp0_desc, 39, tmp46_cached[39].f2(), tmp44_local39);
                tmp4_bitMask1 = tmp4_bitMask1 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp45_input.m13(tmp0_desc);
        return Project().p97(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, tmp39_local34, tmp40_local35, tmp41_local36, tmp42_local37, tmp43_local38, tmp44_local39, null);
      }
      az() {
        return this.n97_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_42().n7a_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), $serializer_getInstance_58(), tmp0_cached[2].f2(), $serializer_getInstance_58(), get_nullable(tmp0_cached[4].f2()), get_nullable(tmp0_cached[5].f2()), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[11].f2(), get_nullable(FloatSerializer_getInstance()), get_nullable(tmp0_cached[13].f2()), tmp0_cached[14].f2(), get_nullable($serializer_getInstance_9()), tmp0_cached[16].f2(), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_4()), get_nullable(tmp0_cached[20].f2()), get_nullable($serializer_getInstance_4()), get_nullable(tmp0_cached[22].f2()), get_nullable($serializer_getInstance_10()), BooleanSerializer_getInstance(), tmp0_cached[25].f2(), $serializer_getInstance_2(), $serializer_getInstance_2(), tmp0_cached[28].f2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), $serializer_getInstance_2(), get_nullable(tmp0_cached[35].f2()), get_nullable(tmp0_cached[36].f2()), get_nullable(tmp0_cached[37].f2()), get_nullable($serializer_getInstance_42()), get_nullable(tmp0_cached[39].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_27 = $;
  }
  return $serializerClass_27;
}
var $serializer_instance_27;
function $serializer_getInstance_43() {
  if ($serializer_instance_27 === VOID)
    new ($serializer_27())();
  return $serializer_instance_27;
}
var ProjectClass;
function Project() {
  if (ProjectClass === VOID) {
    class $ {
      constructor(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy) {
        Companion_getInstance_42();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        shortId = shortId === VOID ? Companion_instance_47.i5n() : shortId;
        customer = customer === VOID ? null : customer;
        client = client === VOID ? null : client;
        location = location === VOID ? null : location;
        jobNumber = jobNumber === VOID ? null : jobNumber;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        retention = retention === VOID ? null : retention;
        published = published === VOID ? null : published;
        readBy = readBy === VOID ? emptySet() : readBy;
        feedback = feedback === VOID ? null : feedback;
        var tmp_0;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance_0).b1m();
        } else {
          tmp_0 = created;
        }
        created = tmp_0;
        cancelled = cancelled === VOID ? null : cancelled;
        abandoned = abandoned === VOID ? null : abandoned;
        archived = archived === VOID ? null : archived;
        viewedByCustomer = viewedByCustomer === VOID ? null : viewedByCustomer;
        approved = approved === VOID ? null : approved;
        terminated = terminated === VOID ? null : terminated;
        complete = complete === VOID ? null : complete;
        isArchived = isArchived === VOID ? false : isArchived;
        state = state === VOID ? ProjectState_Creating_getInstance() : state;
        originalPrice = originalPrice === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : originalPrice;
        activePrice = activePrice === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : activePrice;
        projectCredits = projectCredits === VOID ? emptyList() : projectCredits;
        acceptedChangeAmount = acceptedChangeAmount === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : acceptedChangeAmount;
        fundingRequested = fundingRequested === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : fundingRequested;
        clientDeposits = clientDeposits === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : clientDeposits;
        pendingClientDeposits = pendingClientDeposits === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : pendingClientDeposits;
        contractorPayments = contractorPayments === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : contractorPayments;
        clientReturn = clientReturn === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : clientReturn;
        started = started === VOID ? null : started;
        preSubstantialCompletion = preSubstantialCompletion === VOID ? null : preSubstantialCompletion;
        substantialCompletion = substantialCompletion === VOID ? null : substantialCompletion;
        locked = locked === VOID ? null : locked;
        lastModifiedBy = lastModifiedBy === VOID ? null : lastModifiedBy;
        this.v7a_1 = _id;
        this.w7a_1 = shortId;
        this.x7a_1 = contractor;
        this.y7a_1 = contractorShortId;
        this.z7a_1 = customer;
        this.a7b_1 = client;
        this.b7b_1 = name;
        this.c7b_1 = description;
        this.d7b_1 = address;
        this.e7b_1 = location;
        this.f7b_1 = jobNumber;
        this.g7b_1 = files;
        this.h7b_1 = retention;
        this.i7b_1 = published;
        this.j7b_1 = readBy;
        this.k7b_1 = feedback;
        this.l7b_1 = created;
        this.m7b_1 = cancelled;
        this.n7b_1 = abandoned;
        this.o7b_1 = archived;
        this.p7b_1 = viewedByCustomer;
        this.q7b_1 = approved;
        this.r7b_1 = terminated;
        this.s7b_1 = complete;
        this.t7b_1 = isArchived;
        this.u7b_1 = state;
        this.v7b_1 = originalPrice;
        this.w7b_1 = activePrice;
        this.x7b_1 = projectCredits;
        this.y7b_1 = acceptedChangeAmount;
        this.z7b_1 = fundingRequested;
        this.a7c_1 = clientDeposits;
        this.b7c_1 = pendingClientDeposits;
        this.c7c_1 = contractorPayments;
        this.d7c_1 = clientReturn;
        this.e7c_1 = started;
        this.f7c_1 = preSubstantialCompletion;
        this.g7c_1 = substantialCompletion;
        this.h7c_1 = locked;
        this.i7c_1 = lastModifiedBy;
      }
      f40() {
        return this.v7a_1;
      }
      v91() {
        return this.j7b_1;
      }
      q97() {
        return ShortId__toString_impl_wslzee(this.y7a_1) + '-' + ShortId__toString_impl_wslzee(this.w7a_1);
      }
      r97() {
        return coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(this.z7b_1, this.a7c_1), this.b7c_1)), new (MonetaryValue())(Companion_instance.m62(0))).y5r_1;
      }
      s97() {
        return coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(this.w7b_1, this.a7c_1)), new (MonetaryValue())(Companion_instance.m62(0))).y5r_1;
      }
      t97() {
        return MonetaryValue__compareTo_impl_w7ul1r(this.a7c_1, this.w7b_1) >= 0;
      }
      u97() {
        return MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(this.a7c_1, this.c7c_1), this.d7c_1);
      }
      v97() {
        return coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(this.a7c_1, this.w7b_1)), new (MonetaryValue())(Companion_instance.r91(0n))).y5r_1;
      }
      w97() {
        var tmp0_safe_receiver = this.h7b_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_0;
          if (!(tmp0_safe_receiver < 0.05)) {
            tmp_0 = tmp0_safe_receiver;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? 0.05 : tmp1_elvis_lhs;
      }
      u91() {
        return this.x7b_1;
      }
      x97(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy) {
        return new (Project())(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy);
      }
      k7c(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy, $super) {
        _id = _id === VOID ? this.v7a_1 : _id;
        shortId = shortId === VOID ? this.w7a_1 : shortId;
        contractor = contractor === VOID ? this.x7a_1 : contractor;
        contractorShortId = contractorShortId === VOID ? this.y7a_1 : contractorShortId;
        customer = customer === VOID ? this.z7a_1 : customer;
        client = client === VOID ? this.a7b_1 : client;
        name = name === VOID ? this.b7b_1 : name;
        description = description === VOID ? this.c7b_1 : description;
        address = address === VOID ? this.d7b_1 : address;
        location = location === VOID ? this.e7b_1 : location;
        jobNumber = jobNumber === VOID ? this.f7b_1 : jobNumber;
        files = files === VOID ? this.g7b_1 : files;
        retention = retention === VOID ? this.h7b_1 : retention;
        published = published === VOID ? this.i7b_1 : published;
        readBy = readBy === VOID ? this.j7b_1 : readBy;
        feedback = feedback === VOID ? this.k7b_1 : feedback;
        created = created === VOID ? this.l7b_1 : created;
        cancelled = cancelled === VOID ? this.m7b_1 : cancelled;
        abandoned = abandoned === VOID ? this.n7b_1 : abandoned;
        archived = archived === VOID ? this.o7b_1 : archived;
        viewedByCustomer = viewedByCustomer === VOID ? this.p7b_1 : viewedByCustomer;
        approved = approved === VOID ? this.q7b_1 : approved;
        terminated = terminated === VOID ? this.r7b_1 : terminated;
        complete = complete === VOID ? this.s7b_1 : complete;
        isArchived = isArchived === VOID ? this.t7b_1 : isArchived;
        state = state === VOID ? this.u7b_1 : state;
        originalPrice = originalPrice === VOID ? this.v7b_1 : originalPrice;
        activePrice = activePrice === VOID ? this.w7b_1 : activePrice;
        projectCredits = projectCredits === VOID ? this.x7b_1 : projectCredits;
        acceptedChangeAmount = acceptedChangeAmount === VOID ? this.y7b_1 : acceptedChangeAmount;
        fundingRequested = fundingRequested === VOID ? this.z7b_1 : fundingRequested;
        clientDeposits = clientDeposits === VOID ? this.a7c_1 : clientDeposits;
        pendingClientDeposits = pendingClientDeposits === VOID ? this.b7c_1 : pendingClientDeposits;
        contractorPayments = contractorPayments === VOID ? this.c7c_1 : contractorPayments;
        clientReturn = clientReturn === VOID ? this.d7c_1 : clientReturn;
        started = started === VOID ? this.e7c_1 : started;
        preSubstantialCompletion = preSubstantialCompletion === VOID ? this.f7c_1 : preSubstantialCompletion;
        substantialCompletion = substantialCompletion === VOID ? this.g7c_1 : substantialCompletion;
        locked = locked === VOID ? this.h7c_1 : locked;
        lastModifiedBy = lastModifiedBy === VOID ? this.i7c_1 : lastModifiedBy;
        return $super === VOID ? this.x97(_id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy) : $super.x97.call(this, _id, new (ShortId())(shortId), contractor, new (ShortId())(contractorShortId), customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, new (MonetaryValue())(originalPrice), new (MonetaryValue())(activePrice), projectCredits, new (MonetaryValue())(acceptedChangeAmount), new (MonetaryValue())(fundingRequested), new (MonetaryValue())(clientDeposits), new (MonetaryValue())(pendingClientDeposits), new (MonetaryValue())(contractorPayments), new (MonetaryValue())(clientReturn), started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy);
      }
      toString() {
        return 'Project(_id=' + this.v7a_1.toString() + ', shortId=' + ShortId__toString_impl_wslzee(this.w7a_1) + ', contractor=' + this.x7a_1.toString() + ', contractorShortId=' + ShortId__toString_impl_wslzee(this.y7a_1) + ', customer=' + toString_0(this.z7a_1) + ', client=' + toString_0(this.a7b_1) + ', name=' + this.b7b_1 + ', description=' + this.c7b_1 + ', address=' + this.d7b_1.toString() + ', location=' + this.e7b_1 + ', jobNumber=' + this.f7b_1 + ', files=' + toString(this.g7b_1) + ', retention=' + this.h7b_1 + ', published=' + toString_0(this.i7b_1) + ', readBy=' + toString(this.j7b_1) + ', feedback=' + toString_0(this.k7b_1) + ', created=' + this.l7b_1.toString() + ', cancelled=' + toString_0(this.m7b_1) + ', abandoned=' + toString_0(this.n7b_1) + ', archived=' + toString_0(this.o7b_1) + ', viewedByCustomer=' + toString_0(this.p7b_1) + ', approved=' + toString_0(this.q7b_1) + ', terminated=' + toString_0(this.r7b_1) + ', complete=' + toString_0(this.s7b_1) + ', isArchived=' + this.t7b_1 + ', state=' + toString(this.u7b_1) + ', originalPrice=' + MonetaryValue__toString_impl_xslc77(this.v7b_1) + ', activePrice=' + MonetaryValue__toString_impl_xslc77(this.w7b_1) + ', projectCredits=' + toString(this.x7b_1) + ', acceptedChangeAmount=' + MonetaryValue__toString_impl_xslc77(this.y7b_1) + ', fundingRequested=' + MonetaryValue__toString_impl_xslc77(this.z7b_1) + ', clientDeposits=' + MonetaryValue__toString_impl_xslc77(this.a7c_1) + ', pendingClientDeposits=' + MonetaryValue__toString_impl_xslc77(this.b7c_1) + ', contractorPayments=' + MonetaryValue__toString_impl_xslc77(this.c7c_1) + ', clientReturn=' + MonetaryValue__toString_impl_xslc77(this.d7c_1) + ', started=' + toString_0(this.e7c_1) + ', preSubstantialCompletion=' + toString_0(this.f7c_1) + ', substantialCompletion=' + toString_0(this.g7c_1) + ', locked=' + toString_0(this.h7c_1) + ', lastModifiedBy=' + toString_0(this.i7c_1) + ')';
      }
      hashCode() {
        var result = this.v7a_1.hashCode();
        result = imul(result, 31) + ShortId__hashCode_impl_ghc5rv(this.w7a_1) | 0;
        result = imul(result, 31) + this.x7a_1.hashCode() | 0;
        result = imul(result, 31) + ShortId__hashCode_impl_ghc5rv(this.y7a_1) | 0;
        result = imul(result, 31) + (this.z7a_1 == null ? 0 : this.z7a_1.hashCode()) | 0;
        result = imul(result, 31) + (this.a7b_1 == null ? 0 : this.a7b_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.b7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c7b_1) | 0;
        result = imul(result, 31) + this.d7b_1.hashCode() | 0;
        result = imul(result, 31) + (this.e7b_1 == null ? 0 : getStringHashCode(this.e7b_1)) | 0;
        result = imul(result, 31) + (this.f7b_1 == null ? 0 : getStringHashCode(this.f7b_1)) | 0;
        result = imul(result, 31) + hashCode(this.g7b_1) | 0;
        result = imul(result, 31) + (this.h7b_1 == null ? 0 : getNumberHashCode(this.h7b_1)) | 0;
        result = imul(result, 31) + (this.i7b_1 == null ? 0 : this.i7b_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.j7b_1) | 0;
        result = imul(result, 31) + (this.k7b_1 == null ? 0 : this.k7b_1.hashCode()) | 0;
        result = imul(result, 31) + this.l7b_1.hashCode() | 0;
        result = imul(result, 31) + (this.m7b_1 == null ? 0 : this.m7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.n7b_1 == null ? 0 : this.n7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.o7b_1 == null ? 0 : this.o7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.p7b_1 == null ? 0 : this.p7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q7b_1 == null ? 0 : this.q7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.r7b_1 == null ? 0 : this.r7b_1.hashCode()) | 0;
        result = imul(result, 31) + (this.s7b_1 == null ? 0 : this.s7b_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t7b_1) | 0;
        result = imul(result, 31) + this.u7b_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.v7b_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.w7b_1) | 0;
        result = imul(result, 31) + hashCode(this.x7b_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.y7b_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.z7b_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.a7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.b7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.c7c_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.d7c_1) | 0;
        result = imul(result, 31) + (this.e7c_1 == null ? 0 : this.e7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.f7c_1 == null ? 0 : this.f7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.g7c_1 == null ? 0 : this.g7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.h7c_1 == null ? 0 : this.h7c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.i7c_1 == null ? 0 : this.i7c_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Project()))
          return false;
        if (!this.v7a_1.equals(other.v7a_1))
          return false;
        if (!(this.w7a_1 === other.w7a_1))
          return false;
        if (!this.x7a_1.equals(other.x7a_1))
          return false;
        if (!(this.y7a_1 === other.y7a_1))
          return false;
        if (!equals(this.z7a_1, other.z7a_1))
          return false;
        if (!equals(this.a7b_1, other.a7b_1))
          return false;
        if (!(this.b7b_1 === other.b7b_1))
          return false;
        if (!(this.c7b_1 === other.c7b_1))
          return false;
        if (!this.d7b_1.equals(other.d7b_1))
          return false;
        if (!(this.e7b_1 == other.e7b_1))
          return false;
        if (!(this.f7b_1 == other.f7b_1))
          return false;
        if (!equals(this.g7b_1, other.g7b_1))
          return false;
        if (!equals(this.h7b_1, other.h7b_1))
          return false;
        if (!equals(this.i7b_1, other.i7b_1))
          return false;
        if (!equals(this.j7b_1, other.j7b_1))
          return false;
        if (!equals(this.k7b_1, other.k7b_1))
          return false;
        if (!this.l7b_1.equals(other.l7b_1))
          return false;
        if (!equals(this.m7b_1, other.m7b_1))
          return false;
        if (!equals(this.n7b_1, other.n7b_1))
          return false;
        if (!equals(this.o7b_1, other.o7b_1))
          return false;
        if (!equals(this.p7b_1, other.p7b_1))
          return false;
        if (!equals(this.q7b_1, other.q7b_1))
          return false;
        if (!equals(this.r7b_1, other.r7b_1))
          return false;
        if (!equals(this.s7b_1, other.s7b_1))
          return false;
        if (!(this.t7b_1 === other.t7b_1))
          return false;
        if (!this.u7b_1.equals(other.u7b_1))
          return false;
        if (!(this.v7b_1 === other.v7b_1))
          return false;
        if (!(this.w7b_1 === other.w7b_1))
          return false;
        if (!equals(this.x7b_1, other.x7b_1))
          return false;
        if (!(this.y7b_1 === other.y7b_1))
          return false;
        if (!(this.z7b_1 === other.z7b_1))
          return false;
        if (!(this.a7c_1 === other.a7c_1))
          return false;
        if (!(this.b7c_1 === other.b7c_1))
          return false;
        if (!(this.c7c_1 === other.c7c_1))
          return false;
        if (!(this.d7c_1 === other.d7c_1))
          return false;
        if (!equals(this.e7c_1, other.e7c_1))
          return false;
        if (!equals(this.f7c_1, other.f7c_1))
          return false;
        if (!equals(this.g7c_1, other.g7c_1))
          return false;
        if (!equals(this.h7c_1, other.h7c_1))
          return false;
        if (!equals(this.i7c_1, other.i7c_1))
          return false;
        return true;
      }
      static p97(seen0, seen1, _id, shortId, contractor, contractorShortId, customer, client, name, description, address, location, jobNumber, files, retention, published, readBy, feedback, created, cancelled, abandoned, archived, viewedByCustomer, approved, terminated, complete, isArchived, state, originalPrice, activePrice, projectCredits, acceptedChangeAmount, fundingRequested, clientDeposits, pendingClientDeposits, contractorPayments, clientReturn, started, preSubstantialCompletion, substantialCompletion, locked, lastModifiedBy, serializationConstructorMarker) {
        Companion_getInstance_42();
        if (!!(!(460 === (460 & seen0)) | !(0 === (0 & seen1)))) {
          // Inline function 'kotlin.intArrayOf' call
          var tmp = new Int32Array([seen0, seen1]);
          // Inline function 'kotlin.intArrayOf' call
          var tmp$ret$1 = new Int32Array([460, 0]);
          throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_43().n97_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.v7a_1 = Companion_getInstance().k2p();
        else
          $this.v7a_1 = _id;
        if (0 === (seen0 & 2))
          $this.w7a_1 = Companion_instance_47.i5n();
        else
          $this.w7a_1 = shortId;
        $this.x7a_1 = contractor;
        $this.y7a_1 = contractorShortId;
        if (0 === (seen0 & 16))
          $this.z7a_1 = null;
        else
          $this.z7a_1 = customer;
        if (0 === (seen0 & 32))
          $this.a7b_1 = null;
        else
          $this.a7b_1 = client;
        $this.b7b_1 = name;
        $this.c7b_1 = description;
        $this.d7b_1 = address;
        if (0 === (seen0 & 512))
          $this.e7b_1 = null;
        else
          $this.e7b_1 = location;
        if (0 === (seen0 & 1024))
          $this.f7b_1 = null;
        else
          $this.f7b_1 = jobNumber;
        if (0 === (seen0 & 2048)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp_0.g7b_1 = emptyList();
        } else
          $this.g7b_1 = files;
        if (0 === (seen0 & 4096))
          $this.h7b_1 = null;
        else
          $this.h7b_1 = retention;
        if (0 === (seen0 & 8192))
          $this.i7b_1 = null;
        else
          $this.i7b_1 = published;
        if (0 === (seen0 & 16384))
          $this.j7b_1 = emptySet();
        else
          $this.j7b_1 = readBy;
        if (0 === (seen0 & 32768))
          $this.k7b_1 = null;
        else
          $this.k7b_1 = feedback;
        if (0 === (seen0 & 65536)) {
          var tmp_1 = $this;
          // Inline function 'com.lightningkite.now' call
          tmp_1.l7b_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.l7b_1 = created;
        if (0 === (seen0 & 131072))
          $this.m7b_1 = null;
        else
          $this.m7b_1 = cancelled;
        if (0 === (seen0 & 262144))
          $this.n7b_1 = null;
        else
          $this.n7b_1 = abandoned;
        if (0 === (seen0 & 524288))
          $this.o7b_1 = null;
        else
          $this.o7b_1 = archived;
        if (0 === (seen0 & 1048576))
          $this.p7b_1 = null;
        else
          $this.p7b_1 = viewedByCustomer;
        if (0 === (seen0 & 2097152))
          $this.q7b_1 = null;
        else
          $this.q7b_1 = approved;
        if (0 === (seen0 & 4194304))
          $this.r7b_1 = null;
        else
          $this.r7b_1 = terminated;
        if (0 === (seen0 & 8388608))
          $this.s7b_1 = null;
        else
          $this.s7b_1 = complete;
        if (0 === (seen0 & 16777216))
          $this.t7b_1 = false;
        else
          $this.t7b_1 = isArchived;
        if (0 === (seen0 & 33554432))
          $this.u7b_1 = ProjectState_Creating_getInstance();
        else
          $this.u7b_1 = state;
        if (0 === (seen0 & 67108864))
          $this.v7b_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.v7b_1 = originalPrice;
        if (0 === (seen0 & 134217728))
          $this.w7b_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.w7b_1 = activePrice;
        if (0 === (seen0 & 268435456))
          $this.x7b_1 = emptyList();
        else
          $this.x7b_1 = projectCredits;
        if (0 === (seen0 & 536870912))
          $this.y7b_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.y7b_1 = acceptedChangeAmount;
        if (0 === (seen0 & 1073741824))
          $this.z7b_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.z7b_1 = fundingRequested;
        if (0 === (seen0 & -2147483648))
          $this.a7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.a7c_1 = clientDeposits;
        if (0 === (seen1 & 1))
          $this.b7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.b7c_1 = pendingClientDeposits;
        if (0 === (seen1 & 2))
          $this.c7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.c7c_1 = contractorPayments;
        if (0 === (seen1 & 4))
          $this.d7c_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.d7c_1 = clientReturn;
        if (0 === (seen1 & 8))
          $this.e7c_1 = null;
        else
          $this.e7c_1 = started;
        if (0 === (seen1 & 16))
          $this.f7c_1 = null;
        else
          $this.f7c_1 = preSubstantialCompletion;
        if (0 === (seen1 & 32))
          $this.g7c_1 = null;
        else
          $this.g7c_1 = substantialCompletion;
        if (0 === (seen1 & 64))
          $this.h7c_1 = null;
        else
          $this.h7c_1 = locked;
        if (0 === (seen1 & 128))
          $this.i7c_1 = null;
        else
          $this.i7c_1 = lastModifiedBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Project', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_43});
    ProjectClass = $;
  }
  return ProjectClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.y97_1.f2();
}
function ProjectLedgerItem$ExternalDeposit$Type$Companion$_anonymous__vwkhit() {
  return createSimpleEnumSerializer('com.crowpay.ProjectLedgerItem.ExternalDeposit.Type', values_1());
}
var Type_Check_instance;
var Type_WireTransfer_instance;
function values_1() {
  return [Type_Check_getInstance(), Type_WireTransfer_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_1());
  return $ENTRIES_0;
}
var CompanionClass_29;
function Companion_29() {
  if (CompanionClass_29 === VOID) {
    class $ {
      constructor() {
        Companion_instance_31 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.y97_1 = lazy(tmp_0, ProjectLedgerItem$ExternalDeposit$Type$Companion$_anonymous__vwkhit);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_29 = $;
  }
  return CompanionClass_29;
}
var Companion_instance_31;
function Companion_getInstance_43() {
  Type_initEntries_0();
  if (Companion_instance_31 === VOID)
    new (Companion_29())();
  return Companion_instance_31;
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_Check_instance = Type_0().c98('Check', 0, 'Check');
  Type_WireTransfer_instance = Type_0().c98('WireTransfer', 1, 'Wire Transfer');
  Companion_getInstance_43();
}
var $ENTRIES_0;
function ProjectLedgerItem$ExternalDeposit$Companion$$childSerializers$_anonymous__faz3ga() {
  return Companion_getInstance_43().k2a();
}
var TypeClass_0;
function Type_0() {
  if (TypeClass_0 === VOID) {
    class $ extends Enum() {
      static c98(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.b98_1 = displayName;
        return $this;
      }
      e90() {
        return this.b98_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'Type', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_43});
    TypeClass_0 = $;
  }
  return TypeClass_0;
}
var CompanionClass_30;
function Companion_30() {
  if (CompanionClass_30 === VOID) {
    class $ {
      constructor() {
        Companion_instance_32 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o5z_1 = [null, null, lazy(tmp_0, ProjectLedgerItem$ExternalDeposit$Companion$$childSerializers$_anonymous__faz3ga), null];
      }
      k2a() {
        return $serializer_getInstance_44();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_30 = $;
  }
  return CompanionClass_30;
}
var Companion_instance_32;
function Companion_getInstance_44() {
  if (Companion_instance_32 === VOID)
    new (Companion_30())();
  return Companion_instance_32;
}
var $serializerClass_28;
function $serializer_28() {
  if ($serializerClass_28 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_28 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectLedgerItem.ExternalDeposit', this, 4);
        tmp0_serialDesc.a1b('amount', false);
        tmp0_serialDesc.a1b('checkNumber', false);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('notes', false);
        this.d98_1 = tmp0_serialDesc;
      }
      e98(encoder, value) {
        var tmp0_desc = this.d98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_44().o5z_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_2(), new (MonetaryValue())(value.t5z_1));
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.u5z_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.v5z_1);
        tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.w5z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e98(encoder, value instanceof ExternalDeposit() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_44().o5z_1;
        if (tmp8_input.a14()) {
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp8_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return ExternalDeposit().f98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.d98_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_44().o5z_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_2(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2].f2(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_28 = $;
  }
  return $serializerClass_28;
}
var $serializer_instance_28;
function $serializer_getInstance_44() {
  if ($serializer_instance_28 === VOID)
    new ($serializer_28())();
  return $serializer_instance_28;
}
function Type_Check_getInstance() {
  Type_initEntries_0();
  return Type_Check_instance;
}
function Type_WireTransfer_getInstance() {
  Type_initEntries_0();
  return Type_WireTransfer_instance;
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_3() {
  return Companion_getInstance_8().k2a();
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_4() {
  return Companion_getInstance_9().k2a();
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_5() {
  return Companion_getInstance_12().k2a();
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_7() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_8() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_9() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_10() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var ExternalDepositClass;
function ExternalDeposit() {
  if (ExternalDepositClass === VOID) {
    class $ {
      constructor(amount, checkNumber, type, notes) {
        Companion_getInstance_44();
        this.t5z_1 = amount;
        this.u5z_1 = checkNumber;
        this.v5z_1 = type;
        this.w5z_1 = notes;
      }
      g98(amount, checkNumber, type, notes) {
        return new (ExternalDeposit())(amount, checkNumber, type, notes);
      }
      y5z(amount, checkNumber, type, notes, $super) {
        amount = amount === VOID ? this.t5z_1 : amount;
        checkNumber = checkNumber === VOID ? this.u5z_1 : checkNumber;
        type = type === VOID ? this.v5z_1 : type;
        notes = notes === VOID ? this.w5z_1 : notes;
        return $super === VOID ? this.g98(amount, checkNumber, type, notes) : $super.g98.call(this, new (MonetaryValue())(amount), checkNumber, type, notes);
      }
      toString() {
        return 'ExternalDeposit(amount=' + MonetaryValue__toString_impl_xslc77(this.t5z_1) + ', checkNumber=' + this.u5z_1 + ', type=' + toString(this.v5z_1) + ', notes=' + this.w5z_1 + ')';
      }
      hashCode() {
        var result = MonetaryValue__hashCode_impl_fhcsz2(this.t5z_1);
        result = imul(result, 31) + (this.u5z_1 == null ? 0 : getStringHashCode(this.u5z_1)) | 0;
        result = imul(result, 31) + this.v5z_1.hashCode() | 0;
        result = imul(result, 31) + (this.w5z_1 == null ? 0 : getStringHashCode(this.w5z_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExternalDeposit()))
          return false;
        if (!(this.t5z_1 === other.t5z_1))
          return false;
        if (!(this.u5z_1 == other.u5z_1))
          return false;
        if (!this.v5z_1.equals(other.v5z_1))
          return false;
        if (!(this.w5z_1 == other.w5z_1))
          return false;
        return true;
      }
      static f98(seen0, amount, checkNumber, type, notes, serializationConstructorMarker) {
        Companion_getInstance_44();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_44().d98_1);
        }
        var $this = createThis(this);
        $this.t5z_1 = amount;
        $this.u5z_1 = checkNumber;
        $this.v5z_1 = type;
        $this.w5z_1 = notes;
        return $this;
      }
    }
    initMetadataForClass($, 'ExternalDeposit', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_44});
    ExternalDepositClass = $;
  }
  return ExternalDepositClass;
}
var CompanionClass_31;
function Companion_31() {
  if (CompanionClass_31 === VOID) {
    class $ {
      constructor() {
        Companion_instance_33 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_15 = lazy(tmp_14, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_6);
        var tmp_16 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_17 = lazy(tmp_16, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_7);
        var tmp_18 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_19 = lazy(tmp_18, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_8);
        var tmp_20 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_21 = lazy(tmp_20, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_9);
        var tmp_22 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i7k_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, null, null, null, tmp_11, null, tmp_13, tmp_15, tmp_17, tmp_19, null, null, tmp_21, lazy(tmp_22, ProjectLedgerItem$Companion$$childSerializers$_anonymous__tq8i3v_10)];
      }
      k2a() {
        return $serializer_getInstance_45();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_31 = $;
  }
  return CompanionClass_31;
}
var Companion_instance_33;
function Companion_getInstance_45() {
  if (Companion_instance_33 === VOID)
    new (Companion_31())();
  return Companion_instance_33;
}
var $serializerClass_29;
function $serializer_29() {
  if ($serializerClass_29 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_29 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectLedgerItem', this, 19);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Project()), 'Ledger Items'));
        tmp0_serialDesc.a1b('lineItem', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('payApp', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.a1b('party', false);
        tmp0_serialDesc.a1b('amount', true);
        tmp0_serialDesc.b1b(new (Description())('Positive indicates a payment into Stoze, negative indicates a payment out.'));
        tmp0_serialDesc.a1b('contractorFee', true);
        tmp0_serialDesc.a1b('platformFee', true);
        tmp0_serialDesc.a1b('processorFee', true);
        tmp0_serialDesc.a1b('state', false);
        tmp0_serialDesc.a1b('message', true);
        tmp0_serialDesc.a1b('method', true);
        tmp0_serialDesc.a1b('depositSucceeded', true);
        tmp0_serialDesc.a1b('payoutRequested', true);
        tmp0_serialDesc.a1b('payoutConfirmation', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('accountName', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('intentId', true);
        tmp0_serialDesc.a1b('check', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(MailCheckPhysically())));
        tmp0_serialDesc.a1b('created', true);
        tmp0_serialDesc.c1b(new (IndexSet())(['project', 'party']));
        tmp0_serialDesc.c1b(new (IndexSet())(['state', 'payoutRequested']));
        this.h98_1 = tmp0_serialDesc;
      }
      i98(encoder, value) {
        var tmp0_desc = this.h98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_45().i7k_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.n7k_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.n7k_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.o7k_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.p7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.p7k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.q7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.q7k_1);
        }
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.r7k_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.s7k_1 === _MonetaryValue___init__impl__jsc11x(0n))) {
          tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_2(), new (MonetaryValue())(value.s7k_1));
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp = true;
        } else {
          var tmp_0 = value.t7k_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.t7k_1;
          tmp1_output.d15(tmp0_desc, 6, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.u7k_1;
          tmp_3 = !((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = value.u7k_1;
          tmp1_output.d15(tmp0_desc, 7, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
        }
        var tmp_7;
        if (tmp1_output.h15(tmp0_desc, 8)) {
          tmp_7 = true;
        } else {
          var tmp_8 = value.v7k_1;
          tmp_7 = !((tmp_8 == null ? null : new (MonetaryValue())(tmp_8)) == null);
        }
        if (tmp_7) {
          var tmp_9 = $serializer_getInstance_2();
          var tmp_10 = value.v7k_1;
          tmp1_output.d15(tmp0_desc, 8, tmp_9, tmp_10 == null ? null : new (MonetaryValue())(tmp_10));
        }
        tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.w7k_1);
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.x7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, StringSerializer_getInstance(), value.x7k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.y7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, tmp2_cached[11].f2(), value.y7k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.z7k_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, tmp2_cached[12].f2(), value.z7k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.a7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 13, tmp2_cached[13].f2(), value.a7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.b7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 14, tmp2_cached[14].f2(), value.b7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !(value.c7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 15, StringSerializer_getInstance(), value.c7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 16) ? true : !(value.d7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 16, StringSerializer_getInstance(), value.d7l_1);
        }
        if (tmp1_output.h15(tmp0_desc, 17) ? true : !(value.e7l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 17, tmp2_cached[17].f2(), value.e7l_1);
        }
        var tmp_11;
        if (tmp1_output.h15(tmp0_desc, 18)) {
          tmp_11 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp_11 = !value.f7l_1.equals(tmp$ret$0);
        }
        if (tmp_11) {
          tmp1_output.c15(tmp0_desc, 18, tmp2_cached[18].f2(), value.f7l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i98(encoder, value instanceof ProjectLedgerItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = null;
        var tmp20_local16 = null;
        var tmp21_local17 = null;
        var tmp22_local18 = null;
        var tmp23_input = decoder.l13(tmp0_desc);
        var tmp24_cached = Companion_getInstance_45().i7k_1;
        if (tmp23_input.a14()) {
          tmp4_local0 = tmp23_input.x13(tmp0_desc, 0, tmp24_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp23_input.x13(tmp0_desc, 1, tmp24_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp23_input.z13(tmp0_desc, 2, tmp24_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp23_input.z13(tmp0_desc, 3, tmp24_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp23_input.x13(tmp0_desc, 4, tmp24_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp23_input.x13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp10_local6;
          var tmp_4 = tmp23_input.z13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp10_local6 = tmp_4 == null ? null : tmp_4.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_5 = $serializer_getInstance_2();
          var tmp_6 = tmp11_local7;
          var tmp_7 = tmp23_input.z13(tmp0_desc, 7, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp11_local7 = tmp_7 == null ? null : tmp_7.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_8 = $serializer_getInstance_2();
          var tmp_9 = tmp12_local8;
          var tmp_10 = tmp23_input.z13(tmp0_desc, 8, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp12_local8 = tmp_10 == null ? null : tmp_10.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp23_input.x13(tmp0_desc, 9, tmp24_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp23_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp23_input.z13(tmp0_desc, 11, tmp24_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp23_input.z13(tmp0_desc, 12, tmp24_cached[12].f2(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp23_input.z13(tmp0_desc, 13, tmp24_cached[13].f2(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp23_input.z13(tmp0_desc, 14, tmp24_cached[14].f2(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp23_input.z13(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp23_input.z13(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp23_input.z13(tmp0_desc, 17, tmp24_cached[17].f2(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp23_input.x13(tmp0_desc, 18, tmp24_cached[18].f2(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp23_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp23_input.x13(tmp0_desc, 0, tmp24_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp23_input.x13(tmp0_desc, 1, tmp24_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp23_input.z13(tmp0_desc, 2, tmp24_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp23_input.z13(tmp0_desc, 3, tmp24_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp23_input.x13(tmp0_desc, 4, tmp24_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp9_local5;
                var tmp_13 = tmp23_input.x13(tmp0_desc, 5, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
                tmp9_local5 = tmp_13 == null ? null : tmp_13.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_14 = $serializer_getInstance_2();
                var tmp_15 = tmp10_local6;
                var tmp_16 = tmp23_input.z13(tmp0_desc, 6, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
                tmp10_local6 = tmp_16 == null ? null : tmp_16.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_17 = $serializer_getInstance_2();
                var tmp_18 = tmp11_local7;
                var tmp_19 = tmp23_input.z13(tmp0_desc, 7, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
                tmp11_local7 = tmp_19 == null ? null : tmp_19.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_20 = $serializer_getInstance_2();
                var tmp_21 = tmp12_local8;
                var tmp_22 = tmp23_input.z13(tmp0_desc, 8, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
                tmp12_local8 = tmp_22 == null ? null : tmp_22.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp23_input.x13(tmp0_desc, 9, tmp24_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp23_input.z13(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp23_input.z13(tmp0_desc, 11, tmp24_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp23_input.z13(tmp0_desc, 12, tmp24_cached[12].f2(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp23_input.z13(tmp0_desc, 13, tmp24_cached[13].f2(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp23_input.z13(tmp0_desc, 14, tmp24_cached[14].f2(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp23_input.z13(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp23_input.z13(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp23_input.z13(tmp0_desc, 17, tmp24_cached[17].f2(), tmp21_local17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp23_input.x13(tmp0_desc, 18, tmp24_cached[18].f2(), tmp22_local18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp23_input.m13(tmp0_desc);
        return ProjectLedgerItem().j98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, null);
      }
      az() {
        return this.h98_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_45().i7k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), tmp0_cached[4].f2(), $serializer_getInstance_2(), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2()), tmp0_cached[9].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[11].f2()), get_nullable(tmp0_cached[12].f2()), get_nullable(tmp0_cached[13].f2()), get_nullable(tmp0_cached[14].f2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[17].f2()), tmp0_cached[18].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_29 = $;
  }
  return $serializerClass_29;
}
var $serializer_instance_29;
function $serializer_getInstance_45() {
  if ($serializer_instance_29 === VOID)
    new ($serializer_29())();
  return $serializer_instance_29;
}
var ProjectLedgerItemClass;
function ProjectLedgerItem() {
  if (ProjectLedgerItemClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created) {
        Companion_getInstance_45();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        payApp = payApp === VOID ? null : payApp;
        amount = amount === VOID ? _MonetaryValue___init__impl__jsc11x(0n) : amount;
        contractorFee = contractorFee === VOID ? null : contractorFee;
        platformFee = platformFee === VOID ? null : platformFee;
        processorFee = processorFee === VOID ? null : processorFee;
        message = message === VOID ? null : message;
        method = method === VOID ? null : method;
        depositSucceeded = depositSucceeded === VOID ? null : depositSucceeded;
        payoutRequested = payoutRequested === VOID ? null : payoutRequested;
        payoutConfirmation = payoutConfirmation === VOID ? null : payoutConfirmation;
        accountName = accountName === VOID ? null : accountName;
        intentId = intentId === VOID ? null : intentId;
        check = check === VOID ? null : check;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.n7k_1 = _id;
        this.o7k_1 = project;
        this.p7k_1 = lineItem;
        this.q7k_1 = payApp;
        this.r7k_1 = party;
        this.s7k_1 = amount;
        this.t7k_1 = contractorFee;
        this.u7k_1 = platformFee;
        this.v7k_1 = processorFee;
        this.w7k_1 = state;
        this.x7k_1 = message;
        this.y7k_1 = method;
        this.z7k_1 = depositSucceeded;
        this.a7l_1 = payoutRequested;
        this.b7l_1 = payoutConfirmation;
        this.c7l_1 = accountName;
        this.d7l_1 = intentId;
        this.e7l_1 = check;
        this.f7l_1 = created;
      }
      f40() {
        return this.n7k_1;
      }
      k98(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created) {
        return new (ProjectLedgerItem())(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created);
      }
      h7l(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created, $super) {
        _id = _id === VOID ? this.n7k_1 : _id;
        project = project === VOID ? this.o7k_1 : project;
        lineItem = lineItem === VOID ? this.p7k_1 : lineItem;
        payApp = payApp === VOID ? this.q7k_1 : payApp;
        party = party === VOID ? this.r7k_1 : party;
        amount = amount === VOID ? this.s7k_1 : amount;
        contractorFee = contractorFee === VOID ? this.t7k_1 : contractorFee;
        platformFee = platformFee === VOID ? this.u7k_1 : platformFee;
        processorFee = processorFee === VOID ? this.v7k_1 : processorFee;
        state = state === VOID ? this.w7k_1 : state;
        message = message === VOID ? this.x7k_1 : message;
        method = method === VOID ? this.y7k_1 : method;
        depositSucceeded = depositSucceeded === VOID ? this.z7k_1 : depositSucceeded;
        payoutRequested = payoutRequested === VOID ? this.a7l_1 : payoutRequested;
        payoutConfirmation = payoutConfirmation === VOID ? this.b7l_1 : payoutConfirmation;
        accountName = accountName === VOID ? this.c7l_1 : accountName;
        intentId = intentId === VOID ? this.d7l_1 : intentId;
        check = check === VOID ? this.e7l_1 : check;
        created = created === VOID ? this.f7l_1 : created;
        var tmp;
        if ($super === VOID) {
          tmp = this.k98(_id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created);
        } else {
          var tmp_0 = $super.k98;
          var tmp_1 = contractorFee;
          var tmp_2 = tmp_1 == null ? null : new (MonetaryValue())(tmp_1);
          var tmp_3 = platformFee;
          var tmp_4 = tmp_3 == null ? null : new (MonetaryValue())(tmp_3);
          var tmp_5 = processorFee;
          tmp = tmp_0.call(this, _id, project, lineItem, payApp, party, new (MonetaryValue())(amount), tmp_2, tmp_4, tmp_5 == null ? null : new (MonetaryValue())(tmp_5), state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created);
        }
        return tmp;
      }
      toString() {
        var tmp = this.n7k_1.toString();
        var tmp_0 = this.o7k_1.toString();
        var tmp_1 = toString_0(this.p7k_1);
        var tmp_2 = toString_0(this.q7k_1);
        var tmp_3 = this.r7k_1.toString();
        var tmp_4 = MonetaryValue__toString_impl_xslc77(this.s7k_1);
        var tmp_5 = this.t7k_1;
        var tmp_6 = toString_0(tmp_5 == null ? null : new (MonetaryValue())(tmp_5));
        var tmp_7 = this.u7k_1;
        var tmp_8 = toString_0(tmp_7 == null ? null : new (MonetaryValue())(tmp_7));
        var tmp_9 = this.v7k_1;
        return 'ProjectLedgerItem(_id=' + tmp + ', project=' + tmp_0 + ', lineItem=' + tmp_1 + ', payApp=' + tmp_2 + ', party=' + tmp_3 + ', amount=' + tmp_4 + ', contractorFee=' + tmp_6 + ', platformFee=' + tmp_8 + ', processorFee=' + toString_0(tmp_9 == null ? null : new (MonetaryValue())(tmp_9)) + ', state=' + toString(this.w7k_1) + ', message=' + this.x7k_1 + ', method=' + toString_0(this.y7k_1) + ', depositSucceeded=' + toString_0(this.z7k_1) + ', payoutRequested=' + toString_0(this.a7l_1) + ', payoutConfirmation=' + toString_0(this.b7l_1) + ', accountName=' + this.c7l_1 + ', intentId=' + this.d7l_1 + ', check=' + toString_0(this.e7l_1) + ', created=' + this.f7l_1.toString() + ')';
      }
      hashCode() {
        var result = this.n7k_1.hashCode();
        result = imul(result, 31) + this.o7k_1.hashCode() | 0;
        result = imul(result, 31) + (this.p7k_1 == null ? 0 : this.p7k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q7k_1 == null ? 0 : this.q7k_1.hashCode()) | 0;
        result = imul(result, 31) + this.r7k_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.s7k_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.t7k_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.t7k_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.u7k_1;
        if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = MonetaryValue__hashCode_impl_fhcsz2(this.u7k_1);
        }
        result = tmp_2 + tmp_3 | 0;
        var tmp_5 = imul(result, 31);
        var tmp_6;
        var tmp_7 = this.v7k_1;
        if ((tmp_7 == null ? null : new (MonetaryValue())(tmp_7)) == null) {
          tmp_6 = 0;
        } else {
          tmp_6 = MonetaryValue__hashCode_impl_fhcsz2(this.v7k_1);
        }
        result = tmp_5 + tmp_6 | 0;
        result = imul(result, 31) + this.w7k_1.hashCode() | 0;
        result = imul(result, 31) + (this.x7k_1 == null ? 0 : getStringHashCode(this.x7k_1)) | 0;
        result = imul(result, 31) + (this.y7k_1 == null ? 0 : this.y7k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.z7k_1 == null ? 0 : this.z7k_1.hashCode()) | 0;
        result = imul(result, 31) + (this.a7l_1 == null ? 0 : this.a7l_1.hashCode()) | 0;
        result = imul(result, 31) + (this.b7l_1 == null ? 0 : this.b7l_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c7l_1 == null ? 0 : getStringHashCode(this.c7l_1)) | 0;
        result = imul(result, 31) + (this.d7l_1 == null ? 0 : getStringHashCode(this.d7l_1)) | 0;
        result = imul(result, 31) + (this.e7l_1 == null ? 0 : this.e7l_1.hashCode()) | 0;
        result = imul(result, 31) + this.f7l_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectLedgerItem()))
          return false;
        if (!this.n7k_1.equals(other.n7k_1))
          return false;
        if (!this.o7k_1.equals(other.o7k_1))
          return false;
        if (!equals(this.p7k_1, other.p7k_1))
          return false;
        if (!equals(this.q7k_1, other.q7k_1))
          return false;
        if (!this.r7k_1.equals(other.r7k_1))
          return false;
        if (!(this.s7k_1 === other.s7k_1))
          return false;
        var tmp = this.t7k_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.t7k_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        var tmp_2 = this.u7k_1;
        var tmp_3 = tmp_2 == null ? null : new (MonetaryValue())(tmp_2);
        var tmp_4 = other.u7k_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (MonetaryValue())(tmp_4)))
          return false;
        var tmp_5 = this.v7k_1;
        var tmp_6 = tmp_5 == null ? null : new (MonetaryValue())(tmp_5);
        var tmp_7 = other.v7k_1;
        if (!equals(tmp_6, tmp_7 == null ? null : new (MonetaryValue())(tmp_7)))
          return false;
        if (!this.w7k_1.equals(other.w7k_1))
          return false;
        if (!(this.x7k_1 == other.x7k_1))
          return false;
        if (!equals(this.y7k_1, other.y7k_1))
          return false;
        if (!equals(this.z7k_1, other.z7k_1))
          return false;
        if (!equals(this.a7l_1, other.a7l_1))
          return false;
        if (!equals(this.b7l_1, other.b7l_1))
          return false;
        if (!(this.c7l_1 == other.c7l_1))
          return false;
        if (!(this.d7l_1 == other.d7l_1))
          return false;
        if (!equals(this.e7l_1, other.e7l_1))
          return false;
        if (!this.f7l_1.equals(other.f7l_1))
          return false;
        return true;
      }
      static j98(seen0, _id, project, lineItem, payApp, party, amount, contractorFee, platformFee, processorFee, state, message, method, depositSucceeded, payoutRequested, payoutConfirmation, accountName, intentId, check, created, serializationConstructorMarker) {
        Companion_getInstance_45();
        if (!(530 === (530 & seen0))) {
          throwMissingFieldException(seen0, 530, $serializer_getInstance_45().h98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.n7k_1 = Companion_getInstance().k2p();
        else
          $this.n7k_1 = _id;
        $this.o7k_1 = project;
        if (0 === (seen0 & 4))
          $this.p7k_1 = null;
        else
          $this.p7k_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.q7k_1 = null;
        else
          $this.q7k_1 = payApp;
        $this.r7k_1 = party;
        if (0 === (seen0 & 32))
          $this.s7k_1 = _MonetaryValue___init__impl__jsc11x(0n);
        else
          $this.s7k_1 = amount;
        if (0 === (seen0 & 64))
          $this.t7k_1 = null;
        else
          $this.t7k_1 = contractorFee;
        if (0 === (seen0 & 128))
          $this.u7k_1 = null;
        else
          $this.u7k_1 = platformFee;
        if (0 === (seen0 & 256))
          $this.v7k_1 = null;
        else
          $this.v7k_1 = processorFee;
        $this.w7k_1 = state;
        if (0 === (seen0 & 1024))
          $this.x7k_1 = null;
        else
          $this.x7k_1 = message;
        if (0 === (seen0 & 2048))
          $this.y7k_1 = null;
        else
          $this.y7k_1 = method;
        if (0 === (seen0 & 4096))
          $this.z7k_1 = null;
        else
          $this.z7k_1 = depositSucceeded;
        if (0 === (seen0 & 8192))
          $this.a7l_1 = null;
        else
          $this.a7l_1 = payoutRequested;
        if (0 === (seen0 & 16384))
          $this.b7l_1 = null;
        else
          $this.b7l_1 = payoutConfirmation;
        if (0 === (seen0 & 32768))
          $this.c7l_1 = null;
        else
          $this.c7l_1 = accountName;
        if (0 === (seen0 & 65536))
          $this.d7l_1 = null;
        else
          $this.d7l_1 = intentId;
        if (0 === (seen0 & 131072))
          $this.e7l_1 = null;
        else
          $this.e7l_1 = check;
        if (0 === (seen0 & 262144)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.f7l_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.f7l_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectLedgerItem', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_45});
    ProjectLedgerItemClass = $;
  }
  return ProjectLedgerItemClass;
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_2() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_4() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_32;
function Companion_32() {
  if (CompanionClass_32 === VOID) {
    class $ {
      constructor() {
        Companion_instance_34 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b7p_1 = [tmp_1, tmp_3, tmp_5, null, tmp_7, null, tmp_9, null, lazy(tmp_10, ProjectMessage$Companion$$childSerializers$_anonymous__gw1bwc_4), null, null, null];
      }
      k2a() {
        return $serializer_getInstance_46();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_32 = $;
  }
  return CompanionClass_32;
}
var Companion_instance_34;
function Companion_getInstance_46() {
  if (Companion_instance_34 === VOID)
    new (Companion_32())();
  return Companion_instance_34;
}
var $serializerClass_30;
function $serializer_30() {
  if ($serializerClass_30 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_30 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectMessage', this, 12);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('sender', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(User())));
        tmp0_serialDesc.a1b('senderName', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('senderIcon', true);
        tmp0_serialDesc.a1b('clientMessage', false);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('sent', true);
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('replyingToMessage', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('referencesChangeRequest', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        tmp0_serialDesc.a1b('referencesPayApp', true);
        tmp0_serialDesc.b1b(new (AdminViewOnly())());
        this.l98_1 = tmp0_serialDesc;
      }
      m98(encoder, value) {
        var tmp0_desc = this.l98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_46().b7p_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.g7p_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.g7p_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.h7p_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.i7p_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.j7p_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.j7p_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 4)) {
          tmp = true;
        } else {
          var tmp_0 = value.k7p_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[4].f2();
          var tmp_2 = value.k7p_1;
          tmp1_output.d15(tmp0_desc, 4, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.s14(tmp0_desc, 5, value.l7p_1);
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 6)) {
          tmp_3 = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp_3 = !value.m7p_1.equals(tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.m7p_1);
        }
        tmp1_output.a15(tmp0_desc, 7, value.n7p_1);
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.o7p_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.o7p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.p7p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_55(), value.p7p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.q7p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, $serializer_getInstance_57(), value.q7p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.r7p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, $serializer_getInstance_56(), value.r7p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m98(encoder, value instanceof ProjectMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = false;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_46().b7p_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp = tmp17_cached[4].f2();
          var tmp_0 = tmp8_local4;
          var tmp_1 = tmp16_input.z13(tmp0_desc, 4, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp8_local4 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.n13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.x13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, $serializer_getInstance_55(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, $serializer_getInstance_57(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, $serializer_getInstance_56(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.x13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_2 = tmp17_cached[4].f2();
                var tmp_3 = tmp8_local4;
                var tmp_4 = tmp16_input.z13(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp8_local4 = tmp_4 == null ? null : tmp_4.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.n13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.x13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.z13(tmp0_desc, 9, $serializer_getInstance_55(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, $serializer_getInstance_57(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, $serializer_getInstance_56(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return ProjectMessage().n98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
      }
      az() {
        return this.l98_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_46().b7p_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[4].f2()), BooleanSerializer_getInstance(), tmp0_cached[6].f2(), StringSerializer_getInstance(), tmp0_cached[8].f2(), get_nullable($serializer_getInstance_55()), get_nullable($serializer_getInstance_57()), get_nullable($serializer_getInstance_56())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_30 = $;
  }
  return $serializerClass_30;
}
var $serializer_instance_30;
function $serializer_getInstance_46() {
  if ($serializer_instance_30 === VOID)
    new ($serializer_30())();
  return $serializer_instance_30;
}
var ProjectMessageClass;
function ProjectMessage() {
  if (ProjectMessageClass === VOID) {
    class $ {
      constructor(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp) {
        Companion_getInstance_46();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        senderName = senderName === VOID ? '' : senderName;
        senderIcon = senderIcon === VOID ? null : senderIcon;
        var tmp;
        if (sent === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = sent;
        }
        sent = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        replyingToMessage = replyingToMessage === VOID ? null : replyingToMessage;
        referencesChangeRequest = referencesChangeRequest === VOID ? null : referencesChangeRequest;
        referencesPayApp = referencesPayApp === VOID ? null : referencesPayApp;
        this.g7p_1 = _id;
        this.h7p_1 = project;
        this.i7p_1 = sender;
        this.j7p_1 = senderName;
        this.k7p_1 = senderIcon;
        this.l7p_1 = clientMessage;
        this.m7p_1 = sent;
        this.n7p_1 = message;
        this.o7p_1 = readBy;
        this.p7p_1 = replyingToMessage;
        this.q7p_1 = referencesChangeRequest;
        this.r7p_1 = referencesPayApp;
      }
      f40() {
        return this.g7p_1;
      }
      v91() {
        return this.o7p_1;
      }
      o98(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp) {
        return new (ProjectMessage())(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp);
      }
      t7p(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp, $super) {
        _id = _id === VOID ? this.g7p_1 : _id;
        project = project === VOID ? this.h7p_1 : project;
        sender = sender === VOID ? this.i7p_1 : sender;
        senderName = senderName === VOID ? this.j7p_1 : senderName;
        senderIcon = senderIcon === VOID ? this.k7p_1 : senderIcon;
        clientMessage = clientMessage === VOID ? this.l7p_1 : clientMessage;
        sent = sent === VOID ? this.m7p_1 : sent;
        message = message === VOID ? this.n7p_1 : message;
        readBy = readBy === VOID ? this.o7p_1 : readBy;
        replyingToMessage = replyingToMessage === VOID ? this.p7p_1 : replyingToMessage;
        referencesChangeRequest = referencesChangeRequest === VOID ? this.q7p_1 : referencesChangeRequest;
        referencesPayApp = referencesPayApp === VOID ? this.r7p_1 : referencesPayApp;
        var tmp;
        if ($super === VOID) {
          tmp = this.o98(_id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp);
        } else {
          var tmp_0 = $super.o98;
          var tmp_1 = senderIcon;
          tmp = tmp_0.call(this, _id, project, sender, senderName, tmp_1 == null ? null : new (ServerFile())(tmp_1), clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp);
        }
        return tmp;
      }
      toString() {
        var tmp = this.g7p_1.toString();
        var tmp_0 = this.h7p_1.toString();
        var tmp_1 = this.i7p_1.toString();
        var tmp_2 = this.k7p_1;
        return 'ProjectMessage(_id=' + tmp + ', project=' + tmp_0 + ', sender=' + tmp_1 + ', senderName=' + this.j7p_1 + ', senderIcon=' + toString_0(tmp_2 == null ? null : new (ServerFile())(tmp_2)) + ', clientMessage=' + this.l7p_1 + ', sent=' + this.m7p_1.toString() + ', message=' + this.n7p_1 + ', readBy=' + toString(this.o7p_1) + ', replyingToMessage=' + toString_0(this.p7p_1) + ', referencesChangeRequest=' + toString_0(this.q7p_1) + ', referencesPayApp=' + toString_0(this.r7p_1) + ')';
      }
      hashCode() {
        var result = this.g7p_1.hashCode();
        result = imul(result, 31) + this.h7p_1.hashCode() | 0;
        result = imul(result, 31) + this.i7p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.j7p_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.k7p_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.k7p_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.l7p_1) | 0;
        result = imul(result, 31) + this.m7p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.n7p_1) | 0;
        result = imul(result, 31) + hashCode(this.o7p_1) | 0;
        result = imul(result, 31) + (this.p7p_1 == null ? 0 : this.p7p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q7p_1 == null ? 0 : this.q7p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.r7p_1 == null ? 0 : this.r7p_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectMessage()))
          return false;
        if (!this.g7p_1.equals(other.g7p_1))
          return false;
        if (!this.h7p_1.equals(other.h7p_1))
          return false;
        if (!this.i7p_1.equals(other.i7p_1))
          return false;
        if (!(this.j7p_1 === other.j7p_1))
          return false;
        var tmp = this.k7p_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.k7p_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!(this.l7p_1 === other.l7p_1))
          return false;
        if (!this.m7p_1.equals(other.m7p_1))
          return false;
        if (!(this.n7p_1 === other.n7p_1))
          return false;
        if (!equals(this.o7p_1, other.o7p_1))
          return false;
        if (!equals(this.p7p_1, other.p7p_1))
          return false;
        if (!equals(this.q7p_1, other.q7p_1))
          return false;
        if (!equals(this.r7p_1, other.r7p_1))
          return false;
        return true;
      }
      static n98(seen0, _id, project, sender, senderName, senderIcon, clientMessage, sent, message, readBy, replyingToMessage, referencesChangeRequest, referencesPayApp, serializationConstructorMarker) {
        Companion_getInstance_46();
        if (!(166 === (166 & seen0))) {
          throwMissingFieldException(seen0, 166, $serializer_getInstance_46().l98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.g7p_1 = Companion_getInstance().k2p();
        else
          $this.g7p_1 = _id;
        $this.h7p_1 = project;
        $this.i7p_1 = sender;
        if (0 === (seen0 & 8))
          $this.j7p_1 = '';
        else
          $this.j7p_1 = senderName;
        if (0 === (seen0 & 16))
          $this.k7p_1 = null;
        else
          $this.k7p_1 = senderIcon;
        $this.l7p_1 = clientMessage;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.m7p_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.m7p_1 = sent;
        $this.n7p_1 = message;
        if (0 === (seen0 & 256))
          $this.o7p_1 = emptySet();
        else
          $this.o7p_1 = readBy;
        if (0 === (seen0 & 512))
          $this.p7p_1 = null;
        else
          $this.p7p_1 = replyingToMessage;
        if (0 === (seen0 & 1024))
          $this.q7p_1 = null;
        else
          $this.q7p_1 = referencesChangeRequest;
        if (0 === (seen0 & 2048))
          $this.r7p_1 = null;
        else
          $this.r7p_1 = referencesPayApp;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectMessage', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_46});
    ProjectMessageClass = $;
  }
  return ProjectMessageClass;
}
function ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_1() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_33;
function Companion_33() {
  if (CompanionClass_33 === VOID) {
    class $ {
      constructor() {
        Companion_instance_35 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a7s_1 = [tmp_1, tmp_3, null, null, null, lazy(tmp_4, ProjectSettlementDocumentation$Companion$$childSerializers$_anonymous__1375gy_1)];
      }
      k2a() {
        return $serializer_getInstance_47();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_33 = $;
  }
  return CompanionClass_33;
}
var Companion_instance_35;
function Companion_getInstance_47() {
  if (Companion_instance_35 === VOID)
    new (Companion_33())();
  return Companion_instance_35;
}
var $serializerClass_31;
function $serializer_31() {
  if ($serializerClass_31 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_31 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectSettlementDocumentation', this, 6);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('submitted', false);
        tmp0_serialDesc.a1b('submittedByClient', false);
        tmp0_serialDesc.a1b('summary', false);
        tmp0_serialDesc.a1b('documents', false);
        this.p98_1 = tmp0_serialDesc;
      }
      q98(encoder, value) {
        var tmp0_desc = this.p98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_47().a7s_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.f7s_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.f7s_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.g7s_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.h7s_1);
        tmp1_output.s14(tmp0_desc, 3, value.i7s_1);
        tmp1_output.a15(tmp0_desc, 4, value.j7s_1);
        tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.k7s_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q98(encoder, value instanceof ProjectSettlementDocumentation() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance_47().a7s_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, tmp11_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, tmp11_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return ProjectSettlementDocumentation().r98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.p98_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_47().a7s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_4(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[5].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_31 = $;
  }
  return $serializerClass_31;
}
var $serializer_instance_31;
function $serializer_getInstance_47() {
  if ($serializer_instance_31 === VOID)
    new ($serializer_31())();
  return $serializer_instance_31;
}
var ProjectSettlementDocumentationClass;
function ProjectSettlementDocumentation() {
  if (ProjectSettlementDocumentationClass === VOID) {
    class $ {
      constructor(_id, project, submitted, submittedByClient, summary, documents) {
        Companion_getInstance_47();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        this.f7s_1 = _id;
        this.g7s_1 = project;
        this.h7s_1 = submitted;
        this.i7s_1 = submittedByClient;
        this.j7s_1 = summary;
        this.k7s_1 = documents;
      }
      f40() {
        return this.f7s_1;
      }
      s98(_id, project, submitted, submittedByClient, summary, documents) {
        return new (ProjectSettlementDocumentation())(_id, project, submitted, submittedByClient, summary, documents);
      }
      m7s(_id, project, submitted, submittedByClient, summary, documents, $super) {
        _id = _id === VOID ? this.f7s_1 : _id;
        project = project === VOID ? this.g7s_1 : project;
        submitted = submitted === VOID ? this.h7s_1 : submitted;
        submittedByClient = submittedByClient === VOID ? this.i7s_1 : submittedByClient;
        summary = summary === VOID ? this.j7s_1 : summary;
        documents = documents === VOID ? this.k7s_1 : documents;
        return $super === VOID ? this.s98(_id, project, submitted, submittedByClient, summary, documents) : $super.s98.call(this, _id, project, submitted, submittedByClient, summary, documents);
      }
      toString() {
        return 'ProjectSettlementDocumentation(_id=' + this.f7s_1.toString() + ', project=' + this.g7s_1.toString() + ', submitted=' + this.h7s_1.toString() + ', submittedByClient=' + this.i7s_1 + ', summary=' + this.j7s_1 + ', documents=' + toString(this.k7s_1) + ')';
      }
      hashCode() {
        var result = this.f7s_1.hashCode();
        result = imul(result, 31) + this.g7s_1.hashCode() | 0;
        result = imul(result, 31) + this.h7s_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.i7s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j7s_1) | 0;
        result = imul(result, 31) + hashCode(this.k7s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectSettlementDocumentation()))
          return false;
        if (!this.f7s_1.equals(other.f7s_1))
          return false;
        if (!this.g7s_1.equals(other.g7s_1))
          return false;
        if (!this.h7s_1.equals(other.h7s_1))
          return false;
        if (!(this.i7s_1 === other.i7s_1))
          return false;
        if (!(this.j7s_1 === other.j7s_1))
          return false;
        if (!equals(this.k7s_1, other.k7s_1))
          return false;
        return true;
      }
      static r98(seen0, _id, project, submitted, submittedByClient, summary, documents, serializationConstructorMarker) {
        Companion_getInstance_47();
        if (!(62 === (62 & seen0))) {
          throwMissingFieldException(seen0, 62, $serializer_getInstance_47().p98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.f7s_1 = Companion_getInstance().k2p();
        else
          $this.f7s_1 = _id;
        $this.g7s_1 = project;
        $this.h7s_1 = submitted;
        $this.i7s_1 = submittedByClient;
        $this.j7s_1 = summary;
        $this.k7s_1 = documents;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectSettlementDocumentation', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_47});
    ProjectSettlementDocumentationClass = $;
  }
  return ProjectSettlementDocumentationClass;
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_4() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_5() {
  return Companion_getInstance_0().k2a();
}
function ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_6() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_34;
function Companion_34() {
  if (CompanionClass_34 === VOID) {
    class $ {
      constructor() {
        Companion_instance_36 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_13 = lazy(tmp_12, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_5);
        var tmp_14 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i7t_1 = [tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, null, tmp_11, null, tmp_13, null, null, lazy(tmp_14, ProjectTimer$Companion$$childSerializers$_anonymous__gkvzwe_6)];
      }
      k2a() {
        return $serializer_getInstance_48();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_34 = $;
  }
  return CompanionClass_34;
}
var Companion_instance_36;
function Companion_getInstance_48() {
  if (Companion_instance_36 === VOID)
    new (Companion_34())();
  return Companion_instance_36;
}
var $serializerClass_32;
function $serializer_32() {
  if ($serializerClass_32 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_32 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectTimer', this, 12);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lineItem', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('incident', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.a1b('payApp', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.a1b('durationLeft', true);
        tmp0_serialDesc.a1b('executesAt', false);
        tmp0_serialDesc.a1b('pausedFromDispute', true);
        tmp0_serialDesc.a1b('action', false);
        tmp0_serialDesc.a1b('businessDaysOnly', true);
        tmp0_serialDesc.a1b('minimumTimeWhenResumed', true);
        tmp0_serialDesc.a1b('executed', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.c1b(new (AdminTableColumns())(['project', 'lineItem', 'executesAt', 'action']));
        this.t98_1 = tmp0_serialDesc;
      }
      u98(encoder, value) {
        var tmp0_desc = this.t98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_48().i7t_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.p7t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.q7t_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.r7t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r7t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.s7t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.s7t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.t7t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.t7t_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.u7t_1;
          tmp = !((tmp_0 == null ? null : new (Duration())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = DurationSerializer_getInstance();
          var tmp_2 = value.u7t_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (Duration())(tmp_2));
        }
        tmp1_output.d15(tmp0_desc, 6, tmp2_cached[6].f2(), value.v7t_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.w7t_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.w7t_1);
        }
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.x7t_1);
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.y7t_1 === false)) {
          tmp1_output.s14(tmp0_desc, 9, value.y7t_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 10)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.z7t_1;
          tmp_3 = !((tmp_4 == null ? null : new (Duration())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = DurationSerializer_getInstance();
          var tmp_6 = value.z7t_1;
          tmp1_output.d15(tmp0_desc, 10, tmp_5, tmp_6 == null ? null : new (Duration())(tmp_6));
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.a7u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, tmp2_cached[11].f2(), value.a7u_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u98(encoder, value instanceof ProjectTimer() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_local9 = false;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_48().i7t_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.z13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp16_input.z13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = DurationSerializer_getInstance();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp16_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.n13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          var tmp_2 = DurationSerializer_getInstance();
          var tmp_3 = tmp14_local10;
          var tmp_4 = tmp16_input.z13(tmp0_desc, 10, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
          tmp14_local10 = tmp_4 == null ? null : tmp_4.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, tmp17_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.x13(tmp0_desc, 1, tmp17_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.z13(tmp0_desc, 2, tmp17_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp16_input.z13(tmp0_desc, 3, tmp17_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp16_input.z13(tmp0_desc, 4, tmp17_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_5 = DurationSerializer_getInstance();
                var tmp_6 = tmp9_local5;
                var tmp_7 = tmp16_input.z13(tmp0_desc, 5, tmp_5, tmp_6 == null ? null : new (Duration())(tmp_6));
                tmp9_local5 = tmp_7 == null ? null : tmp_7.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.z13(tmp0_desc, 6, tmp17_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.x13(tmp0_desc, 8, tmp17_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.n13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                var tmp_8 = DurationSerializer_getInstance();
                var tmp_9 = tmp14_local10;
                var tmp_10 = tmp16_input.z13(tmp0_desc, 10, tmp_8, tmp_9 == null ? null : new (Duration())(tmp_9));
                tmp14_local10 = tmp_10 == null ? null : tmp_10.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp16_input.z13(tmp0_desc, 11, tmp17_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return ProjectTimer().v98(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
      }
      az() {
        return this.t98_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_48().i7t_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), get_nullable(tmp0_cached[4].f2()), get_nullable(DurationSerializer_getInstance()), get_nullable(tmp0_cached[6].f2()), BooleanSerializer_getInstance(), tmp0_cached[8].f2(), BooleanSerializer_getInstance(), get_nullable(DurationSerializer_getInstance()), get_nullable(tmp0_cached[11].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_32 = $;
  }
  return $serializerClass_32;
}
var $serializer_instance_32;
function $serializer_getInstance_48() {
  if ($serializer_instance_32 === VOID)
    new ($serializer_32())();
  return $serializer_instance_32;
}
var ProjectTimerClass;
function ProjectTimer() {
  if (ProjectTimerClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed) {
        Companion_getInstance_48();
        lineItem = lineItem === VOID ? null : lineItem;
        incident = incident === VOID ? null : incident;
        payApp = payApp === VOID ? null : payApp;
        durationLeft = durationLeft === VOID ? null : durationLeft;
        pausedFromDispute = pausedFromDispute === VOID ? false : pausedFromDispute;
        businessDaysOnly = businessDaysOnly === VOID ? false : businessDaysOnly;
        minimumTimeWhenResumed = minimumTimeWhenResumed === VOID ? null : minimumTimeWhenResumed;
        executed = executed === VOID ? null : executed;
        this.p7t_1 = _id;
        this.q7t_1 = project;
        this.r7t_1 = lineItem;
        this.s7t_1 = incident;
        this.t7t_1 = payApp;
        this.u7t_1 = durationLeft;
        this.v7t_1 = executesAt;
        this.w7t_1 = pausedFromDispute;
        this.x7t_1 = action;
        this.y7t_1 = businessDaysOnly;
        this.z7t_1 = minimumTimeWhenResumed;
        this.a7u_1 = executed;
      }
      f40() {
        return this.p7t_1;
      }
      w98() {
        return this.v7t_1 == null;
      }
      x98(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed) {
        return new (ProjectTimer())(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed);
      }
      c7u(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed, $super) {
        _id = _id === VOID ? this.p7t_1 : _id;
        project = project === VOID ? this.q7t_1 : project;
        lineItem = lineItem === VOID ? this.r7t_1 : lineItem;
        incident = incident === VOID ? this.s7t_1 : incident;
        payApp = payApp === VOID ? this.t7t_1 : payApp;
        durationLeft = durationLeft === VOID ? this.u7t_1 : durationLeft;
        executesAt = executesAt === VOID ? this.v7t_1 : executesAt;
        pausedFromDispute = pausedFromDispute === VOID ? this.w7t_1 : pausedFromDispute;
        action = action === VOID ? this.x7t_1 : action;
        businessDaysOnly = businessDaysOnly === VOID ? this.y7t_1 : businessDaysOnly;
        minimumTimeWhenResumed = minimumTimeWhenResumed === VOID ? this.z7t_1 : minimumTimeWhenResumed;
        executed = executed === VOID ? this.a7u_1 : executed;
        var tmp;
        if ($super === VOID) {
          tmp = this.x98(_id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed);
        } else {
          var tmp_0 = $super.x98;
          var tmp_1 = durationLeft;
          var tmp_2 = tmp_1 == null ? null : new (Duration())(tmp_1);
          var tmp_3 = minimumTimeWhenResumed;
          tmp = tmp_0.call(this, _id, project, lineItem, incident, payApp, tmp_2, executesAt, pausedFromDispute, action, businessDaysOnly, tmp_3 == null ? null : new (Duration())(tmp_3), executed);
        }
        return tmp;
      }
      toString() {
        var tmp = this.p7t_1.toString();
        var tmp_0 = this.q7t_1.toString();
        var tmp_1 = toString_0(this.r7t_1);
        var tmp_2 = toString_0(this.s7t_1);
        var tmp_3 = toString_0(this.t7t_1);
        var tmp_4 = this.u7t_1;
        var tmp_5 = toString_0(tmp_4 == null ? null : new (Duration())(tmp_4));
        var tmp_6 = toString_0(this.v7t_1);
        var tmp_7 = this.x7t_1.toString();
        var tmp_8 = this.z7t_1;
        return 'ProjectTimer(_id=' + tmp + ', project=' + tmp_0 + ', lineItem=' + tmp_1 + ', incident=' + tmp_2 + ', payApp=' + tmp_3 + ', durationLeft=' + tmp_5 + ', executesAt=' + tmp_6 + ', pausedFromDispute=' + this.w7t_1 + ', action=' + tmp_7 + ', businessDaysOnly=' + this.y7t_1 + ', minimumTimeWhenResumed=' + toString_0(tmp_8 == null ? null : new (Duration())(tmp_8)) + ', executed=' + toString_0(this.a7u_1) + ')';
      }
      hashCode() {
        var result = this.p7t_1.hashCode();
        result = imul(result, 31) + this.q7t_1.hashCode() | 0;
        result = imul(result, 31) + (this.r7t_1 == null ? 0 : this.r7t_1.hashCode()) | 0;
        result = imul(result, 31) + (this.s7t_1 == null ? 0 : this.s7t_1.hashCode()) | 0;
        result = imul(result, 31) + (this.t7t_1 == null ? 0 : this.t7t_1.hashCode()) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.u7t_1;
        if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Duration__hashCode_impl_u4exz6(this.u7t_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.v7t_1 == null ? 0 : this.v7t_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.w7t_1) | 0;
        result = imul(result, 31) + this.x7t_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.y7t_1) | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.z7t_1;
        if ((tmp_4 == null ? null : new (Duration())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = Duration__hashCode_impl_u4exz6(this.z7t_1);
        }
        result = tmp_2 + tmp_3 | 0;
        result = imul(result, 31) + (this.a7u_1 == null ? 0 : this.a7u_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectTimer()))
          return false;
        if (!this.p7t_1.equals(other.p7t_1))
          return false;
        if (!this.q7t_1.equals(other.q7t_1))
          return false;
        if (!equals(this.r7t_1, other.r7t_1))
          return false;
        if (!equals(this.s7t_1, other.s7t_1))
          return false;
        if (!equals(this.t7t_1, other.t7t_1))
          return false;
        var tmp = this.u7t_1;
        var tmp_0 = tmp == null ? null : new (Duration())(tmp);
        var tmp_1 = other.u7t_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Duration())(tmp_1)))
          return false;
        if (!equals(this.v7t_1, other.v7t_1))
          return false;
        if (!(this.w7t_1 === other.w7t_1))
          return false;
        if (!this.x7t_1.equals(other.x7t_1))
          return false;
        if (!(this.y7t_1 === other.y7t_1))
          return false;
        var tmp_2 = this.z7t_1;
        var tmp_3 = tmp_2 == null ? null : new (Duration())(tmp_2);
        var tmp_4 = other.z7t_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (Duration())(tmp_4)))
          return false;
        if (!equals(this.a7u_1, other.a7u_1))
          return false;
        return true;
      }
      static v98(seen0, _id, project, lineItem, incident, payApp, durationLeft, executesAt, pausedFromDispute, action, businessDaysOnly, minimumTimeWhenResumed, executed, serializationConstructorMarker) {
        Companion_getInstance_48();
        if (!(323 === (323 & seen0))) {
          throwMissingFieldException(seen0, 323, $serializer_getInstance_48().t98_1);
        }
        var $this = createThis(this);
        $this.p7t_1 = _id;
        $this.q7t_1 = project;
        if (0 === (seen0 & 4))
          $this.r7t_1 = null;
        else
          $this.r7t_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.s7t_1 = null;
        else
          $this.s7t_1 = incident;
        if (0 === (seen0 & 16))
          $this.t7t_1 = null;
        else
          $this.t7t_1 = payApp;
        if (0 === (seen0 & 32))
          $this.u7t_1 = null;
        else
          $this.u7t_1 = durationLeft;
        $this.v7t_1 = executesAt;
        if (0 === (seen0 & 128))
          $this.w7t_1 = false;
        else
          $this.w7t_1 = pausedFromDispute;
        $this.x7t_1 = action;
        if (0 === (seen0 & 512))
          $this.y7t_1 = false;
        else
          $this.y7t_1 = businessDaysOnly;
        if (0 === (seen0 & 1024))
          $this.z7t_1 = null;
        else
          $this.z7t_1 = minimumTimeWhenResumed;
        if (0 === (seen0 & 2048))
          $this.a7u_1 = null;
        else
          $this.a7u_1 = executed;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectTimer', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_48});
    ProjectTimerClass = $;
  }
  return ProjectTimerClass;
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_35;
function Companion_35() {
  if (CompanionClass_35 === VOID) {
    class $ {
      constructor() {
        Companion_instance_37 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e7w_1 = [tmp_1, tmp_3, tmp_5, tmp_7, null, null, null, null, lazy(tmp_8, PunchListItem$Companion$$childSerializers$_anonymous__18yzsl_3), null];
      }
      k2a() {
        return $serializer_getInstance_49();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_35 = $;
  }
  return CompanionClass_35;
}
var Companion_instance_37;
function Companion_getInstance_49() {
  if (Companion_instance_37 === VOID)
    new (Companion_35())();
  return Companion_instance_37;
}
var $serializerClass_33;
function $serializer_33() {
  if ($serializerClass_33 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_33 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PunchListItem', this, 10);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lineItem', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.a1b('scope', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.a1b('order', true);
        tmp0_serialDesc.a1b('content', false);
        tmp0_serialDesc.a1b('required', false);
        tmp0_serialDesc.a1b('complete', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.a1b('isMinorAdjustment', true);
        this.y98_1 = tmp0_serialDesc;
      }
      z98(encoder, value) {
        var tmp0_desc = this.y98_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_49().e7w_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.j7w_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.j7w_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.k7w_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.l7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.l7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.m7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.m7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.n7w_1, 0.5)) {
          tmp1_output.y14(tmp0_desc, 4, value.n7w_1);
        }
        tmp1_output.a15(tmp0_desc, 5, value.o7w_1);
        tmp1_output.s14(tmp0_desc, 6, value.p7w_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.q7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.q7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.r7w_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.r7w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.s7w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.s7w_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z98(encoder, value instanceof PunchListItem() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y98_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0.0;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_49().e7w_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.t13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.x13(tmp0_desc, 0, tmp15_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.x13(tmp0_desc, 1, tmp15_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.z13(tmp0_desc, 2, tmp15_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.z13(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.t13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.n13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.x13(tmp0_desc, 8, tmp15_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return PunchListItem().a99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.y98_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_49().e7w_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), DoubleSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4()), tmp0_cached[8].f2(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_33 = $;
  }
  return $serializerClass_33;
}
var $serializer_instance_33;
function $serializer_getInstance_49() {
  if ($serializer_instance_33 === VOID)
    new ($serializer_33())();
  return $serializer_instance_33;
}
var PunchListItemClass;
function PunchListItem() {
  if (PunchListItemClass === VOID) {
    class $ {
      constructor(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment) {
        Companion_getInstance_49();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        lineItem = lineItem === VOID ? null : lineItem;
        scope = scope === VOID ? null : scope;
        order = order === VOID ? 0.5 : order;
        complete = complete === VOID ? null : complete;
        readBy = readBy === VOID ? emptySet() : readBy;
        isMinorAdjustment = isMinorAdjustment === VOID ? null : isMinorAdjustment;
        this.j7w_1 = _id;
        this.k7w_1 = project;
        this.l7w_1 = lineItem;
        this.m7w_1 = scope;
        this.n7w_1 = order;
        this.o7w_1 = content;
        this.p7w_1 = required;
        this.q7w_1 = complete;
        this.r7w_1 = readBy;
        this.s7w_1 = isMinorAdjustment;
      }
      f40() {
        return this.j7w_1;
      }
      i8v() {
        return this.n7w_1;
      }
      v91() {
        return this.r7w_1;
      }
      j8v(order) {
        return this.u7w(VOID, VOID, VOID, VOID, order);
      }
      b99(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment) {
        return new (PunchListItem())(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment);
      }
      u7w(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment, $super) {
        _id = _id === VOID ? this.j7w_1 : _id;
        project = project === VOID ? this.k7w_1 : project;
        lineItem = lineItem === VOID ? this.l7w_1 : lineItem;
        scope = scope === VOID ? this.m7w_1 : scope;
        order = order === VOID ? this.n7w_1 : order;
        content = content === VOID ? this.o7w_1 : content;
        required = required === VOID ? this.p7w_1 : required;
        complete = complete === VOID ? this.q7w_1 : complete;
        readBy = readBy === VOID ? this.r7w_1 : readBy;
        isMinorAdjustment = isMinorAdjustment === VOID ? this.s7w_1 : isMinorAdjustment;
        return $super === VOID ? this.b99(_id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment) : $super.b99.call(this, _id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment);
      }
      toString() {
        return 'PunchListItem(_id=' + this.j7w_1.toString() + ', project=' + this.k7w_1.toString() + ', lineItem=' + toString_0(this.l7w_1) + ', scope=' + toString_0(this.m7w_1) + ', order=' + this.n7w_1 + ', content=' + this.o7w_1 + ', required=' + this.p7w_1 + ', complete=' + toString_0(this.q7w_1) + ', readBy=' + toString(this.r7w_1) + ', isMinorAdjustment=' + this.s7w_1 + ')';
      }
      hashCode() {
        var result = this.j7w_1.hashCode();
        result = imul(result, 31) + this.k7w_1.hashCode() | 0;
        result = imul(result, 31) + (this.l7w_1 == null ? 0 : this.l7w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.m7w_1 == null ? 0 : this.m7w_1.hashCode()) | 0;
        result = imul(result, 31) + getNumberHashCode(this.n7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o7w_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p7w_1) | 0;
        result = imul(result, 31) + (this.q7w_1 == null ? 0 : this.q7w_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.r7w_1) | 0;
        result = imul(result, 31) + (this.s7w_1 == null ? 0 : getStringHashCode(this.s7w_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PunchListItem()))
          return false;
        if (!this.j7w_1.equals(other.j7w_1))
          return false;
        if (!this.k7w_1.equals(other.k7w_1))
          return false;
        if (!equals(this.l7w_1, other.l7w_1))
          return false;
        if (!equals(this.m7w_1, other.m7w_1))
          return false;
        if (!equals(this.n7w_1, other.n7w_1))
          return false;
        if (!(this.o7w_1 === other.o7w_1))
          return false;
        if (!(this.p7w_1 === other.p7w_1))
          return false;
        if (!equals(this.q7w_1, other.q7w_1))
          return false;
        if (!equals(this.r7w_1, other.r7w_1))
          return false;
        if (!(this.s7w_1 == other.s7w_1))
          return false;
        return true;
      }
      static a99(seen0, _id, project, lineItem, scope, order, content, required, complete, readBy, isMinorAdjustment, serializationConstructorMarker) {
        Companion_getInstance_49();
        if (!(98 === (98 & seen0))) {
          throwMissingFieldException(seen0, 98, $serializer_getInstance_49().y98_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.j7w_1 = Companion_getInstance().k2p();
        else
          $this.j7w_1 = _id;
        $this.k7w_1 = project;
        if (0 === (seen0 & 4))
          $this.l7w_1 = null;
        else
          $this.l7w_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.m7w_1 = null;
        else
          $this.m7w_1 = scope;
        if (0 === (seen0 & 16))
          $this.n7w_1 = 0.5;
        else
          $this.n7w_1 = order;
        $this.o7w_1 = content;
        $this.p7w_1 = required;
        if (0 === (seen0 & 128))
          $this.q7w_1 = null;
        else
          $this.q7w_1 = complete;
        if (0 === (seen0 & 256))
          $this.r7w_1 = emptySet();
        else
          $this.r7w_1 = readBy;
        if (0 === (seen0 & 512))
          $this.s7w_1 = null;
        else
          $this.s7w_1 = isMinorAdjustment;
        return $this;
      }
      d(other) {
        return this.k8v(other instanceof PunchListItem() ? other : THROW_CCE());
      }
    }
    protoOf($).k8v = compareTo;
    initMetadataForClass($, 'PunchListItem', VOID, VOID, [HasId(), ReadByDataModel(), Reorderable()], VOID, VOID, {0: $serializer_getInstance_49});
    PunchListItemClass = $;
  }
  return PunchListItemClass;
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_36;
function Companion_36() {
  if (CompanionClass_36 === VOID) {
    class $ {
      constructor() {
        Companion_instance_38 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d7z_1 = [tmp_1, tmp_3, null, null, null, null, tmp_5, null, lazy(tmp_6, ScopeView$Companion$$childSerializers$_anonymous__i9bl8x_2)];
      }
      k2a() {
        return $serializer_getInstance_50();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_36 = $;
  }
  return CompanionClass_36;
}
var Companion_instance_38;
function Companion_getInstance_50() {
  if (Companion_instance_38 === VOID)
    new (Companion_36())();
  return Companion_instance_38;
}
var $serializerClass_34;
function $serializer_34() {
  if ($serializerClass_34 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_34 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ScopeView', this, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('scopeTitle', false);
        tmp0_serialDesc.a1b('description', true);
        tmp0_serialDesc.a1b('order', true);
        tmp0_serialDesc.a1b('scopeSet', true);
        tmp0_serialDesc.a1b('parentView', true);
        tmp0_serialDesc.b1b(new (References())(getKClass(ScopeView())));
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('fromChangeRequest', true);
        tmp0_serialDesc.a1b('readBy', true);
        tmp0_serialDesc.c1b(new (IndexSet())(['project', 'fromChangeRequest']));
        this.c99_1 = tmp0_serialDesc;
      }
      d99(encoder, value) {
        var tmp0_desc = this.c99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_50().d7z_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.i7z_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j7z_1);
        tmp1_output.a15(tmp0_desc, 2, value.k7z_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.l7z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.l7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !equals(value.m7z_1, 0.5)) {
          tmp1_output.y14(tmp0_desc, 4, value.m7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.n7z_1 === false)) {
          tmp1_output.s14(tmp0_desc, 5, value.n7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.o7z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, tmp2_cached[6].f2(), value.o7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.p7z_1 === false)) {
          tmp1_output.s14(tmp0_desc, 7, value.p7z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.q7z_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.q7z_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d99(encoder, value instanceof ScopeView() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0.0;
        var tmp9_local5 = false;
        var tmp10_local6 = null;
        var tmp11_local7 = false;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_50().d7z_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.t13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.n13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, tmp14_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.n13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.t13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.n13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, tmp14_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.n13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return ScopeView().e99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.c99_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_50().d7z_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[6].f2()), BooleanSerializer_getInstance(), tmp0_cached[8].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_34 = $;
  }
  return $serializerClass_34;
}
var $serializer_instance_34;
function $serializer_getInstance_50() {
  if ($serializer_instance_34 === VOID)
    new ($serializer_34())();
  return $serializer_instance_34;
}
var ScopeViewClass;
function ScopeView() {
  if (ScopeViewClass === VOID) {
    class $ {
      constructor(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy) {
        Companion_getInstance_50();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        description = description === VOID ? null : description;
        order = order === VOID ? 0.5 : order;
        scopeSet = scopeSet === VOID ? false : scopeSet;
        parentView = parentView === VOID ? null : parentView;
        fromChangeRequest = fromChangeRequest === VOID ? false : fromChangeRequest;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.i7z_1 = _id;
        this.j7z_1 = project;
        this.k7z_1 = scopeTitle;
        this.l7z_1 = description;
        this.m7z_1 = order;
        this.n7z_1 = scopeSet;
        this.o7z_1 = parentView;
        this.p7z_1 = fromChangeRequest;
        this.q7z_1 = readBy;
      }
      f40() {
        return this.i7z_1;
      }
      f99() {
        return this.k7z_1;
      }
      s91() {
        return this.l7z_1;
      }
      i8v() {
        return this.m7z_1;
      }
      g99() {
        return this.n7z_1;
      }
      h99() {
        return this.o7z_1;
      }
      v91() {
        return this.q7z_1;
      }
      j8v(order) {
        return this.s7z(VOID, VOID, VOID, VOID, order);
      }
      i99(scopeTitle, description, scopeSet, parentView) {
        return this.s7z(this.i7z_1, VOID, scopeTitle, description, VOID, scopeSet, parentView);
      }
      j99(parentView) {
        return new (SpecView())(VOID, this.k7z_1, this.l7z_1, this.n7z_1, parentView);
      }
      k99(parentView, $super) {
        parentView = parentView === VOID ? null : parentView;
        return $super === VOID ? this.j99(parentView) : $super.j99.call(this, parentView);
      }
      l99(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy) {
        return new (ScopeView())(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy);
      }
      s7z(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy, $super) {
        _id = _id === VOID ? this.i7z_1 : _id;
        project = project === VOID ? this.j7z_1 : project;
        scopeTitle = scopeTitle === VOID ? this.k7z_1 : scopeTitle;
        description = description === VOID ? this.l7z_1 : description;
        order = order === VOID ? this.m7z_1 : order;
        scopeSet = scopeSet === VOID ? this.n7z_1 : scopeSet;
        parentView = parentView === VOID ? this.o7z_1 : parentView;
        fromChangeRequest = fromChangeRequest === VOID ? this.p7z_1 : fromChangeRequest;
        readBy = readBy === VOID ? this.q7z_1 : readBy;
        return $super === VOID ? this.l99(_id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy) : $super.l99.call(this, _id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy);
      }
      toString() {
        return 'ScopeView(_id=' + this.i7z_1.toString() + ', project=' + this.j7z_1.toString() + ', scopeTitle=' + this.k7z_1 + ', description=' + this.l7z_1 + ', order=' + this.m7z_1 + ', scopeSet=' + this.n7z_1 + ', parentView=' + toString_0(this.o7z_1) + ', fromChangeRequest=' + this.p7z_1 + ', readBy=' + toString(this.q7z_1) + ')';
      }
      hashCode() {
        var result = this.i7z_1.hashCode();
        result = imul(result, 31) + this.j7z_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.k7z_1) | 0;
        result = imul(result, 31) + (this.l7z_1 == null ? 0 : getStringHashCode(this.l7z_1)) | 0;
        result = imul(result, 31) + getNumberHashCode(this.m7z_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n7z_1) | 0;
        result = imul(result, 31) + (this.o7z_1 == null ? 0 : this.o7z_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p7z_1) | 0;
        result = imul(result, 31) + hashCode(this.q7z_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScopeView()))
          return false;
        if (!this.i7z_1.equals(other.i7z_1))
          return false;
        if (!this.j7z_1.equals(other.j7z_1))
          return false;
        if (!(this.k7z_1 === other.k7z_1))
          return false;
        if (!(this.l7z_1 == other.l7z_1))
          return false;
        if (!equals(this.m7z_1, other.m7z_1))
          return false;
        if (!(this.n7z_1 === other.n7z_1))
          return false;
        if (!equals(this.o7z_1, other.o7z_1))
          return false;
        if (!(this.p7z_1 === other.p7z_1))
          return false;
        if (!equals(this.q7z_1, other.q7z_1))
          return false;
        return true;
      }
      static e99(seen0, _id, project, scopeTitle, description, order, scopeSet, parentView, fromChangeRequest, readBy, serializationConstructorMarker) {
        Companion_getInstance_50();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_50().c99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i7z_1 = Companion_getInstance().k2p();
        else
          $this.i7z_1 = _id;
        $this.j7z_1 = project;
        $this.k7z_1 = scopeTitle;
        if (0 === (seen0 & 8))
          $this.l7z_1 = null;
        else
          $this.l7z_1 = description;
        if (0 === (seen0 & 16))
          $this.m7z_1 = 0.5;
        else
          $this.m7z_1 = order;
        if (0 === (seen0 & 32))
          $this.n7z_1 = false;
        else
          $this.n7z_1 = scopeSet;
        if (0 === (seen0 & 64))
          $this.o7z_1 = null;
        else
          $this.o7z_1 = parentView;
        if (0 === (seen0 & 128))
          $this.p7z_1 = false;
        else
          $this.p7z_1 = fromChangeRequest;
        if (0 === (seen0 & 256))
          $this.q7z_1 = emptySet();
        else
          $this.q7z_1 = readBy;
        return $this;
      }
      d(other) {
        return this.k8v(other instanceof ScopeView() ? other : THROW_CCE());
      }
    }
    protoOf($).c80 = copy$default;
    protoOf($).k8v = compareTo;
    initMetadataForClass($, 'ScopeView', VOID, VOID, [HasId(), ScopeGroup(), ReadByDataModel(), Reorderable()], VOID, VOID, {0: $serializer_getInstance_50});
    ScopeViewClass = $;
  }
  return ScopeViewClass;
}
function Specification$Companion$$childSerializers$_anonymous__4x7813() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Specification$Companion$$childSerializers$_anonymous__4x7813_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Specification$Companion$$childSerializers$_anonymous__4x7813_1() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function Specification$Companion$$childSerializers$_anonymous__4x7813_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_37;
function Companion_37() {
  if (CompanionClass_37 === VOID) {
    class $ {
      constructor() {
        Companion_instance_39 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Specification$Companion$$childSerializers$_anonymous__4x7813);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Specification$Companion$$childSerializers$_anonymous__4x7813_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Specification$Companion$$childSerializers$_anonymous__4x7813_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n83_1 = [tmp_1, tmp_3, null, null, null, null, null, tmp_5, lazy(tmp_6, Specification$Companion$$childSerializers$_anonymous__4x7813_2)];
      }
      k2a() {
        return $serializer_getInstance_51();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_37 = $;
  }
  return CompanionClass_37;
}
var Companion_instance_39;
function Companion_getInstance_51() {
  if (Companion_instance_39 === VOID)
    new (Companion_37())();
  return Companion_instance_39;
}
var $serializerClass_35;
function $serializer_35() {
  if ($serializerClass_35 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_35 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Specification', this, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('contractor', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.a1b('group', true);
        tmp0_serialDesc.a1b('title', true);
        tmp0_serialDesc.a1b('description', true);
        tmp0_serialDesc.a1b('price', true);
        tmp0_serialDesc.a1b('unit', true);
        tmp0_serialDesc.a1b('files', true);
        tmp0_serialDesc.a1b('readBy', true);
        this.m99_1 = tmp0_serialDesc;
      }
      n99(encoder, value) {
        var tmp0_desc = this.m99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_51().n83_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.s83_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.s83_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.t83_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.u83_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_11(), value.u83_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.v83_1 === '')) {
          tmp1_output.a15(tmp0_desc, 3, value.v83_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.w83_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.w83_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          var tmp_0 = value.x83_1;
          tmp = !((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_2();
          var tmp_2 = value.x83_1;
          tmp1_output.d15(tmp0_desc, 5, tmp_1, tmp_2 == null ? null : new (MonetaryValue())(tmp_2));
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.y83_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, StringSerializer_getInstance(), value.y83_1);
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 7)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp_3 = !equals(value.z83_1, tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 7, tmp2_cached[7].f2(), value.z83_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !equals(value.a84_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.a84_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n99(encoder, value instanceof Specification() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        var tmp14_cached = Companion_getInstance_51().n83_1;
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.z13(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp9_local5;
          var tmp_1 = tmp13_input.z13(tmp0_desc, 5, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp9_local5 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.x13(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, tmp14_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.x13(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.z13(tmp0_desc, 2, $serializer_getInstance_11(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp9_local5;
                var tmp_4 = tmp13_input.z13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp9_local5 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.x13(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.x13(tmp0_desc, 8, tmp14_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return Specification().o99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.m99_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_51().n83_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), get_nullable($serializer_getInstance_11()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), tmp0_cached[7].f2(), tmp0_cached[8].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_35 = $;
  }
  return $serializerClass_35;
}
var $serializer_instance_35;
function $serializer_getInstance_51() {
  if ($serializer_instance_35 === VOID)
    new ($serializer_35())();
  return $serializer_instance_35;
}
var SpecificationClass;
function Specification() {
  if (SpecificationClass === VOID) {
    class $ {
      constructor(_id, contractor, group, title, description, price, unit, files, readBy) {
        Companion_getInstance_51();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        group = group === VOID ? null : group;
        title = title === VOID ? '' : title;
        description = description === VOID ? '' : description;
        price = price === VOID ? null : price;
        unit = unit === VOID ? null : unit;
        var tmp;
        if (files === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = files;
        }
        files = tmp;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.s83_1 = _id;
        this.t83_1 = contractor;
        this.u83_1 = group;
        this.v83_1 = title;
        this.w83_1 = description;
        this.x83_1 = price;
        this.y83_1 = unit;
        this.z83_1 = files;
        this.a84_1 = readBy;
      }
      f40() {
        return this.s83_1;
      }
      v91() {
        return this.a84_1;
      }
      p99(project, scopeView, scopeSet) {
        var tmp;
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_0 = this.y83_1;
        if (this_0 == null || isBlank(this_0)) {
          tmp = '';
        } else {
          tmp = ' (1 ' + this.y83_1 + ')';
        }
        var tmp3_name = this.v83_1 + tmp;
        var tmp4_description = this.w83_1;
        var tmp0_elvis_lhs = this.x83_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = _MonetaryValue___init__impl__jsc11x(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp5_originalPrice = tmp_0;
        var tmp6_scopeView = scopeView == null ? null : scopeView.i7z_1;
        var tmp7_scopeSet = scopeSet == null ? null : scopeSet.i7z_1;
        var tmp8_files = this.z83_1;
        return new (LineItem())(VOID, project, VOID, tmp6_scopeView, tmp7_scopeSet, tmp3_name, tmp4_description, tmp5_originalPrice, VOID, tmp8_files);
      }
      q99(_id, contractor, group, title, description, price, unit, files, readBy) {
        return new (Specification())(_id, contractor, group, title, description, price, unit, files, readBy);
      }
      c84(_id, contractor, group, title, description, price, unit, files, readBy, $super) {
        _id = _id === VOID ? this.s83_1 : _id;
        contractor = contractor === VOID ? this.t83_1 : contractor;
        group = group === VOID ? this.u83_1 : group;
        title = title === VOID ? this.v83_1 : title;
        description = description === VOID ? this.w83_1 : description;
        price = price === VOID ? this.x83_1 : price;
        unit = unit === VOID ? this.y83_1 : unit;
        files = files === VOID ? this.z83_1 : files;
        readBy = readBy === VOID ? this.a84_1 : readBy;
        var tmp;
        if ($super === VOID) {
          tmp = this.q99(_id, contractor, group, title, description, price, unit, files, readBy);
        } else {
          var tmp_0 = $super.q99;
          var tmp_1 = price;
          tmp = tmp_0.call(this, _id, contractor, group, title, description, tmp_1 == null ? null : new (MonetaryValue())(tmp_1), unit, files, readBy);
        }
        return tmp;
      }
      toString() {
        var tmp = this.s83_1.toString();
        var tmp_0 = this.t83_1.toString();
        var tmp_1 = toString_0(this.u83_1);
        var tmp_2 = this.x83_1;
        return 'Specification(_id=' + tmp + ', contractor=' + tmp_0 + ', group=' + tmp_1 + ', title=' + this.v83_1 + ', description=' + this.w83_1 + ', price=' + toString_0(tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) + ', unit=' + this.y83_1 + ', files=' + toString(this.z83_1) + ', readBy=' + toString(this.a84_1) + ')';
      }
      hashCode() {
        var result = this.s83_1.hashCode();
        result = imul(result, 31) + this.t83_1.hashCode() | 0;
        result = imul(result, 31) + (this.u83_1 == null ? 0 : this.u83_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.v83_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w83_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.x83_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.x83_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.y83_1 == null ? 0 : getStringHashCode(this.y83_1)) | 0;
        result = imul(result, 31) + hashCode(this.z83_1) | 0;
        result = imul(result, 31) + hashCode(this.a84_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Specification()))
          return false;
        if (!this.s83_1.equals(other.s83_1))
          return false;
        if (!this.t83_1.equals(other.t83_1))
          return false;
        if (!equals(this.u83_1, other.u83_1))
          return false;
        if (!(this.v83_1 === other.v83_1))
          return false;
        if (!(this.w83_1 === other.w83_1))
          return false;
        var tmp = this.x83_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.x83_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        if (!(this.y83_1 == other.y83_1))
          return false;
        if (!equals(this.z83_1, other.z83_1))
          return false;
        if (!equals(this.a84_1, other.a84_1))
          return false;
        return true;
      }
      static o99(seen0, _id, contractor, group, title, description, price, unit, files, readBy, serializationConstructorMarker) {
        Companion_getInstance_51();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_51().m99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.s83_1 = Companion_getInstance().k2p();
        else
          $this.s83_1 = _id;
        $this.t83_1 = contractor;
        if (0 === (seen0 & 4))
          $this.u83_1 = null;
        else
          $this.u83_1 = group;
        if (0 === (seen0 & 8))
          $this.v83_1 = '';
        else
          $this.v83_1 = title;
        if (0 === (seen0 & 16))
          $this.w83_1 = '';
        else
          $this.w83_1 = description;
        if (0 === (seen0 & 32))
          $this.x83_1 = null;
        else
          $this.x83_1 = price;
        if (0 === (seen0 & 64))
          $this.y83_1 = null;
        else
          $this.y83_1 = unit;
        if (0 === (seen0 & 128)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.z83_1 = emptyList();
        } else
          $this.z83_1 = files;
        if (0 === (seen0 & 256))
          $this.a84_1 = emptySet();
        else
          $this.a84_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Specification', VOID, VOID, [HasId(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_51});
    SpecificationClass = $;
  }
  return SpecificationClass;
}
var CompanionClass_38;
function Companion_38() {
  if (CompanionClass_38 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_52();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_38 = $;
  }
  return CompanionClass_38;
}
var Companion_instance_40;
function Companion_getInstance_52() {
  return Companion_instance_40;
}
var $serializerClass_36;
function $serializer_36() {
  if ($serializerClass_36 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_36 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Trade', this, 1);
        tmp0_serialDesc.a1b('_id', false);
        this.r99_1 = tmp0_serialDesc;
      }
      s99(encoder, value) {
        var tmp0_desc = this.r99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.c86_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s99(encoder, value instanceof Trade() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return Trade().t99(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.r99_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_36 = $;
  }
  return $serializerClass_36;
}
var $serializer_instance_36;
function $serializer_getInstance_52() {
  if ($serializer_instance_36 === VOID)
    new ($serializer_36())();
  return $serializer_instance_36;
}
var TradeClass;
function Trade() {
  if (TradeClass === VOID) {
    class $ {
      constructor(_id) {
        this.c86_1 = _id;
      }
      f40() {
        return this.c86_1;
      }
      n5z(_id) {
        return new (Trade())(_id);
      }
      toString() {
        return 'Trade(_id=' + this.c86_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.c86_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Trade()))
          return false;
        if (!(this.c86_1 === other.c86_1))
          return false;
        return true;
      }
      static t99(seen0, _id, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_52().r99_1);
        }
        var $this = createThis(this);
        $this.c86_1 = _id;
        return $this;
      }
    }
    initMetadataForClass($, 'Trade', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_52});
    TradeClass = $;
  }
  return TradeClass;
}
function UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_1() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_39;
function Companion_39() {
  if (CompanionClass_39 === VOID) {
    class $ {
      constructor() {
        Companion_instance_41 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e86_1 = [tmp_1, tmp_3, null, null, null, null, lazy(tmp_4, UnlockProjectRequest$Companion$$childSerializers$_anonymous__eqe1dc_1), null];
      }
      k2a() {
        return $serializer_getInstance_53();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_39 = $;
  }
  return CompanionClass_39;
}
var Companion_instance_41;
function Companion_getInstance_53() {
  if (Companion_instance_41 === VOID)
    new (Companion_39())();
  return Companion_instance_41;
}
var $serializerClass_37;
function $serializer_37() {
  if ($serializerClass_37 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_37 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.UnlockProjectRequest', this, 8);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('project', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(Project())));
        tmp0_serialDesc.a1b('lock', false);
        tmp0_serialDesc.a1b('submitted', false);
        tmp0_serialDesc.a1b('submittedByClient', false);
        tmp0_serialDesc.a1b('message', false);
        tmp0_serialDesc.a1b('attachments', false);
        tmp0_serialDesc.a1b('accepted', true);
        this.u99_1 = tmp0_serialDesc;
      }
      v99(encoder, value) {
        var tmp0_desc = this.u99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_53().e86_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.j86_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.j86_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.k86_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_42(), value.l86_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance_4(), value.m86_1);
        tmp1_output.s14(tmp0_desc, 4, value.n86_1);
        tmp1_output.a15(tmp0_desc, 5, value.o86_1);
        tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.p86_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.q86_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_4(), value.q86_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v99(encoder, value instanceof UnlockProjectRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_53().e86_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, $serializer_getInstance_4(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.x13(tmp0_desc, 0, tmp13_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.x13(tmp0_desc, 1, tmp13_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.x13(tmp0_desc, 3, $serializer_getInstance_4(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.x13(tmp0_desc, 6, tmp13_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, $serializer_getInstance_4(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return UnlockProjectRequest().w99(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.u99_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_53().e86_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), $serializer_getInstance_42(), $serializer_getInstance_4(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[6].f2(), get_nullable($serializer_getInstance_4())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_37 = $;
  }
  return $serializerClass_37;
}
var $serializer_instance_37;
function $serializer_getInstance_53() {
  if ($serializer_instance_37 === VOID)
    new ($serializer_37())();
  return $serializer_instance_37;
}
var UnlockProjectRequestClass;
function UnlockProjectRequest() {
  if (UnlockProjectRequestClass === VOID) {
    class $ {
      constructor(_id, project, lock, submitted, submittedByClient, message, attachments, accepted) {
        Companion_getInstance_53();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        accepted = accepted === VOID ? null : accepted;
        this.j86_1 = _id;
        this.k86_1 = project;
        this.l86_1 = lock;
        this.m86_1 = submitted;
        this.n86_1 = submittedByClient;
        this.o86_1 = message;
        this.p86_1 = attachments;
        this.q86_1 = accepted;
      }
      f40() {
        return this.j86_1;
      }
      x99(_id, project, lock, submitted, submittedByClient, message, attachments, accepted) {
        return new (UnlockProjectRequest())(_id, project, lock, submitted, submittedByClient, message, attachments, accepted);
      }
      s86(_id, project, lock, submitted, submittedByClient, message, attachments, accepted, $super) {
        _id = _id === VOID ? this.j86_1 : _id;
        project = project === VOID ? this.k86_1 : project;
        lock = lock === VOID ? this.l86_1 : lock;
        submitted = submitted === VOID ? this.m86_1 : submitted;
        submittedByClient = submittedByClient === VOID ? this.n86_1 : submittedByClient;
        message = message === VOID ? this.o86_1 : message;
        attachments = attachments === VOID ? this.p86_1 : attachments;
        accepted = accepted === VOID ? this.q86_1 : accepted;
        return $super === VOID ? this.x99(_id, project, lock, submitted, submittedByClient, message, attachments, accepted) : $super.x99.call(this, _id, project, lock, submitted, submittedByClient, message, attachments, accepted);
      }
      toString() {
        return 'UnlockProjectRequest(_id=' + this.j86_1.toString() + ', project=' + this.k86_1.toString() + ', lock=' + this.l86_1.toString() + ', submitted=' + this.m86_1.toString() + ', submittedByClient=' + this.n86_1 + ', message=' + this.o86_1 + ', attachments=' + toString(this.p86_1) + ', accepted=' + toString_0(this.q86_1) + ')';
      }
      hashCode() {
        var result = this.j86_1.hashCode();
        result = imul(result, 31) + this.k86_1.hashCode() | 0;
        result = imul(result, 31) + this.l86_1.hashCode() | 0;
        result = imul(result, 31) + this.m86_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n86_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o86_1) | 0;
        result = imul(result, 31) + hashCode(this.p86_1) | 0;
        result = imul(result, 31) + (this.q86_1 == null ? 0 : this.q86_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UnlockProjectRequest()))
          return false;
        if (!this.j86_1.equals(other.j86_1))
          return false;
        if (!this.k86_1.equals(other.k86_1))
          return false;
        if (!this.l86_1.equals(other.l86_1))
          return false;
        if (!this.m86_1.equals(other.m86_1))
          return false;
        if (!(this.n86_1 === other.n86_1))
          return false;
        if (!(this.o86_1 === other.o86_1))
          return false;
        if (!equals(this.p86_1, other.p86_1))
          return false;
        if (!equals(this.q86_1, other.q86_1))
          return false;
        return true;
      }
      static w99(seen0, _id, project, lock, submitted, submittedByClient, message, attachments, accepted, serializationConstructorMarker) {
        Companion_getInstance_53();
        if (!(126 === (126 & seen0))) {
          throwMissingFieldException(seen0, 126, $serializer_getInstance_53().u99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.j86_1 = Companion_getInstance().k2p();
        else
          $this.j86_1 = _id;
        $this.k86_1 = project;
        $this.l86_1 = lock;
        $this.m86_1 = submitted;
        $this.n86_1 = submittedByClient;
        $this.o86_1 = message;
        $this.p86_1 = attachments;
        if (0 === (seen0 & 128))
          $this.q86_1 = null;
        else
          $this.q86_1 = accepted;
        return $this;
      }
    }
    initMetadataForClass($, 'UnlockProjectRequest', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_53});
    UnlockProjectRequestClass = $;
  }
  return UnlockProjectRequestClass;
}
function User$Companion$$childSerializers$_anonymous__6nf9sv() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_0() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_1() {
  return Companion_getInstance_10().k2a();
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (ArrayListSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
function User$Companion$$childSerializers$_anonymous__6nf9sv_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_40;
function Companion_40() {
  if (CompanionClass_40 === VOID) {
    class $ {
      constructor() {
        Companion_instance_42 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, User$Companion$$childSerializers$_anonymous__6nf9sv);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, User$Companion$$childSerializers$_anonymous__6nf9sv_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, User$Companion$$childSerializers$_anonymous__6nf9sv_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, User$Companion$$childSerializers$_anonymous__6nf9sv_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y87_1 = [tmp_1, null, null, tmp_3, null, null, null, null, null, tmp_5, null, null, null, null, null, tmp_7, lazy(tmp_8, User$Companion$$childSerializers$_anonymous__6nf9sv_3)];
      }
      k2a() {
        return $serializer_getInstance_54();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_40 = $;
  }
  return CompanionClass_40;
}
var Companion_instance_42;
function Companion_getInstance_54() {
  if (Companion_instance_42 === VOID)
    new (Companion_40())();
  return Companion_instance_42;
}
var $serializerClass_38;
function $serializer_38() {
  if ($serializerClass_38 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_38 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.User', this, 17);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.b1b(new (Unique())());
        tmp0_serialDesc.a1b('phoneNumber', false);
        tmp0_serialDesc.a1b('fcmTokens', true);
        tmp0_serialDesc.a1b('firstName', false);
        tmp0_serialDesc.a1b('lastName', false);
        tmp0_serialDesc.a1b('address', false);
        tmp0_serialDesc.a1b('membership', true);
        tmp0_serialDesc.a1b('paymentId', true);
        tmp0_serialDesc.a1b('role', false);
        tmp0_serialDesc.a1b('receivesNewContractorEmails', true);
        tmp0_serialDesc.a1b('mfaEnabled', true);
        tmp0_serialDesc.a1b('phoneVerified', true);
        tmp0_serialDesc.a1b('hasPaymentMethods', true);
        tmp0_serialDesc.b1b(new (Denormalized())());
        tmp0_serialDesc.a1b('sendNotifications', true);
        tmp0_serialDesc.a1b('viewingAnonymousProjects', true);
        tmp0_serialDesc.a1b('created', true);
        this.y99_1 = tmp0_serialDesc;
      }
      z99(encoder, value) {
        var tmp0_desc = this.y99_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_54().y87_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d88_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d88_1);
        }
        tmp1_output.c15(tmp0_desc, 1, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.e88_1));
        tmp1_output.c15(tmp0_desc, 2, PhoneNumberSerializer_getInstance(), new (PhoneNumber())(value.f88_1));
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !equals(value.g88_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.g88_1);
        }
        tmp1_output.a15(tmp0_desc, 4, value.h88_1);
        tmp1_output.a15(tmp0_desc, 5, value.i88_1);
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_5(), value.j88_1);
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.k88_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, $serializer_getInstance_12(), value.k88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.l88_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, StringSerializer_getInstance(), value.l88_1);
        }
        tmp1_output.c15(tmp0_desc, 9, tmp2_cached[9].f2(), value.m88_1);
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.n88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 10, value.n88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.o88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 11, value.o88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.p88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 12, value.p88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 13) ? true : !(value.q88_1 === false)) {
          tmp1_output.s14(tmp0_desc, 13, value.q88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 14) ? true : !(value.r88_1 === true)) {
          tmp1_output.s14(tmp0_desc, 14, value.r88_1);
        }
        if (tmp1_output.h15(tmp0_desc, 15) ? true : !equals(value.s88_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 15, tmp2_cached[15].f2(), value.s88_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 16)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance_0).b1m();
          tmp = !value.t88_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 16, tmp2_cached[16].f2(), value.t88_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z99(encoder, value instanceof User() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y99_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = false;
        var tmp15_local11 = false;
        var tmp16_local12 = false;
        var tmp17_local13 = false;
        var tmp18_local14 = false;
        var tmp19_local15 = null;
        var tmp20_local16 = null;
        var tmp21_input = decoder.l13(tmp0_desc);
        var tmp22_cached = Companion_getInstance_54().y87_1;
        if (tmp21_input.a14()) {
          tmp4_local0 = tmp21_input.x13(tmp0_desc, 0, tmp22_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp21_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.a3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp6_local2;
          var tmp_4 = tmp21_input.x13(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp6_local2 = tmp_4 == null ? null : tmp_4.f3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp21_input.x13(tmp0_desc, 3, tmp22_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp21_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp21_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp21_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp21_input.z13(tmp0_desc, 7, $serializer_getInstance_12(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp21_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp21_input.x13(tmp0_desc, 9, tmp22_cached[9].f2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp21_input.n13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp21_input.n13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp21_input.n13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp21_input.n13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp21_input.n13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp21_input.x13(tmp0_desc, 15, tmp22_cached[15].f2(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp21_input.x13(tmp0_desc, 16, tmp22_cached[16].f2(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp21_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp21_input.x13(tmp0_desc, 0, tmp22_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = EmailAddressSerializer_getInstance();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp21_input.x13(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (EmailAddress())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.a3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_8 = PhoneNumberSerializer_getInstance();
                var tmp_9 = tmp6_local2;
                var tmp_10 = tmp21_input.x13(tmp0_desc, 2, tmp_8, tmp_9 == null ? null : new (PhoneNumber())(tmp_9));
                tmp6_local2 = tmp_10 == null ? null : tmp_10.f3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp21_input.x13(tmp0_desc, 3, tmp22_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp21_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp21_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp21_input.x13(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp21_input.z13(tmp0_desc, 7, $serializer_getInstance_12(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp21_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp21_input.x13(tmp0_desc, 9, tmp22_cached[9].f2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp21_input.n13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp21_input.n13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp21_input.n13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp21_input.n13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp21_input.n13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp21_input.x13(tmp0_desc, 15, tmp22_cached[15].f2(), tmp19_local15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp21_input.x13(tmp0_desc, 16, tmp22_cached[16].f2(), tmp20_local16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp21_input.m13(tmp0_desc);
        return User().a9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
      }
      az() {
        return this.y99_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_54().y87_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), EmailAddressSerializer_getInstance(), PhoneNumberSerializer_getInstance(), tmp0_cached[3].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_5(), get_nullable($serializer_getInstance_12()), get_nullable(StringSerializer_getInstance()), tmp0_cached[9].f2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[15].f2(), tmp0_cached[16].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_38 = $;
  }
  return $serializerClass_38;
}
var $serializer_instance_38;
function $serializer_getInstance_54() {
  if ($serializer_instance_38 === VOID)
    new ($serializer_38())();
  return $serializer_instance_38;
}
var UserClass;
function User() {
  if (UserClass === VOID) {
    class $ {
      constructor(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created) {
        Companion_getInstance_54();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        fcmTokens = fcmTokens === VOID ? emptyList() : fcmTokens;
        membership = membership === VOID ? null : membership;
        paymentId = paymentId === VOID ? null : paymentId;
        receivesNewContractorEmails = receivesNewContractorEmails === VOID ? false : receivesNewContractorEmails;
        mfaEnabled = mfaEnabled === VOID ? false : mfaEnabled;
        phoneVerified = phoneVerified === VOID ? false : phoneVerified;
        hasPaymentMethods = hasPaymentMethods === VOID ? false : hasPaymentMethods;
        sendNotifications = sendNotifications === VOID ? true : sendNotifications;
        viewingAnonymousProjects = viewingAnonymousProjects === VOID ? emptyList() : viewingAnonymousProjects;
        var tmp;
        if (created === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance_0).b1m();
        } else {
          tmp = created;
        }
        created = tmp;
        this.d88_1 = _id;
        this.e88_1 = email;
        this.f88_1 = phoneNumber;
        this.g88_1 = fcmTokens;
        this.h88_1 = firstName;
        this.i88_1 = lastName;
        this.j88_1 = address;
        this.k88_1 = membership;
        this.l88_1 = paymentId;
        this.m88_1 = role;
        this.n88_1 = receivesNewContractorEmails;
        this.o88_1 = mfaEnabled;
        this.p88_1 = phoneVerified;
        this.q88_1 = hasPaymentMethods;
        this.r88_1 = sendNotifications;
        this.s88_1 = viewingAnonymousProjects;
        this.t88_1 = created;
      }
      f40() {
        return this.d88_1;
      }
      b9a(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created) {
        return new (User())(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created);
      }
      v88(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created, $super) {
        _id = _id === VOID ? this.d88_1 : _id;
        email = email === VOID ? this.e88_1 : email;
        phoneNumber = phoneNumber === VOID ? this.f88_1 : phoneNumber;
        fcmTokens = fcmTokens === VOID ? this.g88_1 : fcmTokens;
        firstName = firstName === VOID ? this.h88_1 : firstName;
        lastName = lastName === VOID ? this.i88_1 : lastName;
        address = address === VOID ? this.j88_1 : address;
        membership = membership === VOID ? this.k88_1 : membership;
        paymentId = paymentId === VOID ? this.l88_1 : paymentId;
        role = role === VOID ? this.m88_1 : role;
        receivesNewContractorEmails = receivesNewContractorEmails === VOID ? this.n88_1 : receivesNewContractorEmails;
        mfaEnabled = mfaEnabled === VOID ? this.o88_1 : mfaEnabled;
        phoneVerified = phoneVerified === VOID ? this.p88_1 : phoneVerified;
        hasPaymentMethods = hasPaymentMethods === VOID ? this.q88_1 : hasPaymentMethods;
        sendNotifications = sendNotifications === VOID ? this.r88_1 : sendNotifications;
        viewingAnonymousProjects = viewingAnonymousProjects === VOID ? this.s88_1 : viewingAnonymousProjects;
        created = created === VOID ? this.t88_1 : created;
        return $super === VOID ? this.b9a(_id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created) : $super.b9a.call(this, _id, new (EmailAddress())(email), new (PhoneNumber())(phoneNumber), fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created);
      }
      toString() {
        return 'User(_id=' + this.d88_1.toString() + ', email=' + EmailAddress__toString_impl_artjh3(this.e88_1) + ', phoneNumber=' + PhoneNumber__toString_impl_7i2x3q(this.f88_1) + ', fcmTokens=' + toString(this.g88_1) + ', firstName=' + this.h88_1 + ', lastName=' + this.i88_1 + ', address=' + this.j88_1.toString() + ', membership=' + toString_0(this.k88_1) + ', paymentId=' + this.l88_1 + ', role=' + this.m88_1.toString() + ', receivesNewContractorEmails=' + this.n88_1 + ', mfaEnabled=' + this.o88_1 + ', phoneVerified=' + this.p88_1 + ', hasPaymentMethods=' + this.q88_1 + ', sendNotifications=' + this.r88_1 + ', viewingAnonymousProjects=' + toString(this.s88_1) + ', created=' + this.t88_1.toString() + ')';
      }
      hashCode() {
        var result = this.d88_1.hashCode();
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.e88_1) | 0;
        result = imul(result, 31) + PhoneNumber__hashCode_impl_t98twl(this.f88_1) | 0;
        result = imul(result, 31) + hashCode(this.g88_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h88_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i88_1) | 0;
        result = imul(result, 31) + this.j88_1.hashCode() | 0;
        result = imul(result, 31) + (this.k88_1 == null ? 0 : this.k88_1.hashCode()) | 0;
        result = imul(result, 31) + (this.l88_1 == null ? 0 : getStringHashCode(this.l88_1)) | 0;
        result = imul(result, 31) + this.m88_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.o88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.q88_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.r88_1) | 0;
        result = imul(result, 31) + hashCode(this.s88_1) | 0;
        result = imul(result, 31) + this.t88_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof User()))
          return false;
        if (!this.d88_1.equals(other.d88_1))
          return false;
        if (!(this.e88_1 === other.e88_1))
          return false;
        if (!(this.f88_1 === other.f88_1))
          return false;
        if (!equals(this.g88_1, other.g88_1))
          return false;
        if (!(this.h88_1 === other.h88_1))
          return false;
        if (!(this.i88_1 === other.i88_1))
          return false;
        if (!this.j88_1.equals(other.j88_1))
          return false;
        if (!equals(this.k88_1, other.k88_1))
          return false;
        if (!(this.l88_1 == other.l88_1))
          return false;
        if (!this.m88_1.equals(other.m88_1))
          return false;
        if (!(this.n88_1 === other.n88_1))
          return false;
        if (!(this.o88_1 === other.o88_1))
          return false;
        if (!(this.p88_1 === other.p88_1))
          return false;
        if (!(this.q88_1 === other.q88_1))
          return false;
        if (!(this.r88_1 === other.r88_1))
          return false;
        if (!equals(this.s88_1, other.s88_1))
          return false;
        if (!this.t88_1.equals(other.t88_1))
          return false;
        return true;
      }
      static a9a(seen0, _id, email, phoneNumber, fcmTokens, firstName, lastName, address, membership, paymentId, role, receivesNewContractorEmails, mfaEnabled, phoneVerified, hasPaymentMethods, sendNotifications, viewingAnonymousProjects, created, serializationConstructorMarker) {
        Companion_getInstance_54();
        if (!(630 === (630 & seen0))) {
          throwMissingFieldException(seen0, 630, $serializer_getInstance_54().y99_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d88_1 = Companion_getInstance().k2p();
        else
          $this.d88_1 = _id;
        $this.e88_1 = email;
        $this.f88_1 = phoneNumber;
        if (0 === (seen0 & 8))
          $this.g88_1 = emptyList();
        else
          $this.g88_1 = fcmTokens;
        $this.h88_1 = firstName;
        $this.i88_1 = lastName;
        $this.j88_1 = address;
        if (0 === (seen0 & 128))
          $this.k88_1 = null;
        else
          $this.k88_1 = membership;
        if (0 === (seen0 & 256))
          $this.l88_1 = null;
        else
          $this.l88_1 = paymentId;
        $this.m88_1 = role;
        if (0 === (seen0 & 1024))
          $this.n88_1 = false;
        else
          $this.n88_1 = receivesNewContractorEmails;
        if (0 === (seen0 & 2048))
          $this.o88_1 = false;
        else
          $this.o88_1 = mfaEnabled;
        if (0 === (seen0 & 4096))
          $this.p88_1 = false;
        else
          $this.p88_1 = phoneVerified;
        if (0 === (seen0 & 8192))
          $this.q88_1 = false;
        else
          $this.q88_1 = hasPaymentMethods;
        if (0 === (seen0 & 16384))
          $this.r88_1 = true;
        else
          $this.r88_1 = sendNotifications;
        if (0 === (seen0 & 32768))
          $this.s88_1 = emptyList();
        else
          $this.s88_1 = viewingAnonymousProjects;
        if (0 === (seen0 & 65536)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.t88_1 = get_default(Companion_instance_0).b1m();
        } else
          $this.t88_1 = created;
        return $this;
      }
    }
    initMetadataForClass($, 'User', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_54});
    UserClass = $;
  }
  return UserClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.f8q_1.f2();
}
function DisputeState$Companion$_anonymous__16xn8e() {
  return createSimpleEnumSerializer('com.crowpay.DisputeState', values_2());
}
var DisputeState_Ongoing_instance;
var DisputeState_ProjectLocked_instance;
var DisputeState_Resolved_instance;
function values_2() {
  return [DisputeState_Ongoing_getInstance(), DisputeState_ProjectLocked_getInstance(), DisputeState_Resolved_getInstance()];
}
var CompanionClass_41;
function Companion_41() {
  if (CompanionClass_41 === VOID) {
    class $ {
      constructor() {
        Companion_instance_43 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.f8q_1 = lazy(tmp_0, DisputeState$Companion$_anonymous__16xn8e);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_41 = $;
  }
  return CompanionClass_41;
}
var Companion_instance_43;
function Companion_getInstance_55() {
  DisputeState_initEntries();
  if (Companion_instance_43 === VOID)
    new (Companion_41())();
  return Companion_instance_43;
}
var DisputeState_entriesInitialized;
function DisputeState_initEntries() {
  if (DisputeState_entriesInitialized)
    return Unit_instance;
  DisputeState_entriesInitialized = true;
  DisputeState_Ongoing_instance = DisputeState().e9a('Ongoing', 0);
  DisputeState_ProjectLocked_instance = DisputeState().e9a('ProjectLocked', 1);
  DisputeState_Resolved_instance = DisputeState().e9a('Resolved', 2);
  Companion_getInstance_55();
}
var DisputeStateClass;
function DisputeState() {
  if (DisputeStateClass === VOID) {
    class $ extends Enum() {
      static e9a(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'DisputeState', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_55});
    DisputeStateClass = $;
  }
  return DisputeStateClass;
}
function MessageReply$Companion$$childSerializers$_anonymous__7g03cp() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_42;
function Companion_42() {
  if (CompanionClass_42 === VOID) {
    class $ {
      constructor() {
        Companion_instance_44 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g8q_1 = [lazy(tmp_0, MessageReply$Companion$$childSerializers$_anonymous__7g03cp), null];
      }
      k2a() {
        return $serializer_getInstance_55();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_42 = $;
  }
  return CompanionClass_42;
}
var Companion_instance_44;
function Companion_getInstance_56() {
  if (Companion_instance_44 === VOID)
    new (Companion_42())();
  return Companion_instance_44;
}
var $serializerClass_39;
function $serializer_39() {
  if ($serializerClass_39 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_39 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MessageReply', this, 2);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(ProjectMessage())));
        tmp0_serialDesc.a1b('message', false);
        this.f9a_1 = tmp0_serialDesc;
      }
      g9a(encoder, value) {
        var tmp0_desc = this.f9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_56().g8q_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.h9a_1);
        tmp1_output.a15(tmp0_desc, 1, value.i9a_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g9a(encoder, value instanceof MessageReply() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_56().g8q_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return MessageReply().j9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.f9a_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_56().g8q_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_39 = $;
  }
  return $serializerClass_39;
}
var $serializer_instance_39;
function $serializer_getInstance_55() {
  if ($serializer_instance_39 === VOID)
    new ($serializer_39())();
  return $serializer_instance_39;
}
var MessageReplyClass;
function MessageReply() {
  if (MessageReplyClass === VOID) {
    class $ {
      static k9a(id, message) {
        Companion_getInstance_56();
        var $this = createThis(this);
        $this.h9a_1 = id;
        $this.i9a_1 = message;
        return $this;
      }
      static l9a(message) {
        Companion_getInstance_56();
        return this.k9a(message.g7p_1, message.n7p_1);
      }
      toString() {
        return 'MessageReply(id=' + this.h9a_1.toString() + ', message=' + this.i9a_1 + ')';
      }
      hashCode() {
        var result = this.h9a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.i9a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageReply()))
          return false;
        if (!this.h9a_1.equals(other.h9a_1))
          return false;
        if (!(this.i9a_1 === other.i9a_1))
          return false;
        return true;
      }
      static j9a(seen0, id, message, serializationConstructorMarker) {
        Companion_getInstance_56();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_55().f9a_1);
        }
        var $this = createThis(this);
        $this.h9a_1 = id;
        $this.i9a_1 = message;
        return $this;
      }
    }
    initMetadataForClass($, 'MessageReply', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
    MessageReplyClass = $;
  }
  return MessageReplyClass;
}
function PayAppMessageReference$Companion$$childSerializers$_anonymous__eql5t9() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_43;
function Companion_43() {
  if (CompanionClass_43 === VOID) {
    class $ {
      constructor() {
        Companion_instance_45 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i8q_1 = [lazy(tmp_0, PayAppMessageReference$Companion$$childSerializers$_anonymous__eql5t9), null];
      }
      k2a() {
        return $serializer_getInstance_56();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_43 = $;
  }
  return CompanionClass_43;
}
var Companion_instance_45;
function Companion_getInstance_57() {
  if (Companion_instance_45 === VOID)
    new (Companion_43())();
  return Companion_instance_45;
}
var $serializerClass_40;
function $serializer_40() {
  if ($serializerClass_40 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_40 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PayAppMessageReference', this, 2);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(PayApplication())));
        tmp0_serialDesc.a1b('reason', false);
        this.m9a_1 = tmp0_serialDesc;
      }
      n9a(encoder, value) {
        var tmp0_desc = this.m9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_57().i8q_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.o9a_1);
        tmp1_output.a15(tmp0_desc, 1, value.p9a_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n9a(encoder, value instanceof PayAppMessageReference() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_57().i8q_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PayAppMessageReference().q9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.m9a_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_57().i8q_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_40 = $;
  }
  return $serializerClass_40;
}
var $serializer_instance_40;
function $serializer_getInstance_56() {
  if ($serializer_instance_40 === VOID)
    new ($serializer_40())();
  return $serializer_instance_40;
}
var PayAppMessageReferenceClass;
function PayAppMessageReference() {
  if (PayAppMessageReferenceClass === VOID) {
    class $ {
      toString() {
        return 'PayAppMessageReference(id=' + this.o9a_1.toString() + ', reason=' + this.p9a_1 + ')';
      }
      hashCode() {
        var result = this.o9a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.p9a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayAppMessageReference()))
          return false;
        if (!this.o9a_1.equals(other.o9a_1))
          return false;
        if (!(this.p9a_1 === other.p9a_1))
          return false;
        return true;
      }
      static q9a(seen0, id, reason, serializationConstructorMarker) {
        Companion_getInstance_57();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_56().m9a_1);
        }
        var $this = createThis(this);
        $this.o9a_1 = id;
        $this.p9a_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'PayAppMessageReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
    PayAppMessageReferenceClass = $;
  }
  return PayAppMessageReferenceClass;
}
function ChangeRequestMessageReference$Companion$$childSerializers$_anonymous__9zm4qv() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_44;
function Companion_44() {
  if (CompanionClass_44 === VOID) {
    class $ {
      constructor() {
        Companion_instance_46 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h8q_1 = [lazy(tmp_0, ChangeRequestMessageReference$Companion$$childSerializers$_anonymous__9zm4qv), null];
      }
      k2a() {
        return $serializer_getInstance_57();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_44 = $;
  }
  return CompanionClass_44;
}
var Companion_instance_46;
function Companion_getInstance_58() {
  if (Companion_instance_46 === VOID)
    new (Companion_44())();
  return Companion_instance_46;
}
var $serializerClass_41;
function $serializer_41() {
  if ($serializerClass_41 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_41 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ChangeRequestMessageReference', this, 2);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.b1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.a1b('reason', false);
        this.r9a_1 = tmp0_serialDesc;
      }
      s9a(encoder, value) {
        var tmp0_desc = this.r9a_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_58().h8q_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t9a_1);
        tmp1_output.a15(tmp0_desc, 1, value.u9a_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s9a(encoder, value instanceof ChangeRequestMessageReference() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r9a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_58().h8q_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ChangeRequestMessageReference().v9a(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.r9a_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_58().h8q_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_41 = $;
  }
  return $serializerClass_41;
}
var $serializer_instance_41;
function $serializer_getInstance_57() {
  if ($serializer_instance_41 === VOID)
    new ($serializer_41())();
  return $serializer_instance_41;
}
var ChangeRequestMessageReferenceClass;
function ChangeRequestMessageReference() {
  if (ChangeRequestMessageReferenceClass === VOID) {
    class $ {
      toString() {
        return 'ChangeRequestMessageReference(id=' + this.t9a_1.toString() + ', reason=' + this.u9a_1 + ')';
      }
      hashCode() {
        var result = this.t9a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.u9a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequestMessageReference()))
          return false;
        if (!this.t9a_1.equals(other.t9a_1))
          return false;
        if (!(this.u9a_1 === other.u9a_1))
          return false;
        return true;
      }
      static v9a(seen0, id, reason, serializationConstructorMarker) {
        Companion_getInstance_58();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_57().r9a_1);
        }
        var $this = createThis(this);
        $this.t9a_1 = id;
        $this.u9a_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeRequestMessageReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_57});
    ChangeRequestMessageReferenceClass = $;
  }
  return ChangeRequestMessageReferenceClass;
}
function _ShortId___init__impl__tlblaa(raw) {
  return raw;
}
function _ShortId___get_raw__impl__8lcwip($this) {
  return $this;
}
function ShortId__compareTo_impl_18ek8s($this, other) {
  return compareTo_0(_ShortId___get_raw__impl__8lcwip($this), _ShortId___get_raw__impl__8lcwip(other));
}
function ShortId__compareTo_impl_18ek8s_0($this, other) {
  return ShortId__compareTo_impl_18ek8s($this.l5n_1, other instanceof ShortId() ? other.l5n_1 : THROW_CCE());
}
function ShortId__toString_impl_wslzee($this) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = toString_1(_ShortId___get_raw__impl__8lcwip($this), 16).toUpperCase();
  return padStart(tmp$ret$1, 4, _Char___init__impl__6a9atx(48));
}
var CompanionClass_45;
function Companion_45() {
  if (CompanionClass_45 === VOID) {
    class $ {
      i5n() {
        return _ShortId___init__impl__tlblaa(Default_getInstance().br(0, 65535));
      }
      k2a() {
        return $serializer_getInstance_58();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_45 = $;
  }
  return CompanionClass_45;
}
var Companion_instance_47;
function Companion_getInstance_59() {
  return Companion_instance_47;
}
var $serializerClass_42;
function $serializer_42() {
  if ($serializerClass_42 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_42 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.crowpay.ShortId', this);
        tmp0_serialDesc.a1b('raw', false);
        this.w9a_1 = tmp0_serialDesc;
      }
      x9a(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.w9a_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.k14(_ShortId___get_raw__impl__8lcwip(value));
        }
      }
      oz(encoder, value) {
        return this.x9a(encoder, value instanceof ShortId() ? value.l5n_1 : THROW_CCE());
      }
      y9a(decoder) {
        return _ShortId___init__impl__tlblaa(decoder.j13(this.w9a_1).c13());
      }
      pz(decoder) {
        return new (ShortId())(this.y9a(decoder));
      }
      az() {
        return this.w9a_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_42 = $;
  }
  return $serializerClass_42;
}
var $serializer_instance_42;
function $serializer_getInstance_58() {
  if ($serializer_instance_42 === VOID)
    new ($serializer_42())();
  return $serializer_instance_42;
}
function ShortId__hashCode_impl_ghc5rv($this) {
  return $this;
}
function ShortId__equals_impl_1l2c0n($this, other) {
  if (!(other instanceof ShortId()))
    return false;
  if (!($this === other.l5n_1))
    return false;
  return true;
}
var ShortIdClass;
function ShortId() {
  if (ShortIdClass === VOID) {
    class $ {
      constructor(raw) {
        this.l5n_1 = raw;
      }
      z9a(other) {
        return ShortId__compareTo_impl_18ek8s(this.l5n_1, other);
      }
      d(other) {
        return ShortId__compareTo_impl_18ek8s_0(this, other);
      }
      toString() {
        return ShortId__toString_impl_wslzee(this.l5n_1);
      }
      hashCode() {
        return ShortId__hashCode_impl_ghc5rv(this.l5n_1);
      }
      equals(other) {
        return ShortId__equals_impl_1l2c0n(this.l5n_1, other);
      }
    }
    initMetadataForClass($, 'ShortId', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_58});
    ShortIdClass = $;
  }
  return ShortIdClass;
}
function Owner$Companion$$childSerializers$_anonymous__2fi79l() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Owner$Companion$$childSerializers$_anonymous__2fi79l_0() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
var CompanionClass_46;
function Companion_46() {
  if (CompanionClass_46 === VOID) {
    class $ {
      constructor() {
        Companion_instance_48 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Owner$Companion$$childSerializers$_anonymous__2fi79l);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l6s_1 = [tmp_1, null, null, null, null, null, null, null, null, null, null, lazy(tmp_2, Owner$Companion$$childSerializers$_anonymous__2fi79l_0)];
      }
      k2a() {
        return $serializer_getInstance_59();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_46 = $;
  }
  return CompanionClass_46;
}
var Companion_instance_48;
function Companion_getInstance_60() {
  if (Companion_instance_48 === VOID)
    new (Companion_46())();
  return Companion_instance_48;
}
var $serializerClass_43;
function $serializer_43() {
  if ($serializerClass_43 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_43 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Owner', this, 12);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('legalFirstName', false);
        tmp0_serialDesc.a1b('legalLastName', false);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.a1b('phoneNumber', false);
        tmp0_serialDesc.a1b('address', false);
        tmp0_serialDesc.a1b('title', true);
        tmp0_serialDesc.a1b('ssn', true);
        tmp0_serialDesc.a1b('ssnDisplay', true);
        tmp0_serialDesc.a1b('ownership', true);
        tmp0_serialDesc.a1b('birthDate', true);
        tmp0_serialDesc.a1b('document', true);
        this.a9b_1 = tmp0_serialDesc;
      }
      b9b(encoder, value) {
        var tmp0_desc = this.a9b_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_60().l6s_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.s6s_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.s6s_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.t6s_1);
        tmp1_output.a15(tmp0_desc, 2, value.u6s_1);
        tmp1_output.c15(tmp0_desc, 3, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.v6s_1));
        tmp1_output.c15(tmp0_desc, 4, PhoneNumberSerializer_getInstance(), new (PhoneNumber())(value.w6s_1));
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance_5(), value.x6s_1);
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.y6s_1 === '')) {
          tmp1_output.a15(tmp0_desc, 6, value.y6s_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.z6s_1 === '')) {
          tmp1_output.a15(tmp0_desc, 7, value.z6s_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.a6t_1 === '')) {
          tmp1_output.a15(tmp0_desc, 8, value.a6t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.b6t_1 === 100)) {
          tmp1_output.v14(tmp0_desc, 9, value.b6t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.c6t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, LocalDateIso8601Serializer_getInstance(), value.c6t_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 11)) {
          tmp = true;
        } else {
          var tmp_0 = value.d6t_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[11].f2();
          var tmp_2 = value.d6t_1;
          tmp1_output.d15(tmp0_desc, 11, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b9b(encoder, value instanceof Owner() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a9b_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = 0;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_input = decoder.l13(tmp0_desc);
        var tmp17_cached = Companion_getInstance_60().l6s_1;
        if (tmp16_input.a14()) {
          tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp16_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp16_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp16_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.a3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp8_local4;
          var tmp_4 = tmp16_input.x13(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp8_local4 = tmp_4 == null ? null : tmp_4.f3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_5(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp16_input.v13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp16_input.q13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, LocalDateIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          var tmp_5 = tmp17_cached[11].f2();
          var tmp_6 = tmp15_local11;
          var tmp_7 = tmp16_input.z13(tmp0_desc, 11, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
          tmp15_local11 = tmp_7 == null ? null : tmp_7.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp16_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp16_input.x13(tmp0_desc, 0, tmp17_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp16_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp16_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_8 = EmailAddressSerializer_getInstance();
                var tmp_9 = tmp7_local3;
                var tmp_10 = tmp16_input.x13(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (EmailAddress())(tmp_9));
                tmp7_local3 = tmp_10 == null ? null : tmp_10.a3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_11 = PhoneNumberSerializer_getInstance();
                var tmp_12 = tmp8_local4;
                var tmp_13 = tmp16_input.x13(tmp0_desc, 4, tmp_11, tmp_12 == null ? null : new (PhoneNumber())(tmp_12));
                tmp8_local4 = tmp_13 == null ? null : tmp_13.f3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp16_input.x13(tmp0_desc, 5, $serializer_getInstance_5(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp16_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp16_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp16_input.v13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp16_input.q13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp16_input.z13(tmp0_desc, 10, LocalDateIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                var tmp_14 = tmp17_cached[11].f2();
                var tmp_15 = tmp15_local11;
                var tmp_16 = tmp16_input.z13(tmp0_desc, 11, tmp_14, tmp_15 == null ? null : new (ServerFile())(tmp_15));
                tmp15_local11 = tmp_16 == null ? null : tmp_16.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp16_input.m13(tmp0_desc);
        return Owner().c9b(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
      }
      az() {
        return this.a9b_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_60().l6s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), EmailAddressSerializer_getInstance(), PhoneNumberSerializer_getInstance(), $serializer_getInstance_5(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(LocalDateIso8601Serializer_getInstance()), get_nullable(tmp0_cached[11].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_43 = $;
  }
  return $serializerClass_43;
}
var $serializer_instance_43;
function $serializer_getInstance_59() {
  if ($serializer_instance_43 === VOID)
    new ($serializer_43())();
  return $serializer_instance_43;
}
var OwnerClass;
function Owner() {
  if (OwnerClass === VOID) {
    class $ {
      constructor(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document) {
        Companion_getInstance_60();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        title = title === VOID ? '' : title;
        ssn = ssn === VOID ? '' : ssn;
        ssnDisplay = ssnDisplay === VOID ? '' : ssnDisplay;
        ownership = ownership === VOID ? 100 : ownership;
        birthDate = birthDate === VOID ? null : birthDate;
        document = document === VOID ? null : document;
        this.s6s_1 = _id;
        this.t6s_1 = legalFirstName;
        this.u6s_1 = legalLastName;
        this.v6s_1 = email;
        this.w6s_1 = phoneNumber;
        this.x6s_1 = address;
        this.y6s_1 = title;
        this.z6s_1 = ssn;
        this.a6t_1 = ssnDisplay;
        this.b6t_1 = ownership;
        this.c6t_1 = birthDate;
        this.d6t_1 = document;
      }
      f40() {
        return this.s6s_1;
      }
      d9b(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document) {
        return new (Owner())(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document);
      }
      f6t(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document, $super) {
        _id = _id === VOID ? this.s6s_1 : _id;
        legalFirstName = legalFirstName === VOID ? this.t6s_1 : legalFirstName;
        legalLastName = legalLastName === VOID ? this.u6s_1 : legalLastName;
        email = email === VOID ? this.v6s_1 : email;
        phoneNumber = phoneNumber === VOID ? this.w6s_1 : phoneNumber;
        address = address === VOID ? this.x6s_1 : address;
        title = title === VOID ? this.y6s_1 : title;
        ssn = ssn === VOID ? this.z6s_1 : ssn;
        ssnDisplay = ssnDisplay === VOID ? this.a6t_1 : ssnDisplay;
        ownership = ownership === VOID ? this.b6t_1 : ownership;
        birthDate = birthDate === VOID ? this.c6t_1 : birthDate;
        document = document === VOID ? this.d6t_1 : document;
        var tmp;
        if ($super === VOID) {
          tmp = this.d9b(_id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document);
        } else {
          var tmp_0 = $super.d9b;
          var tmp_1 = document;
          tmp = tmp_0.call(this, _id, legalFirstName, legalLastName, new (EmailAddress())(email), new (PhoneNumber())(phoneNumber), address, title, ssn, ssnDisplay, ownership, birthDate, tmp_1 == null ? null : new (ServerFile())(tmp_1));
        }
        return tmp;
      }
      toString() {
        var tmp = this.s6s_1.toString();
        var tmp_0 = EmailAddress__toString_impl_artjh3(this.v6s_1);
        var tmp_1 = PhoneNumber__toString_impl_7i2x3q(this.w6s_1);
        var tmp_2 = this.x6s_1.toString();
        var tmp_3 = toString_0(this.c6t_1);
        var tmp_4 = this.d6t_1;
        return 'Owner(_id=' + tmp + ', legalFirstName=' + this.t6s_1 + ', legalLastName=' + this.u6s_1 + ', email=' + tmp_0 + ', phoneNumber=' + tmp_1 + ', address=' + tmp_2 + ', title=' + this.y6s_1 + ', ssn=' + this.z6s_1 + ', ssnDisplay=' + this.a6t_1 + ', ownership=' + this.b6t_1 + ', birthDate=' + tmp_3 + ', document=' + toString_0(tmp_4 == null ? null : new (ServerFile())(tmp_4)) + ')';
      }
      hashCode() {
        var result = this.s6s_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.t6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u6s_1) | 0;
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.v6s_1) | 0;
        result = imul(result, 31) + PhoneNumber__hashCode_impl_t98twl(this.w6s_1) | 0;
        result = imul(result, 31) + this.x6s_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.y6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6t_1) | 0;
        result = imul(result, 31) + this.b6t_1 | 0;
        result = imul(result, 31) + (this.c6t_1 == null ? 0 : this.c6t_1.hashCode()) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.d6t_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.d6t_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Owner()))
          return false;
        if (!this.s6s_1.equals(other.s6s_1))
          return false;
        if (!(this.t6s_1 === other.t6s_1))
          return false;
        if (!(this.u6s_1 === other.u6s_1))
          return false;
        if (!(this.v6s_1 === other.v6s_1))
          return false;
        if (!(this.w6s_1 === other.w6s_1))
          return false;
        if (!this.x6s_1.equals(other.x6s_1))
          return false;
        if (!(this.y6s_1 === other.y6s_1))
          return false;
        if (!(this.z6s_1 === other.z6s_1))
          return false;
        if (!(this.a6t_1 === other.a6t_1))
          return false;
        if (!(this.b6t_1 === other.b6t_1))
          return false;
        if (!equals(this.c6t_1, other.c6t_1))
          return false;
        var tmp = this.d6t_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.d6t_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        return true;
      }
      static c9b(seen0, _id, legalFirstName, legalLastName, email, phoneNumber, address, title, ssn, ssnDisplay, ownership, birthDate, document, serializationConstructorMarker) {
        Companion_getInstance_60();
        if (!(62 === (62 & seen0))) {
          throwMissingFieldException(seen0, 62, $serializer_getInstance_59().a9b_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.s6s_1 = Companion_getInstance().k2p();
        else
          $this.s6s_1 = _id;
        $this.t6s_1 = legalFirstName;
        $this.u6s_1 = legalLastName;
        $this.v6s_1 = email;
        $this.w6s_1 = phoneNumber;
        $this.x6s_1 = address;
        if (0 === (seen0 & 64))
          $this.y6s_1 = '';
        else
          $this.y6s_1 = title;
        if (0 === (seen0 & 128))
          $this.z6s_1 = '';
        else
          $this.z6s_1 = ssn;
        if (0 === (seen0 & 256))
          $this.a6t_1 = '';
        else
          $this.a6t_1 = ssnDisplay;
        if (0 === (seen0 & 512))
          $this.b6t_1 = 100;
        else
          $this.b6t_1 = ownership;
        if (0 === (seen0 & 1024))
          $this.c6t_1 = null;
        else
          $this.c6t_1 = birthDate;
        if (0 === (seen0 & 2048))
          $this.d6t_1 = null;
        else
          $this.d6t_1 = document;
        return $this;
      }
    }
    initMetadataForClass($, 'Owner', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_59});
    OwnerClass = $;
  }
  return OwnerClass;
}
function DisputeState_Ongoing_getInstance() {
  DisputeState_initEntries();
  return DisputeState_Ongoing_instance;
}
function DisputeState_ProjectLocked_getInstance() {
  DisputeState_initEntries();
  return DisputeState_ProjectLocked_instance;
}
function DisputeState_Resolved_getInstance() {
  DisputeState_initEntries();
  return DisputeState_Resolved_instance;
}
//region block: init
Companion_instance_12 = new (Companion_10())();
Companion_instance_21 = new (Companion_19())();
Companion_instance_29 = new (Companion_27())();
Companion_instance_40 = new (Companion_38())();
Companion_instance_47 = new (Companion_45())();
//endregion
//region block: exports
export {
  ApprovedState as ApprovedState3hrsq7yllchx0,
  ChangeRequestMessageReference as ChangeRequestMessageReference3iran64qsoyry,
  ChangeRequest as ChangeRequesthd3ysa2j1i4f,
  Client as Clientuccelyr89ch8,
  CompletionMessageComment as CompletionMessageComment2phagw82v6lch,
  Purpose as Purpose22kmyfd0ayrve,
  ContractorDocument as ContractorDocument2jcw9hqg98amj,
  ContractorNote as ContractorNote59o6kpmrrw5h,
  Contractor as Contractor1wog4uk4l8u77,
  get_entries as get_entries19ryowjr3zlbs,
  Type as Typeqwc7utefu20x,
  CrowPayLegalDocument as CrowPayLegalDocumentvhqnf9xycsrg,
  DisputeState as DisputeState3oxdvb7g0kfjm,
  Dispute as Dispute39kejofcwuxch,
  EntityType as EntityType3jq9a4zvbs0nt,
  FundsRequest as FundsRequesthksopls9wk01,
  IncidentMessageComment as IncidentMessageComment1adwwkgdgyo0h,
  IncidentMessage as IncidentMessage1zg9aeg4hgwtu,
  Incident as Incident3aojs8cp7629c,
  ItemChange as ItemChangee3c665suy3yz,
  LegalDocumentAgreement as LegalDocumentAgreement2jq7u4nlw18u,
  License as License2dabzwgw7jcr2,
  LineItemCompletionMessage as LineItemCompletionMessage2zpi6q6jke1no,
  LineItem as LineItem2rt64afaiyloc,
  ConfirmedShipped as ConfirmedShippedhfotfv6hc5c1,
  Request as Request3h9l52knfhl5u,
  MailCheckPhysically as MailCheckPhysicallytriaqfbh0a67,
  MessageReply as MessageReply3razfyxlh5p4t,
  Owner as Owner3o3y53m8go5cb,
  PayAppItem as PayAppItemz8p3l02jgtr9,
  PayAppMessageReference as PayAppMessageReference2hrqvwim22vlh,
  PayApplication as PayApplicationmbkdcq3ut87x,
  Payout as Payout257apsotr6b9a,
  PendingItemChange as PendingItemChange1hwhwykx2kyit,
  PendingLineItem as PendingLineItem7uj25viy3ie8,
  LockInfo as LockInfo3qyh26jodrlpf,
  get_entries_0 as get_entries5hqvt5541yea,
  Type_0 as Typere4zxecw7uiw,
  ExternalDeposit as ExternalDepositoswk9ddf49t2,
  ProjectLedgerItem as ProjectLedgerItem1yul4cns1huli,
  ProjectMessage as ProjectMessage3vmbacgk5u7x3,
  ProjectSettlementDocumentation as ProjectSettlementDocumentation1o22wkmr8w8uo,
  ProjectTimer as ProjectTimerh0tihs6u35t6,
  Project as Projecto73xqbcrzskm,
  PunchListItem as PunchListItem1wbu5dz9rlo4k,
  ScopeView as ScopeView2pjeasrtqdymw,
  ShortId as ShortId1uz90q3uk7eoq,
  Specification as Specification3fgfbf7ihgj8v,
  Trade as Trade15v4llu79udze,
  UnlockProjectRequest as UnlockProjectRequestsb9zq5gbmeux,
  User as User8yb1tqk4kykg,
  Purpose_ArticleOfIncorporation_getInstance as Purpose_ArticleOfIncorporation_getInstance1fuetuxvqqp0v,
  Purpose_Other_getInstance as Purpose_Other_getInstancerlegdjt2kagb,
  Purpose_ProofOfEin_getInstance as Purpose_ProofOfEin_getInstance3u5kmocn55tdt,
  Type_ClientTermsAndConditions_getInstance as Type_ClientTermsAndConditions_getInstance2f0qgbe5c0m6j,
  Type_ContractorTermsAndConditions_getInstance as Type_ContractorTermsAndConditions_getInstance35f4ps0n3qx14,
  Type_PrivacyPolicy_getInstance as Type_PrivacyPolicy_getInstanceywyaqmy6sd2,
  DisputeState_Ongoing_getInstance as DisputeState_Ongoing_getInstance2zn99spsjy3fz,
  Type_Check_getInstance as Type_Check_getInstance2g1thuyr3vd4k,
  _ShortId___init__impl__tlblaa as _ShortId___init__impl__tlblaa141394eujsnz4,
  ShortId__toString_impl_wslzee as ShortId__toString_impl_wslzee3f3nb044hwkm0,
  Companion_getInstance_16 as Companion_getInstance3bisd6gjnm0oz,
  Companion_getInstance_17 as Companion_getInstance307sotgyzbnou,
  Companion_getInstance_58 as Companion_getInstancese711cjybj43,
  $serializer_getInstance_19 as $serializer_getInstance2hd22g62jocd3,
  Companion_getInstance_18 as Companion_getInstance124t3fbljdbyi,
  Companion_getInstance_19 as Companion_getInstance1z8if8hzu5ng5,
  $serializer_getInstance_21 as $serializer_getInstance2yxo5k0co7dg6,
  Companion_getInstance_20 as Companion_getInstance1b21bhtdgqkve,
  Companion_getInstance_21 as Companion_getInstance3r9dph6rgwho0,
  Companion_getInstance_22 as Companion_getInstance12ven2xbljkm0,
  Companion_getInstance_14 as Companion_getInstancefq4vwlyjorqo,
  Companion_getInstance_13 as Companion_getInstance2uur5hs3fk4e5,
  Companion_getInstance_23 as Companion_getInstanceh1cmko92158x,
  Companion_getInstance_55 as Companion_getInstance2yrqgx0jqnq3c,
  Companion_instance_12 as Companion_instancevwupp4fz0ehs,
  Companion_getInstance_25 as Companion_getInstancexfdqyjk2ykmw,
  Companion_getInstance_26 as Companion_getInstance12sgbyys5mml7,
  Companion_getInstance_27 as Companion_getInstancezuwazqbeik8p,
  Companion_getInstance_28 as Companion_getInstance1up45os1rj3ws,
  Companion_getInstance_29 as Companion_getInstance20myouriyv3u,
  Companion_getInstance_30 as Companion_getInstance1t0noik4ocb5x,
  Companion_getInstance_31 as Companion_getInstancee6k6ib2dkotb,
  $serializer_getInstance_16 as $serializer_getInstancer4f83meamevp,
  Companion_getInstance_15 as Companion_getInstancex3rnna8pnr6f,
  Companion_getInstance_32 as Companion_getInstance1moufct3sbct9,
  Companion_getInstance_35 as Companion_getInstance19tkudxb52ql0,
  Companion_getInstance_34 as Companion_getInstance1mn08iy8k7084,
  Companion_instance_21 as Companion_instance3cy7oygvo3vp5,
  Companion_getInstance_56 as Companion_getInstance20w8n5s732u9i,
  Companion_getInstance_60 as Companion_getInstance14au1t142dbyp,
  Companion_getInstance_36 as Companion_getInstance28gwov6pby7lz,
  Companion_getInstance_57 as Companion_getInstance1852qti57cam2,
  Companion_getInstance_37 as Companion_getInstance1h9pz6hxur4uj,
  Companion_getInstance_38 as Companion_getInstance39he8wfhznx8z,
  Companion_getInstance_39 as Companion_getInstance30idiynnpnbn2,
  Companion_getInstance_40 as Companion_getInstance14mfei2uzw3x6,
  $serializer_getInstance_43 as $serializer_getInstance28bv3p4ron8x8,
  Companion_getInstance_42 as Companion_getInstance1cdih9ztewhpv,
  Companion_instance_29 as Companion_instance1x10wxdaspp9d,
  Companion_getInstance_45 as Companion_getInstance2m617r7l2yg9j,
  Companion_getInstance_44 as Companion_getInstance3g7lwy1meor8x,
  Companion_getInstance_46 as Companion_getInstance1cc7a4v9g7e6l,
  Companion_getInstance_47 as Companion_getInstance3ar1by5trsbn7,
  Companion_getInstance_48 as Companion_getInstance3lubwpz5lc00p,
  Companion_getInstance_49 as Companion_getInstance2eaghgpohvp5v,
  $serializer_getInstance_50 as $serializer_getInstance3sf4q4nbunlsv,
  Companion_getInstance_50 as Companion_getInstanceha7z78i7nvow,
  Companion_instance_47 as Companion_instance3eje2t5q7hpt,
  Companion_getInstance_51 as Companion_getInstance11rxtahezlto7,
  Companion_instance_40 as Companion_instance2x6o1nijtl11,
  Companion_getInstance_53 as Companion_getInstance241hfcdeiz4z5,
  $serializer_getInstance_54 as $serializer_getInstance1vmv5e6k1823y,
  Companion_getInstance_54 as Companion_getInstance21u335vgn0mpe,
};
//endregion

//# sourceMappingURL=databaseModels.mjs.map
